/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * Hosting UAPI
 * Hosting UAPI is an API to expose Hosting, Addons, and Site functionality to a customer-facing Front End such as (Account Manager).
 * OpenAPI spec version: 0.1.0-unknown
 */
import { faker } from '@faker-js/faker';
import { delay, http, HttpResponse } from 'msw';

import {
  FilterAction,
  FilterRuleMatch,
  FilterRuleOpt,
  FilterRulePart,
} from './index.schemas';
import type {
  AccessLogs200,
  AccountAddonList200,
  AccountEventList200,
  AccountFeatures200,
  AccountHostingList200,
  AccountHostingListV2200,
  AccountPublicKey200,
  AccountPublicKeyCreate200,
  AccountPublicKeyDelete200,
  AccountPublicKeys200,
  AccountPublicKeyToggle200,
  AccountPurchaseHosting200,
  AccountPurchaseOrder200,
  AccountPurchaseProducts200,
  ActivityLog200,
  AddCron200,
  AddHostingRedirects200,
  AddIndex200,
  AddonsCloudflare200,
  AddonsCloudflareExternalNsCheck200,
  AddonsInfo200,
  AddonsJetpackValidate200,
  AddonsLlmBalance200,
  AddonsLlmKeys200,
  AddonsLlmKeysCreate200,
  AddonsLlmKeysDelete200,
  AddonsSitelockSso200,
  AddonsSitelockSsoV2200,
  AddonsSpamexpertsDomainAssign200,
  AddonsSpamexpertsSso200,
  AddonsSync200,
  AddonsWorkflows200,
  AddPrivacy200,
  AddSiteIpaddress200,
  AllUserMonarxDetails200,
  Announcements200,
  BackupCreateOndemandV1200,
  BackupCreateV2200,
  BackupCreateV3200,
  BackupCustomDeleteV1200,
  BackupDownloadV2200,
  BackupInitiate200,
  BackupList200,
  BackupListV2200,
  BackupListV3200,
  BackupMeta200,
  BackupPrefSetStatus200,
  BackupRestoreV2200,
  BackupRestoreV3200,
  BackupSettings200,
  BackupSettingsCreate200,
  BackupSettingsUpdate200,
  BackupsJetpackBackup200,
  BackupStatus200,
  BackupStatusV2200,
  BackupStatusV3200,
  BackupUsage200,
  BullhornAnnouncements200,
  CodeguardBackupCreate200,
  CodeguardBackupDownload200,
  CodeguardBackupList200,
  CodeguardBackupRestore200,
  CodeguardDatabaseBackupCreate200,
  CodeguardDatabaseBackupList200,
  CodeguardDatabaseBackupRestore200,
  CodeguardDatabaseList200,
  CodeguardLoginLink200,
  CodeguardPlanInfo200,
  CodeguardWebsiteBackupCreate200,
  CodeguardWebsiteBackupList200,
  CodeguardWebsiteBackupRestore200,
  CodeguardWebsiteList200,
  CreatePhpInfo200,
  Cron200,
  CronLastRun200,
  Db200,
  DbAdd200,
  DbCheckDatabase200,
  DbListV2200,
  DbMultipleUserDatabase200,
  DbUsage200,
  DbUserAdd200,
  DbUserDelete200,
  DbUserList200,
  DbUserPasswordSet200,
  DbUserPrivsGet200,
  DbUserPrivsSet200,
  DbUserRename200,
  DirectoryPrivacy200,
  DomainCertInstall200,
  DomainCerts200,
  DomainCertUninstall200,
  DomainCertUpdate200,
  DomainDnseditor200,
  DomainDnseditorAdd200,
  DomainDnseditorEdit200,
  DomainDnseditorList200,
  DomainDnsExport200,
  DomainDnsImport200,
  DomainDnszoneReset200,
  DomainEmailDeliverability200,
  DomainHealth200,
  DomainInfo200,
  DomainResourceRecords200,
  Domains200,
  DomainsEntriLastSuccess200,
  DomainsSetEntriUsed200,
  DomainsUnsetEntriUsed200,
  DomainUnassign200,
  DomainZoneeditorUrl200,
  EditPrivacy200,
  EmailSso200,
  EntriJwt200,
  ErrorPagesAdd200,
  ErrorPagesDelete200,
  ErrorPagesFetch200,
  HostingAccount200,
  HostingAddons200,
  HostingAdvancedConsole200,
  HostingAdvancedDns200,
  HostingAdvancedDnsUpdate200,
  HostingAdvancedDomainServices200,
  HostingAdvancedDomainServicesCheck200,
  HostingAdvancedImages200,
  HostingAdvancedPassword200,
  HostingAdvancedServer200,
  HostingAdvancedServerHealthcheck200,
  HostingAdvancedServerStatus200,
  HostingAdvancedServerV2200,
  HostingAdvancedSsoWhm200,
  HostingAdvancedSystemConsole200,
  HostingApplicationConfigResponse,
  HostingApplicationDeleteResponse,
  HostingApplicationDeploymentDetailResponse,
  HostingApplicationDeploymentHistoryResponse,
  HostingApplicationDeploymentLogsResponse,
  HostingApplicationHostnamesResponse,
  HostingApplicationListResponse,
  HostingApplicationOverviewResponse,
  HostingBackups200,
  HostingCapabilities200,
  HostingConfigMutationResponse,
  HostingDbAuthorizedHosts200,
  HostingDbAuthorizedHostsAdd200,
  HostingDbAuthorizedHostsDelete200,
  HostingDbAuthorizedHostsUpdate200,
  HostingDomainAssign200,
  HostingDomainAvailability200,
  HostingDomainsLink200,
  HostingDomainsUnassign200,
  HostingDomainsUnassignV2200,
  HostingDomainsV2200,
  HostingEcommerceInfo200,
  HostingEmailAdd200,
  HostingEmailAutoresponderCreate200,
  HostingEmailAutoresponderDelete200,
  HostingEmailAutoresponderInfo200,
  HostingEmailAutoresponderList200,
  HostingEmailAutoresponderUpdate200,
  HostingEmailDelete200,
  HostingEmailDomainRouting200,
  HostingEmailDomainRoutingSet200,
  HostingEmailFiltersAdd200,
  HostingEmailFiltersDelete200,
  HostingEmailFiltersList200,
  HostingEmailFiltersUpdate200,
  HostingEmailFolderList200,
  HostingEmailForwardDelete200,
  HostingEmailForwarderAdd200,
  HostingEmailForwardersList200,
  HostingEmailKeysAdd200,
  HostingEmailKeysList200,
  HostingEmailList200,
  HostingEmailSettings200,
  HostingEmailSetupInfo200,
  HostingEmailSpamCustomSettings200,
  HostingEmailSpamCustomSettingsUpdate200,
  HostingEmailSpamEmpty200,
  HostingEmailSpamSettings200,
  HostingEmailSpamSettingsUpdate200,
  HostingEmailTestSend200,
  HostingEmailUpdate200,
  HostingFixownership200,
  HostingFtp200,
  HostingFtpAdd200,
  HostingFtpList200,
  HostingFtpUpdate200,
  HostingInfo200,
  HostingInfoDiskUsage200,
  HostingLead200,
  HostingLicenseInfo200,
  HostingMigrationInfo200,
  HostingMigrations200,
  HostingMigrationsEvent200,
  HostingMigrationSiteScanStatus200,
  HostingMigrationStatus200,
  HostingMonarxAddonsList200,
  HostingNameservers200,
  HostingNameserversV2200,
  HostingOnboardingData200,
  HostingOnboardingDataUpdate200,
  HostingPasswordUpdate200,
  HostingRedeployResponse,
  HostingRedirect200,
  HostingRedirects200Item,
  HostingRedirectsV2200Item,
  HostingRepo200,
  HostingRepoList200Item,
  HostingRepoLog200,
  HostingRepoSync200,
  HostingResellerSsoWhm200,
  HostingRollbackResponse,
  HostingSendEmailSetupInfo200,
  HostingServerHits200,
  HostingShellInfo200,
  HostingShellToggle200,
  HostingSiteAdd200,
  HostingSiteAddV2200,
  HostingSiteAddV3200,
  HostingSitesV2200,
  HostingSpamexpertsEligibleDomains200,
  HostingSshInfo200,
  HostingVisitors200,
  HostingVpsSshKeySync200,
  HotlinkconfigAdd200,
  HotlinkconfigDelete200,
  HotlinkconfigDetails200,
  Index200,
  JetpackBackupStatus200,
  ListCrons200,
  ListFilesV2200,
  ListIndex200,
  MonarxAddonReportUrl200,
  MonarxAddonSealGeneration200,
  OnboardingGetStepsResponse,
  OnboardingSurveyResponse,
  PasswordGenerate200,
  PasswordScore200,
  PhpErrors200,
  Privacy200,
  PrivacyUser200,
  ProductLicenseDetails200,
  PublicImages200,
  PublicImagesV2200,
  PublicRegions200,
  RepairDatabase200,
  ResetSite200,
  Site200,
  SiteAddonCloudflare200,
  SiteAddonWpsolution200,
  SiteInfoResponseModelV2,
  SiteIpaddress200,
  SiteIpaddressList200Item,
  SiteMalwareStatus200,
  SiteMalwareStatusV2200,
  SitePendingDomainDelete200,
  SitePluginInstall200,
  SitePluginInstaller200,
  SitePlugins200,
  SitePluginsAutoupdate200,
  SitePluginsToggle200,
  SitePluginsUpdate200,
  SitePluginUpdate200,
  SiteQualityMetrics200,
  SitesAccessLogs200,
  SitesAtomicMetrics200,
  SitesAutoupdatesResponse,
  SitesBackups200,
  SitesBackupsCodeguard200,
  SitesBackupsDetails200,
  SitesBackupsXcitium200,
  SitesBatch200,
  SitesDatabaseInfo200,
  SitesDatabasePasswordsync200,
  SitesDns200,
  SitesDomain200,
  SitesDomainsCreate200,
  SitesDomainsV2200,
  SitesDomainUrl200,
  SitesErrorLogs200,
  SitesHasBackups200,
  SitesInfo200,
  SitesJetpackPurchase200,
  SitesListV2200,
  SitesListV3200,
  SitesMetricDimensions200,
  SitesMetricsDimensionAveraged200,
  SitesOnboardingSteps200,
  SitesPerformanceCachepurge200,
  SitesPerformanceEdgecache200,
  SitesPerformanceEnduranceCacheLevel200,
  SitesPerformanceEnduranceCacheLevelStatus200,
  SitesPerformanceEndurancePageCache200,
  SitesPerformanceRedisPurge200,
  SitesPerformanceRedisStatus200,
  SitesPerformanceRedisToggle200,
  SitesPerformanceRedisUninstall200,
  SitesPerformanceScans200,
  SitesPerformanceScansAdd200,
  SitesPerformanceScansList200,
  SitesSecurityBundle200,
  SitesSecurityCheckCore200,
  SitesSecurityHttpsEnableDisableSsl200,
  SitesSecurityHttpsRedirectionStatus200,
  SitesSecurityResetCoreFiles200,
  SitesSecuritySitelock200,
  SitesSecuritySitelockV2200,
  SitesSecuritySslAcme200,
  SitesSecuritySslStatus200,
  SitesSettingsComingSoon200,
  SitesSettingsComingSoonToggle200,
  SitesSettingsDebug200,
  SitesSettingsDebugToggle200,
  SitesSettingsPhpVersionInheritance200,
  SitesSettingsPhpVersions200,
  SitesSettingsPhpVersionUpdate200,
  SitesSshUserCreate200,
  SitesSshUserDelete200,
  SitesSshUserList200,
  SitesSshUserListV2200,
  SitesSshUserUpdate200,
  SitesSsl200,
  SitesSso200,
  SiteStatus200,
  SitesVersion200,
  SiteThemeInstall200,
  SiteUpdate200,
  SiteUsers200,
  SiteUsersV2200,
  SiteWpGenerate200,
  SshKey200,
  SshKeyFetch200,
  SshKeyGenerate200,
  SshKeyImport200,
  SshKeyImportV2200,
  SshKeyImportV3200,
  SshKeyList200,
  SshKeyListV2200,
  SshKeyListV3200,
  SshKeyListV4200,
  SshKeyV2200,
  Sso200,
  StagingSitePromote200,
  UpdateCron200,
  UpdateDomainResourceRecords200,
  UserBillingAccounts200,
  UserDomains200,
  UserHosting200,
  UserHostingOverview200,
  UserOnboarding200,
  UserPhoneSmsConsent200,
  UserPhoneSmsConsentUpdate200,
  UserProducts200,
  UserProservices200,
  UserServers200,
  UserSitesAi200,
  UserSpamexperts200,
  WaldaiSso200,
  WebzaiSso200,
  WeeblySso200,
  XcitiumBackupCreate200,
  XcitiumBackupDownload200,
  XcitiumBackupList200,
  XcitiumBackupRestore200,
  XcitiumPlanInfo200,
  XcitiumSso200,
} from './index.schemas';

export const getAccountEventListResponseMock = (
  overrideResponse: Partial<AccountEventList200> = {},
): AccountEventList200 => ({
  events: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      addon_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      count: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      date_first: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_last: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      event: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      hosting_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      tenant_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  utc: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAccountFeaturesResponseMock = (
  overrideResponse: Partial<AccountFeatures200> = {},
): AccountFeatures200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      autoRenewFlag: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      back_reference: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      expirationDate: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      feature_set: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      info: faker.helpers.arrayElement([
        {
          addon_back_ref: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          addon_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          addon_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          brand: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          brand_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          date_added: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          date_modified: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          homedir: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          ip: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          ns: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          os_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          platform: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          region: faker.helpers.arrayElement([
            {
              desc: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              name: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
            },
            undefined,
          ]),
          server_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          server_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          server_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          ssh_hostname: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          tenant_back_ref: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          tenant_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          username: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      limit: faker.helpers.arrayElement([
        {
          disk_limit_gib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      limit_remote: faker.helpers.arrayElement([
        {
          quota_kib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      package: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      panel: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prodCode: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prodName: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      used: faker.helpers.arrayElement([
        {
          disk_usage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          sites_active: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          staging_sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  total_count: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountHostingListResponseMock = (
  overrideResponse: Partial<AccountHostingList200> = {},
): AccountHostingList200 => ({
  accounts: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      billing_account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      current_sites: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      feature_set: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      hosting_addon_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      hosting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      max_sites: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      parent_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      platform: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      platform_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      prod_inst_id: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      region_desc: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      region_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      server_ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPublicKeysResponseMock = (
  overrideResponse: Partial<AccountPublicKeys200> = {},
): AccountPublicKeys200 => ({
  public_keys: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      date_modified: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      is_active: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      public_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPublicKeyCreateResponseMock = (
  overrideResponse: Partial<AccountPublicKeyCreate200> = {},
): AccountPublicKeyCreate200 => ({
  date_modified: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  is_active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  public_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAccountPublicKeyResponseMock = (
  overrideResponse: Partial<AccountPublicKey200> = {},
): AccountPublicKey200 => ({
  date_modified: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  is_active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  public_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAccountPublicKeyToggleResponseMock = (
  overrideResponse: Partial<AccountPublicKeyToggle200> = {},
): AccountPublicKeyToggle200 => ({
  job_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPublicKeyDeleteResponseMock = (
  overrideResponse: Partial<AccountPublicKeyDelete200> = {},
): AccountPublicKeyDelete200 => ({ ...overrideResponse });

export const getAccountAddonListResponseMock = (
  overrideResponse: Partial<AccountAddonList200> = {},
): AccountAddonList200 => ({
  addons: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      tenant_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  n_rows: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardBackupListResponseMock = (
  overrideResponse: Partial<CodeguardBackupList200> = {},
): CodeguardBackupList200 => ({
  backups: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      database_backups: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          commit_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          event_time: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          recommended: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        })),
        undefined,
      ]),
      event_time: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      website_commit_id: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardBackupCreateResponseMock = (
  overrideResponse: Partial<CodeguardBackupCreate200> = {},
): CodeguardBackupCreate200 => ({
  database_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  website_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardBackupDownloadResponseMock = (
  overrideResponse: Partial<CodeguardBackupDownload200> = {},
): CodeguardBackupDownload200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardBackupRestoreResponseMock = (
  overrideResponse: Partial<CodeguardBackupRestore200> = {},
): CodeguardBackupRestore200 => ({
  database_success: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  website_success: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardDatabaseListResponseMock = (
  overrideResponse: Partial<CodeguardDatabaseList200> = {},
): CodeguardDatabaseList200 => ({
  databases: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      database_backup: faker.helpers.arrayElement([
        {
          account: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          commit_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          website_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardDatabaseBackupListResponseMock = (
  overrideResponse: Partial<CodeguardDatabaseBackupList200> = {},
): CodeguardDatabaseBackupList200 => ({
  backups: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      commit_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      event_time: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardDatabaseBackupCreateResponseMock = (
  overrideResponse: Partial<CodeguardDatabaseBackupCreate200> = {},
): CodeguardDatabaseBackupCreate200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardDatabaseBackupRestoreResponseMock = (
  overrideResponse: Partial<CodeguardDatabaseBackupRestore200> = {},
): CodeguardDatabaseBackupRestore200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardLoginLinkResponseMock = (
  overrideResponse: Partial<CodeguardLoginLink200> = {},
): CodeguardLoginLink200 => ({
  link: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardPlanInfoResponseMock = (
  overrideResponse: Partial<CodeguardPlanInfo200> = {},
): CodeguardPlanInfo200 => ({
  back_reference: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  can_upgrade: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  disabled: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  over_quota: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  plan_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  seat_count: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  seat_limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  seats: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      database_activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      database_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      website_activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      website_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  size: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  size_limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardWebsiteListResponseMock = (
  overrideResponse: Partial<CodeguardWebsiteList200> = {},
): CodeguardWebsiteList200 => ({
  website_list: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      website: faker.helpers.arrayElement([
        {
          activated: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardWebsiteBackupListResponseMock = (
  overrideResponse: Partial<CodeguardWebsiteBackupList200> = {},
): CodeguardWebsiteBackupList200 => ({
  backups: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      commit_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      event_time: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      modifications: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      new_content: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCodeguardWebsiteBackupCreateResponseMock = (
  overrideResponse: Partial<CodeguardWebsiteBackupCreate200> = {},
): CodeguardWebsiteBackupCreate200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getCodeguardWebsiteBackupRestoreResponseMock = (
  overrideResponse: Partial<CodeguardWebsiteBackupRestore200> = {},
): CodeguardWebsiteBackupRestore200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAddonsSitelockSsoResponseMock = (
  overrideResponse: Partial<AddonsSitelockSso200> = {},
): AddonsSitelockSso200 => ({
  site_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  sitelock_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getXcitiumBackupListResponseMock = (
  overrideResponse: Partial<XcitiumBackupList200> = {},
): XcitiumBackupList200 => ({
  backups: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      backup_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      backup_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      end_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      files_added: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      files_deleted: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      files_modified: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      files_total: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      request_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      start_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      website_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getXcitiumBackupCreateResponseMock = (
  overrideResponse: Partial<XcitiumBackupCreate200> = {},
): XcitiumBackupCreate200 => ({
  database_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  website_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getXcitiumBackupDownloadResponseMock = (
  overrideResponse: Partial<XcitiumBackupDownload200> = {},
): XcitiumBackupDownload200 => ({
  database_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  website_success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getXcitiumBackupRestoreResponseMock = (
  overrideResponse: Partial<XcitiumBackupRestore200> = {},
): XcitiumBackupRestore200 => ({
  database_success: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  website_success: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getXcitiumPlanInfoResponseMock = (
  overrideResponse: Partial<XcitiumPlanInfo200> = {},
): XcitiumPlanInfo200 => ({
  activated: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  back_reference: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  can_upgrade: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  disabled: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  over_quota: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  plan_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  seat_count: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  seat_limit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  seats: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      cms_database_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      db_used_gib: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      dir_path: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      fs_used_gib: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      website_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  size: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  size_limit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getXcitiumSsoResponseMock = (
  overrideResponse: Partial<XcitiumSso200> = {},
): XcitiumSso200 => ({
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getBackupInitiateResponseMock = (
  overrideResponse: Partial<BackupInitiate200> = {},
): BackupInitiate200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  tracking_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupStatusResponseMock = (
  overrideResponse: Partial<BackupStatus200> = {},
): BackupStatus200 => ({
  download_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getBackupListResponseMock = (
  overrideResponse: Partial<BackupList200> = {},
): BackupList200 => ({
  home: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      backup_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      backup_status: faker.helpers.arrayElement([
        {
          download_url: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          tracking_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        },
        undefined,
      ]),
      time_created: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupMetaResponseMock = (
  overrideResponse: Partial<BackupMeta200> = {},
): BackupMeta200 => ({
  account: faker.helpers.arrayElement([
    {
      cbs_downloadables: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          time_req_completed: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          url: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
      cbs_event_processing: faker.helpers.arrayElement([
        {
          action: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          backup_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          client_tracking_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          internal_tracking_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          plan_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.helpers.arrayElement(['free', 'premium'] as const),
              null,
            ]),
            undefined,
          ]),
          site_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          snapshot_date: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      cbs_last_restore_timestamp: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  site: faker.helpers.arrayElement([
    {
      cbs_backup_delete_data: faker.helpers.arrayElement([
        {
          backups_deletion_status: faker.helpers.arrayElement([{}, undefined]),
          freed_space: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          plan_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.helpers.arrayElement(['free', 'premium'] as const),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      cbs_downloadables: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          backup_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          plan_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.helpers.arrayElement(['free', 'premium'] as const),
              null,
            ]),
            undefined,
          ]),
          snapshot_date: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          time_req_completed: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          tracking_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          url: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
      cbs_restore_consent_info: faker.helpers.arrayElement([
        {
          backup_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          current_state_backup_download_url: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          current_state_backup_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          internal_tracking_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          plan_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.helpers.arrayElement(['free', 'premium'] as const),
              null,
            ]),
            undefined,
          ]),
          restore_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      restored_from_backup_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupCreateOndemandV1ResponseMock = (
  overrideResponse: Partial<BackupCreateOndemandV1200> = {},
): BackupCreateOndemandV1200 => ({
  client_tracking_id: faker.word.sample(),
  ...overrideResponse,
});

export const getBackupCustomDeleteV1ResponseMock = (
  overrideResponse: Partial<BackupCustomDeleteV1200> = {},
): BackupCustomDeleteV1200 => ({
  client_tracking_id: faker.word.sample(),
  ...overrideResponse,
});

export const getBackupSettingsResponseMock = (
  overrideResponse: Partial<BackupSettings200> = {},
): BackupSettings200 => ({
  backup_scope_config: faker.helpers.arrayElement([{}, undefined]),
  backup_subscription_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  backup_time_local: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  frequency: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  next_run_at_utc: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  notifications: faker.helpers.arrayElement([
    {
      failed_backups: faker.helpers.arrayElement([1] as const),
      general_notifications: faker.helpers.arrayElement([1] as const),
      storage_limit: faker.helpers.arrayElement([1] as const),
      successful_backups: faker.helpers.arrayElement([1] as const),
    },
    undefined,
  ]),
  notify_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  notify_policy: faker.helpers.arrayElement([{}, undefined]),
  provider_resource_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  retention_days: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  schedule_day: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  timezone: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupSettingsCreateResponseMock = (
  overrideResponse: Partial<BackupSettingsCreate200> = {},
): BackupSettingsCreate200 => ({
  preference_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  site_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupSettingsUpdateResponseMock = (
  overrideResponse: Partial<BackupSettingsUpdate200> = {},
): BackupSettingsUpdate200 => ({
  site_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupPrefSetStatusResponseMock = (
  overrideResponse: Partial<BackupPrefSetStatus200> = {},
): BackupPrefSetStatus200 => ({
  site_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupUsageResponseMock = (
  overrideResponse: Partial<BackupUsage200> = {},
): BackupUsage200 => ({
  allowed_limit_bytes: faker.number.int({ min: undefined, max: undefined }),
  available_bytes: faker.number.int({ min: undefined, max: undefined }),
  used_bytes: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getAddonsCloudflareResponseMock = (
  overrideResponse: Partial<AddonsCloudflare200> = {},
): AddonsCloudflare200 => ({
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAddonsCloudflareExternalNsCheckResponseMock = (
  overrideResponse: Partial<AddonsCloudflareExternalNsCheck200> = {},
): AddonsCloudflareExternalNsCheck200 => ({
  base: faker.helpers.arrayElement([
    {
      detected_ips: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      matched: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  cdn_ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  domain_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  domain_ns: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  is_external: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  need_records: faker.helpers.arrayElement([
    {
      content: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  server_ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  server_ns: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  www: faker.helpers.arrayElement([
    {
      detected_ips: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      matched: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsInfoResponseMock = (
  overrideResponse: Partial<AddonsInfo200> = {},
): AddonsInfo200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsJetpackValidateResponseMock = (
  overrideResponse: Partial<AddonsJetpackValidate200> = {},
): AddonsJetpackValidate200 => ({
  is_connected: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsLlmBalanceResponseMock = (
  overrideResponse: Partial<AddonsLlmBalance200> = {},
): AddonsLlmBalance200 => ({
  credit_balance: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  credit_expires_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsLlmKeysResponseMock = (
  overrideResponse: Partial<AddonsLlmKeys200> = {},
): AddonsLlmKeys200 => ({
  inference_base_url: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  keys: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      created_at: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      key_alias: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      last_used_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  n_pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  n_rows: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsLlmKeysCreateResponseMock = (
  overrideResponse: Partial<AddonsLlmKeysCreate200> = {},
): AddonsLlmKeysCreate200 => ({
  inference_base_url: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  virtual_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAddonsLlmKeysDeleteResponseMock = (
  overrideResponse: Partial<AddonsLlmKeysDelete200> = {},
): AddonsLlmKeysDelete200 => ({ ...overrideResponse });

export const getMonarxAddonSealGenerationResponseMock = (
  overrideResponse: Partial<MonarxAddonSealGeneration200> = {},
): MonarxAddonSealGeneration200 => ({
  monarx_seal: faker.word.sample(),
  site_registration_id: faker.word.sample(),
  ...overrideResponse,
});

export const getMonarxAddonReportUrlResponseMock = (
  overrideResponse: Partial<MonarxAddonReportUrl200> = {},
): MonarxAddonReportUrl200 => ({
  report_url: faker.word.sample(),
  ...overrideResponse,
});

export const getAddonsSpamexpertsDomainAssignResponseMock = (
  overrideResponse: Partial<AddonsSpamexpertsDomainAssign200> = {},
): AddonsSpamexpertsDomainAssign200 => ({ ...overrideResponse });

export const getAddonsSpamexpertsSsoResponseMock = (
  overrideResponse: Partial<AddonsSpamexpertsSso200> = {},
): AddonsSpamexpertsSso200 => ({
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAddonsSyncResponseMock = (
  overrideResponse: Partial<AddonsSync200> = {},
): AddonsSync200 => ({
  previous_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getWebzaiSsoResponseMock = (
  overrideResponse: Partial<WebzaiSso200> = {},
): WebzaiSso200 => ({
  sso: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getWeeblySsoResponseMock = (
  overrideResponse: Partial<WeeblySso200> = {},
): WeeblySso200 => ({
  sso: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getAddonsWorkflowsResponseMock = (
  overrideResponse: Partial<AddonsWorkflows200> = {},
): AddonsWorkflows200 => ({
  workflows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      is_completed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      step: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      workflow_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAnnouncementsResponseMock = (
  overrideResponse: Partial<Announcements200> = {},
): Announcements200 => ({
  announcements: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    'cta-label': faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    'cta-redirect-url': faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    dismissible: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    heading: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    pageTargets: faker.helpers.arrayElement([
      Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1,
      ).map(() => faker.word.sample()),
      undefined,
    ]),
    severity: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        'NEUTRAL',
        'SUCCESS',
        'WARNING',
        'ERROR',
      ] as const),
      undefined,
    ]),
    'sub-heading': faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getBullhornAnnouncementsResponseMock = (
  overrideResponse: Partial<BullhornAnnouncements200> = {},
): BullhornAnnouncements200 => ({
  bullhornAnnouncements: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    body: faker.word.sample(),
    featureKey: faker.word.sample(),
    header: faker.word.sample(),
    url: faker.word.sample(),
  })),
  ...overrideResponse,
});

export const getDomainInfoResponseMock = (
  overrideResponse: Partial<DomainInfo200> = {},
): DomainInfo200 => ({
  account_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  authoritative: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  autogen_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  back_reference: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  base_domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  billing_account_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  billing_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  date_ssl_exp: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  dns_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  docroot: faker.helpers.arrayElement([faker.word.sample(), null]),
  domain: faker.word.sample(),
  homedir: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  hosting_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  id: faker.number.int({ min: undefined, max: undefined }),
  is_internal: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  jobs: faker.helpers.arrayElement([{}, undefined]),
  nameservers: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  platform: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  platform_type: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  product_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  setup_progress: faker.helpers.arrayElement([
    {
      validate_cdn: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      validate_cdn_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      validate_dns: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      validate_dns_auto_repair: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      validate_dns_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      validate_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      validate_ssl: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      validate_ssl_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      validate_ssl_error_table: faker.helpers.arrayElement([{}, undefined]),
    },
    undefined,
  ]),
  ssl_issuer: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssl_prod_inst_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssl_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssl_tier: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssl_type: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssl_upgradeable: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  third_party_dns: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  type: faker.word.sample(),
  used_entri: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainCertsResponseMock = (
  overrideResponse: Partial<DomainCerts200> = {},
): DomainCerts200 => ({
  certs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      cert_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      expires_on: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      issued_on: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainCertInstallResponseMock = (
  overrideResponse: Partial<DomainCertInstall200> = {},
): DomainCertInstall200 => ({ ...overrideResponse });

export const getDomainCertUpdateResponseMock = (
  overrideResponse: Partial<DomainCertUpdate200> = {},
): DomainCertUpdate200 => ({ ...overrideResponse });

export const getDomainCertUninstallResponseMock = (
  overrideResponse: Partial<DomainCertUninstall200> = {},
): DomainCertUninstall200 => ({ ...overrideResponse });

export const getDomainDnseditorResponseMock = (
  overrideResponse: Partial<DomainDnseditor200> = {},
): DomainDnseditor200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainDnseditorListResponseMock = (
  overrideResponse: Partial<DomainDnseditorList200> = {},
): DomainDnseditorList200 => ({
  dns_records: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      content: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      flag: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      port: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      preference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      priority: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      tag: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      target: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ttl: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      value: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      weight: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainDnseditorAddResponseMock = (
  overrideResponse: Partial<DomainDnseditorAdd200> = {},
): DomainDnseditorAdd200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainDnseditorEditResponseMock = (
  overrideResponse: Partial<DomainDnseditorEdit200> = {},
): DomainDnseditorEdit200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainDnszoneResetResponseMock = (
  overrideResponse: Partial<DomainDnszoneReset200> = {},
): DomainDnszoneReset200 => ({ ...overrideResponse });

export const getDomainEmailDeliverabilityResponseMock = (
  overrideResponse: Partial<DomainEmailDeliverability200> = {},
): DomainEmailDeliverability200 => ({
  a_record_check: faker.helpers.arrayElement([
    {
      a_match: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      box: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      detected: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      xns: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  dkim_check: faker.helpers.arrayElement([
    {
      dkim_record: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      private_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      pubkeys_match: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      record_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  mx_check: faker.helpers.arrayElement([
    {
      box_mx: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      mx_match: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      xns_mx: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  ptr_check: faker.helpers.arrayElement([
    {
      helo_hostname: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      ptr_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      ptr_value: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  spf_check: faker.helpers.arrayElement([
    {
      box_spf: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      spf_match: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      xns_spf: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getDomainsEntriLastSuccessResponseMock = (
  overrideResponse: Partial<DomainsEntriLastSuccess200> = {},
): DomainsEntriLastSuccess200 => ({
  last_success_at: faker.word.sample(),
  ...overrideResponse,
});

export const getDomainsSetEntriUsedResponseMock = (
  overrideResponse: Partial<DomainsSetEntriUsed200> = {},
): DomainsSetEntriUsed200 => ({ ...overrideResponse });

export const getDomainsUnsetEntriUsedResponseMock = (
  overrideResponse: Partial<DomainsUnsetEntriUsed200> = {},
): DomainsUnsetEntriUsed200 => ({ ...overrideResponse });

export const getDomainHealthResponseMock = (
  overrideResponse: Partial<DomainHealth200> = {},
): DomainHealth200 => ({
  alignment_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  cache: faker.helpers.arrayElement([
    {
      cached_at: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      expires_at: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      hit: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      stale: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  checks: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      cname_target: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      expected: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      explanation: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      hostname: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      layers_agree: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      observed: faker.helpers.arrayElement([
        {
          cpanel: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          hosting_zone: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          internal_dns: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          public: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          public_dns: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          registrar: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          xns: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
        },
        undefined,
      ]),
      reason: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      record_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      severity: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      support_category: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  context: faker.helpers.arrayElement([
    {
      account_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      back_reference: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      parent_zone_domain: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      pending_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      site_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      url_is_provisional: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    },
    undefined,
  ]),
  email: faker.helpers.arrayElement([
    {
      checked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      checks: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          label: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          severity: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        })),
        undefined,
      ]),
      email_deliverability: faker.helpers.arrayElement([
        {
          a_record_check: faker.helpers.arrayElement([
            {
              a_match: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined,
              ]),
              box: faker.helpers.arrayElement([faker.word.sample(), undefined]),
              detected: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              xns: faker.helpers.arrayElement([faker.word.sample(), undefined]),
            },
            undefined,
          ]),
          dkim_check: faker.helpers.arrayElement([
            {
              dkim_record: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              pubkeys_match: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined,
              ]),
              record_name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              record_pubkey: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              server_pubkey: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
            },
            undefined,
          ]),
          mx_check: faker.helpers.arrayElement([
            {
              box_mx: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              mx_match: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined,
              ]),
              xns_mx: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
            },
            undefined,
          ]),
          ptr_check: faker.helpers.arrayElement([
            {
              helo_hostname: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              ptr_name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              ptr_value: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
            },
            undefined,
          ]),
          spf_check: faker.helpers.arrayElement([
            {
              box_spf: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              record_name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              spf_match: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined,
              ]),
              xns_spf: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
            },
            undefined,
          ]),
          success: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
      primary_issue_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      propagation_related: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      severity: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      skip_reason: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      skipped: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      success: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    },
    undefined,
  ]),
  execution_ms: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  expected_source_order: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  layers: faker.helpers.arrayElement([
    {
      labels: faker.helpers.arrayElement([{}, undefined]),
      order: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
    },
    undefined,
  ]),
  primary_issue_code: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  schema_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  severity: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  site: faker.helpers.arrayElement([
    {
      alignment_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      checked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      checks: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          expected: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          layer: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          observed: faker.helpers.arrayElement([{}, undefined]),
          reason: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          severity: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          suggested_fix: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          support_category: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
        })),
        undefined,
      ]),
      context: faker.helpers.arrayElement([
        {
          account_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          docpath: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          docroot: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          domain_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          domain_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          pending_url: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          pending_url_error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          pending_url_stage: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          requested_site_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          site_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          site_status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          site_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          url_is_provisional: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
      primary_issue_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      severity: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      skip_reason: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      skipped: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      success: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    },
    undefined,
  ]),
  source_timings: faker.helpers.arrayElement([
    {
      deliverability: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      dns_status: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      zone_box: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      zone_registrar: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      zone_xns: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  sources: faker.helpers.arrayElement([
    {
      deliverability: faker.helpers.arrayElement([{}, undefined]),
      dns_status: faker.helpers.arrayElement([{}, undefined]),
      zone_box: faker.helpers.arrayElement([{}, undefined]),
      zone_registrar: faker.helpers.arrayElement([{}, undefined]),
      zone_xns: faker.helpers.arrayElement([{}, undefined]),
    },
    undefined,
  ]),
  ssl: faker.helpers.arrayElement([
    {
      alignment_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      certificate: faker.helpers.arrayElement([
        {
          issuer: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          not_after: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          present: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          ssl_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      checked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      checks: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          hostname: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          observed: faker.helpers.arrayElement([
            {
              http_status: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              not_after: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
            },
            undefined,
          ]),
          severity: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        })),
        undefined,
      ]),
      primary_issue_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      severity: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      skip_reason: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      skipped: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccessLogsResponseMock = (
  overrideResponse: Partial<AccessLogs200> = {},
): AccessLogs200 => ({
  logs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      device: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      host: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      request: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      response_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      response_size: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDomainResourceRecordsResponseMock = (
  overrideResponse: Partial<DomainResourceRecords200> = {},
): DomainResourceRecords200 => ({
  dns_prod_inst_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  resource_records: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      associated_prod_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      cname: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      dname: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ename: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      host_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ip_address: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      port: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      preference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      priority: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      rdata: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      target: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      text: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ttl: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      weight: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUpdateDomainResourceRecordsResponseMock =
  (): UpdateDomainResourceRecords200 => ({});

export const getDomainUnassignResponseMock = (
  overrideResponse: Partial<DomainUnassign200> = {},
): DomainUnassign200 => ({ ...overrideResponse });

export const getDomainZoneeditorUrlResponseMock = (
  overrideResponse: Partial<DomainZoneeditorUrl200> = {},
): DomainZoneeditorUrl200 => ({
  url: faker.word.sample(),
  ...overrideResponse,
});

export const getEntriJwtResponseMock = (
  overrideResponse: Partial<EntriJwt200> = {},
): EntriJwt200 => ({ token: faker.word.sample(), ...overrideResponse });

export const getHostingAccountResponseMock = (
  overrideResponse: Partial<HostingAccount200> = {},
): HostingAccount200 => ({
  account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  account_limits: faker.helpers.arrayElement([
    {
      email_accounts: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      max_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  addon_date_added: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  advanced: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  billing: faker.helpers.arrayElement([
    {
      prod_code: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      product_name: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      subbrand: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  brand: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  panel: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  plan_key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  platform: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  resources: faker.helpers.arrayElement([
    {
      staging: faker.helpers.arrayElement([
        {
          storage: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              unit: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
        },
        undefined,
      ]),
      storage: faker.helpers.arrayElement([
        {
          available: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          site_quota: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          total: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          unit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          used: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      used: faker.helpers.arrayElement([
        {
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      workers: faker.helpers.arrayElement([
        {
          available: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          total: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          used: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    },
    undefined,
  ]),
  server_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ssh_hostname: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  username: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getActivityLogResponseMock = (
  overrideResponse: Partial<ActivityLog200> = {},
): ActivityLog200 => ({
  activity: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      data: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_entry: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      event: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      site_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      tenant_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAddonsResponseMock = (
  overrideResponse: Partial<HostingAddons200> = {},
): HostingAddons200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      meta: faker.helpers.arrayElement([
        {
          [faker.string.alphanumeric(5)]: faker.helpers.arrayElement([
            faker.word.sample(),
            faker.number.int({ min: undefined, max: undefined }),
            faker.datatype.boolean(),
          ]),
        },
        undefined,
      ]),
      ssh_hostname: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status_user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedConsoleResponseMock = (
  overrideResponse: Partial<HostingAdvancedConsole200> = {},
): HostingAdvancedConsole200 => ({
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingAdvancedDnsResponseMock = (
  overrideResponse: Partial<HostingAdvancedDns200> = {},
): HostingAdvancedDns200 => ({
  dns: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      content: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      ttl: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedDnsUpdateResponseMock = (
  overrideResponse: Partial<HostingAdvancedDnsUpdate200> = {},
): HostingAdvancedDnsUpdate200 => ({ ...overrideResponse });

export const getHostingAdvancedDomainServicesCheckResponseMock = (
  overrideResponse: Partial<HostingAdvancedDomainServicesCheck200> = {},
): HostingAdvancedDomainServicesCheck200 => ({
  configure_domain_services: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  managed_cpanel_user_exists: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedDomainServicesResponseMock = (
  overrideResponse: Partial<HostingAdvancedDomainServices200> = {},
): HostingAdvancedDomainServices200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedImagesResponseMock = (
  overrideResponse: Partial<HostingAdvancedImages200> = {},
): HostingAdvancedImages200 => ({
  images: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    ai_key_enabled: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    app: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    arch_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    cpanel_default: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    current: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    description: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    docker_default: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    links: faker.helpers.arrayElement([
      {
        community: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        doc: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        forums: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
      },
      undefined,
    ]),
    lts: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    manage_link: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    min_cpus: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    min_disk: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    min_ram: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    os_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    os_version: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    readme: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    resource_compatible: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    software: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    title: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    user_image: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getHostingAdvancedServerResponseMock = (
  overrideResponse: Partial<HostingAdvancedServer200> = {},
): HostingAdvancedServer200 => ({
  actions: faker.helpers.arrayElement([{}, undefined]),
  hostname: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ips: faker.helpers.arrayElement([
    {
      other_ips: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      primary_ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  os_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  os_version: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime_seconds: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedServerStatusResponseMock = (
  overrideResponse: Partial<HostingAdvancedServerStatus200> = {},
): HostingAdvancedServerStatus200 => ({
  actions: faker.helpers.arrayElement([{}, undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime_seconds: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedServerHealthcheckResponseMock = (
  overrideResponse: Partial<HostingAdvancedServerHealthcheck200> = {},
): HostingAdvancedServerHealthcheck200 => ({
  addon_q_job: faker.helpers.arrayElement([
    {
      remaining: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      tries: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  addon_reason: faker.word.sample(),
  addon_status: faker.word.sample(),
  panel_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  reason: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  server_hello: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  server_q_job: faker.helpers.arrayElement([
    {
      remaining: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      tries: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  server_reason: faker.word.sample(),
  server_status: faker.word.sample(),
  ...overrideResponse,
});

export const getHostingAdvancedPasswordResponseMock = (
  overrideResponse: Partial<HostingAdvancedPassword200> = {},
): HostingAdvancedPassword200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingAdvancedSsoWhmResponseMock = (
  overrideResponse: Partial<HostingAdvancedSsoWhm200> = {},
): HostingAdvancedSsoWhm200 => ({
  ssl_setup: faker.helpers.arrayElement([
    {
      dns_updated: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      dns_zone_with_us: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      required: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      server_hostname: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingAdvancedSystemConsoleResponseMock = (
  overrideResponse: Partial<HostingAdvancedSystemConsole200> = {},
): HostingAdvancedSystemConsole200 => ({
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingApplicationsListResponseMock = (
  overrideResponse: Partial<HostingApplicationListResponse> = {},
): HostingApplicationListResponse => ({
  applications: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    active_deployment_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    application_id: faker.word.sample(),
    config_incomplete: faker.datatype.boolean(),
    name: faker.word.sample(),
    recipe_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    recipe_version: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          'accepted',
          'staging',
          'health_check',
          'active',
          'rolling_back',
          'rolled_back',
          'terminal_failure',
        ] as const),
        null,
      ]),
      undefined,
    ]),
    url: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  count: faker.number.int({ min: undefined, max: undefined }),
  hosting_id: faker.word.sample(),
  summary: {
    applications: faker.number.int({ min: undefined, max: undefined }),
    healthy: faker.number.int({ min: undefined, max: undefined }),
    needs_attention: faker.number.int({ min: undefined, max: undefined }),
  },
  target_id: faker.word.sample(),
  ...overrideResponse,
});

export const getHostingApplicationGetResponseMock = (
  overrideResponse: Partial<HostingApplicationOverviewResponse> = {},
): HostingApplicationOverviewResponse => ({
  actions: {
    block_reason: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          'deployment_in_flight',
          'config_incomplete',
          'no_deployment',
          'no_rollback_target',
        ] as const),
        null,
      ]),
      undefined,
    ]),
    redeploy_enabled: faker.datatype.boolean(),
    rollback_enabled: faker.datatype.boolean(),
  },
  active_deployment: faker.helpers.arrayElement([
    {
      artifact_digest: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      correlation_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      created_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      deployed_by: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      deployment_id: faker.word.sample(),
      recipe_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      recipe_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      updated_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  application_id: faker.word.sample(),
  banner: faker.helpers.arrayElement([
    {
      candidate_deployment_id: faker.word.sample(),
      kind: faker.helpers.arrayElement([
        'deployment_in_flight',
        'rollback_in_progress',
        'terminal_failure',
      ] as const),
      live_deployment_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      message: faker.word.sample(),
      tone: faker.helpers.arrayElement(['info', 'danger'] as const),
    },
    undefined,
  ]),
  config_summary: {
    action_needed: faker.datatype.boolean(),
    all_set: faker.datatype.boolean(),
    deploys_blocked: faker.datatype.boolean(),
    deploys_blocked_message: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    missing: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    secrets_set: faker.number.int({ min: undefined, max: undefined }),
    secrets_total: faker.number.int({ min: undefined, max: undefined }),
    variables_count: faker.number.int({ min: undefined, max: undefined }),
  },
  environment: faker.word.sample(),
  health: faker.helpers.arrayElement([
    {
      correlation_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      health: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      instruction_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      reported_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sequence: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      state: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  hosting_id: faker.word.sample(),
  hostnames: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  latest_deployment: faker.helpers.arrayElement([
    {
      created_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      deployment_id: faker.word.sample(),
      status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  name: faker.word.sample(),
  ssl: {
    expires_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    status: faker.helpers.arrayElement(['active', 'unknown', 'none'] as const),
  },
  target_id: faker.word.sample(),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingApplicationDeleteResponseMock = (
  overrideResponse: Partial<HostingApplicationDeleteResponse> = {},
): HostingApplicationDeleteResponse => ({
  agent_instruction_ids: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  application_id: faker.word.sample(),
  config_purged: faker.datatype.boolean(),
  hosting_id: faker.word.sample(),
  purged_deployment_ids: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  target_id: faker.word.sample(),
  ...overrideResponse,
});

export const getHostingApplicationConfigGetResponseMock = (
  overrideResponse: Partial<HostingApplicationConfigResponse> = {},
): HostingApplicationConfigResponse => ({
  all_set: faker.datatype.boolean(),
  application_id: faker.word.sample(),
  config_digest: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  config_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  deploys_blocked: faker.datatype.boolean(),
  deploys_blocked_message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  environment: faker.word.sample(),
  hosting_id: faker.word.sample(),
  missing: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  secrets: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    action: faker.helpers.arrayElement(['replace', 'set_value'] as const),
    description: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hint: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    kind: faker.helpers.arrayElement(['secret'] as const),
    name: faker.word.sample(),
    required: faker.datatype.boolean(),
    status: faker.helpers.arrayElement(['set', 'missing'] as const),
    updated_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  variables: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    action: faker.helpers.arrayElement(['edit', 'set_value'] as const),
    kind: faker.helpers.arrayElement(['plain'] as const),
    name: faker.word.sample(),
    status: faker.helpers.arrayElement(['set', 'missing'] as const),
    updated_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    value: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getHostingApplicationConfigSetResponseMock = (
  overrideResponse: Partial<HostingConfigMutationResponse> = {},
): HostingConfigMutationResponse => ({
  config_digest: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  config_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingApplicationConfigDeleteResponseMock = (
  overrideResponse: Partial<HostingConfigMutationResponse> = {},
): HostingConfigMutationResponse => ({
  config_digest: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  config_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingApplicationDeploymentsListResponseMock = (
  overrideResponse: Partial<HostingApplicationDeploymentHistoryResponse> = {},
): HostingApplicationDeploymentHistoryResponse => ({
  actions: {
    block_reason: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          'deployment_in_flight',
          'config_incomplete',
          'no_deployment',
          'no_rollback_target',
        ] as const),
        null,
      ]),
      undefined,
    ]),
    redeploy_enabled: faker.datatype.boolean(),
    rollback_enabled: faker.datatype.boolean(),
  },
  application_id: faker.word.sample(),
  count: faker.number.int({ min: undefined, max: undefined }),
  deployments: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    artifact_digest: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    correlation_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    created_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    deployment_id: faker.word.sample(),
    is_live: faker.datatype.boolean(),
    is_rollback_eligible: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    recipe_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    recipe_version: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    updated_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  deploys_blocked: faker.datatype.boolean(),
  deploys_blocked_message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  hosting_id: faker.word.sample(),
  missing: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  ...overrideResponse,
});

export const getHostingApplicationRedeployResponseMock = (
  overrideResponse: Partial<HostingRedeployResponse> = {},
): HostingRedeployResponse => ({
  application_id: faker.word.sample(),
  build_id: faker.word.sample(),
  correlation_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  deployment_id: faker.word.sample(),
  source_deployment_id: faker.word.sample(),
  status: faker.helpers.arrayElement(['queued'] as const),
  ...overrideResponse,
});

export const getHostingApplicationDeploymentGetResponseMock = (
  overrideResponse: Partial<HostingApplicationDeploymentDetailResponse> = {},
): HostingApplicationDeploymentDetailResponse => ({
  application_id: faker.word.sample(),
  artifact_digest: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  correlation_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  created_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  deployment_id: faker.word.sample(),
  failure: faker.helpers.arrayElement([
    {
      live_deployment_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      message: faker.word.sample(),
      reason: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  health: faker.helpers.arrayElement([
    {
      correlation_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      health: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      instruction_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      reported_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sequence: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      state: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  history: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    created_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    from_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    reason: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    to_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  hosting_id: faker.word.sample(),
  is_live: faker.datatype.boolean(),
  live_deployment_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  recipe_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  recipe_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  stage_message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  state_machine_position: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  stepper: {
    current: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    failed_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    stages: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
  },
  updated_at: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingApplicationDeploymentLogsGetResponseMock = (
  overrideResponse: Partial<HostingApplicationDeploymentLogsResponse> = {},
): HostingApplicationDeploymentLogsResponse => ({
  application_id: faker.word.sample(),
  cursor: faker.number.int({ min: undefined, max: undefined }),
  deployment_id: faker.word.sample(),
  deployment_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  hosting_id: faker.word.sample(),
  next_cursor: faker.number.int({ min: undefined, max: undefined }),
  segments: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    content: faker.word.sample(),
    correlation_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    cursor: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    emitted_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    next_cursor: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
  })),
  settled: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getHostingApplicationDeploymentRollbackResponseMock = (
  overrideResponse: Partial<HostingRollbackResponse> = {},
): HostingRollbackResponse => ({
  correlation_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  deployment_id: faker.word.sample(),
  from_deployment_id: faker.word.sample(),
  instruction_id: faker.word.sample(),
  status: faker.helpers.arrayElement(['queued', 'duplicate'] as const),
  to_deployment_id: faker.word.sample(),
  ...overrideResponse,
});

export const getHostingApplicationHostnamesPutResponseMock = (
  overrideResponse: Partial<HostingApplicationHostnamesResponse> = {},
): HostingApplicationHostnamesResponse => ({
  application_id: faker.word.sample(),
  hosting_id: faker.word.sample(),
  hostnames: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingBackupsResponseMock = (
  overrideResponse: Partial<HostingBackups200> = {},
): HostingBackups200 => ({
  codeguard: faker.helpers.arrayElement([
    {
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  jetpack: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  xcitium: faker.helpers.arrayElement([
    {
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingCapabilitiesResponseMock = (
  overrideResponse: Partial<HostingCapabilities200> = {},
): HostingCapabilities200 => ({
  advanced_hosting: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  cpanel: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  is_sitelock_migrated: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  reset_password: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  server_controls: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  sites: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  whm: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getListCronsResponseMock = (
  overrideResponse: Partial<ListCrons200> = {},
): ListCrons200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      command: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      day: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      email: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      hour: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      key: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      line: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      minute: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      month: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      weekday: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddCronResponseMock = (
  overrideResponse: Partial<AddCron200> = {},
): AddCron200 => ({
  key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getUpdateCronResponseMock = (
  overrideResponse: Partial<UpdateCron200> = {},
): UpdateCron200 => ({
  key: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getCronResponseMock = (
  overrideResponse: Partial<Cron200> = {},
): Cron200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getCronLastRunResponseMock = (
  overrideResponse: Partial<CronLastRun200> = {},
): CronLastRun200 => ({
  last_run: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbAddResponseMock = (
  overrideResponse: Partial<DbAdd200> = {},
): DbAdd200 => ({
  dbname: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getDbResponseMock = (
  overrideResponse: Partial<Db200> = {},
): Db200 => ({
  dbname: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingDbAuthorizedHostsResponseMock = (
  overrideResponse: Partial<HostingDbAuthorizedHosts200> = {},
): HostingDbAuthorizedHosts200 => ({
  remote_ips: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      host: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      label: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDbAuthorizedHostsAddResponseMock = (
  overrideResponse: Partial<HostingDbAuthorizedHostsAdd200> = {},
): HostingDbAuthorizedHostsAdd200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDbAuthorizedHostsUpdateResponseMock = (
  overrideResponse: Partial<HostingDbAuthorizedHostsUpdate200> = {},
): HostingDbAuthorizedHostsUpdate200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDbAuthorizedHostsDeleteResponseMock = (
  overrideResponse: Partial<HostingDbAuthorizedHostsDelete200> = {},
): HostingDbAuthorizedHostsDelete200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbCheckDatabaseResponseMock = (
  overrideResponse: Partial<DbCheckDatabase200> = {},
): DbCheckDatabase200 => ({
  tables: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      table: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getRepairDatabaseResponseMock = (
  overrideResponse: Partial<RepairDatabase200> = {},
): RepairDatabase200 => ({
  tables: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      table: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbUsageResponseMock = (
  overrideResponse: Partial<DbUsage200> = {},
): DbUsage200 => ({
  db_count: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  db_limit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbUserPasswordSetResponseMock = (
  overrideResponse: Partial<DbUserPasswordSet200> = {},
): DbUserPasswordSet200 => ({
  dbuser: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getDbUserPrivsGetResponseMock = (
  overrideResponse: Partial<DbUserPrivsGet200> = {},
): DbUserPrivsGet200 => ({
  privileges: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbUserPrivsSetResponseMock = (
  overrideResponse: Partial<DbUserPrivsSet200> = {},
): DbUserPrivsSet200 => ({
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbUserAddResponseMock = (
  overrideResponse: Partial<DbUserAdd200> = {},
): DbUserAdd200 => ({
  password: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  username: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getDbUserDeleteResponseMock = (
  overrideResponse: Partial<DbUserDelete200> = {},
): DbUserDelete200 => ({
  dbuser: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getDbUserListResponseMock = (
  overrideResponse: Partial<DbUserList200> = {},
): DbUserList200 => ({
  users: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      dblist: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      shortuser: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbUserRenameResponseMock = (
  overrideResponse: Partial<DbUserRename200> = {},
): DbUserRename200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbMultipleUserDatabaseResponseMock = (
  overrideResponse: Partial<DbMultipleUserDatabase200> = {},
): DbMultipleUserDatabase200 => ({ ...overrideResponse });

export const getDirectoryPrivacyResponseMock = (
  overrideResponse: Partial<DirectoryPrivacy200> = {},
): DirectoryPrivacy200 => ({
  directory: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      directory_path: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      directory_users: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddPrivacyResponseMock = (
  overrideResponse: Partial<AddPrivacy200> = {},
): AddPrivacy200 => ({
  file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getPrivacyResponseMock = (
  overrideResponse: Partial<Privacy200> = {},
): Privacy200 => ({
  file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getEditPrivacyResponseMock = (
  overrideResponse: Partial<EditPrivacy200> = {},
): EditPrivacy200 => ({
  file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getPrivacyUserResponseMock = (
  overrideResponse: Partial<PrivacyUser200> = {},
): PrivacyUser200 => ({
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDomainAssignResponseMock = (
  overrideResponse: Partial<HostingDomainAssign200> = {},
): HostingDomainAssign200 => ({ ...overrideResponse });

export const getHostingDomainAvailabilityResponseMock = (
  overrideResponse: Partial<HostingDomainAvailability200> = {},
): HostingDomainAvailability200 => ({
  assignable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  assigned: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  assigned_to_this_product: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  can_assign: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  registered: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getDomainsResponseMock = (
  overrideResponse: Partial<Domains200> = {},
): Domains200 => ({
  domains: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    autogen_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    date_ssl_exp: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    docroot: faker.word.sample(),
    domain: faker.word.sample(),
    id: faker.number.int({ min: undefined, max: undefined }),
    ssl_issuer: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    type: faker.word.sample(),
  })),
  ...overrideResponse,
});

export const getDomainDnsExportResponseMock = (
  overrideResponse: Partial<DomainDnsExport200> = {},
): DomainDnsExport200 => ({
  content: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getDomainDnsImportResponseMock = (
  overrideResponse: Partial<DomainDnsImport200> = {},
): DomainDnsImport200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingDomainsLinkResponseMock = (
  overrideResponse: Partial<HostingDomainsLink200> = {},
): HostingDomainsLink200 => ({
  already_created: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  id: faker.number.int({ min: undefined, max: undefined }),
  status: faker.word.sample(),
  ...overrideResponse,
});

export const getHostingDomainsUnassignResponseMock = (
  overrideResponse: Partial<HostingDomainsUnassign200> = {},
): HostingDomainsUnassign200 => ({
  queued: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEcommerceInfoResponseMock = (
  overrideResponse: Partial<HostingEcommerceInfo200> = {},
): HostingEcommerceInfo200 => ({
  addon_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  back_ref: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  level: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  subtype: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailAddResponseMock = (
  overrideResponse: Partial<HostingEmailAdd200> = {},
): HostingEmailAdd200 => ({
  address: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailDeleteResponseMock = (
  overrideResponse: Partial<HostingEmailDelete200> = {},
): HostingEmailDelete200 => ({ ...overrideResponse });

export const getHostingEmailListResponseMock = (
  overrideResponse: Partial<HostingEmailList200> = {},
): HostingEmailList200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      address: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      autofolders: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      box_suspensions: faker.helpers.arrayElement([
        {
          incoming: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          login: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          outgoing: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          outgoing_hold: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
      disk_limit_mib: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      disk_used_mib: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      disk_used_percent: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      files: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      system_suspensions: faker.helpers.arrayElement([
        {
          receive: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          relay: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          sendmail: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      utf8_folders: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailUpdateResponseMock = (
  overrideResponse: Partial<HostingEmailUpdate200> = {},
): HostingEmailUpdate200 => ({ ...overrideResponse });

export const getHostingEmailAutoresponderInfoResponseMock = (
  overrideResponse: Partial<HostingEmailAutoresponderInfo200> = {},
): HostingEmailAutoresponderInfo200 => ({
  autoresponder: faker.helpers.arrayElement([
    {
      body: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      charset: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      email: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      from: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      interval: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      is_html: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      start: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      stop: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      subject: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailAutoresponderUpdateResponseMock = (
  overrideResponse: Partial<HostingEmailAutoresponderUpdate200> = {},
): HostingEmailAutoresponderUpdate200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailAutoresponderCreateResponseMock = (
  overrideResponse: Partial<HostingEmailAutoresponderCreate200> = {},
): HostingEmailAutoresponderCreate200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailAutoresponderDeleteResponseMock = (
  overrideResponse: Partial<HostingEmailAutoresponderDelete200> = {},
): HostingEmailAutoresponderDelete200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailAutoresponderListResponseMock = (
  overrideResponse: Partial<HostingEmailAutoresponderList200> = {},
): HostingEmailAutoresponderList200 => ({
  autoresponders: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      email: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      subject: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailFiltersListResponseMock = (
  overrideResponse: Partial<HostingEmailFiltersList200> = {},
): HostingEmailFiltersList200 => ({
  count: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  filters: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      actions: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          action: faker.helpers.arrayElement([
            faker.helpers.arrayElement(Object.values(FilterAction)),
            undefined,
          ]),
          dest: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
      enabled: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      rules: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          match: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.helpers.arrayElement(Object.values(FilterRuleMatch)),
              null,
            ]),
            undefined,
          ]),
          opt: faker.helpers.arrayElement([
            faker.helpers.arrayElement(Object.values(FilterRuleOpt)),
            undefined,
          ]),
          part: faker.helpers.arrayElement([
            faker.helpers.arrayElement(Object.values(FilterRulePart)),
            undefined,
          ]),
          val: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
      unescaped: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailFiltersAddResponseMock = (
  overrideResponse: Partial<HostingEmailFiltersAdd200> = {},
): HostingEmailFiltersAdd200 => ({ ...overrideResponse });

export const getHostingEmailFiltersUpdateResponseMock = (
  overrideResponse: Partial<HostingEmailFiltersUpdate200> = {},
): HostingEmailFiltersUpdate200 => ({ ...overrideResponse });

export const getHostingEmailFiltersDeleteResponseMock = (
  overrideResponse: Partial<HostingEmailFiltersDelete200> = {},
): HostingEmailFiltersDelete200 => ({ ...overrideResponse });

export const getHostingEmailForwardersListResponseMock = (
  overrideResponse: Partial<HostingEmailForwardersList200> = {},
): HostingEmailForwardersList200 => ({
  forwarders: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      destination: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      destination_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      source: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailForwarderAddResponseMock = (
  overrideResponse: Partial<HostingEmailForwarderAdd200> = {},
): HostingEmailForwarderAdd200 => ({ ...overrideResponse });

export const getHostingEmailForwardDeleteResponseMock = (
  overrideResponse: Partial<HostingEmailForwardDelete200> = {},
): HostingEmailForwardDelete200 => ({ ...overrideResponse });

export const getHostingEmailKeysAddResponseMock = (
  overrideResponse: Partial<HostingEmailKeysAdd200> = {},
): HostingEmailKeysAdd200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailKeysListResponseMock = (
  overrideResponse: Partial<HostingEmailKeysList200> = {},
): HostingEmailKeysList200 => ({
  keys: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      algo: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      created: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      email: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      expires: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      keyid: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      keysize: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      uids: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailDomainRoutingResponseMock = (
  overrideResponse: Partial<HostingEmailDomainRouting200> = {},
): HostingEmailDomainRouting200 => ({
  domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  route_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailDomainRoutingSetResponseMock = (
  overrideResponse: Partial<HostingEmailDomainRoutingSet200> = {},
): HostingEmailDomainRoutingSet200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingEmailSettingsResponseMock = (
  overrideResponse: Partial<HostingEmailSettings200> = {},
): HostingEmailSettings200 => ({
  account_incoming: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  account_login: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  account_outgoing: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  address: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  autofolders: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  utf8_folders: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailSpamCustomSettingsResponseMock = (
  overrideResponse: Partial<HostingEmailSpamCustomSettings200> = {},
): HostingEmailSpamCustomSettings200 => ({
  allowlist: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  blocklist: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  custom_scores: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  spam_score: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailSpamCustomSettingsUpdateResponseMock = (
  overrideResponse: Partial<HostingEmailSpamCustomSettingsUpdate200> = {},
): HostingEmailSpamCustomSettingsUpdate200 => ({ ...overrideResponse });

export const getHostingEmailSpamEmptyResponseMock = (
  overrideResponse: Partial<HostingEmailSpamEmpty200> = {},
): HostingEmailSpamEmpty200 => ({ ...overrideResponse });

export const getHostingEmailSpamSettingsResponseMock = (
  overrideResponse: Partial<HostingEmailSpamSettings200> = {},
): HostingEmailSpamSettings200 => ({
  auto_delete_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  auto_delete_score: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  spam_box_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  spam_filter_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailSpamSettingsUpdateResponseMock = (
  overrideResponse: Partial<HostingEmailSpamSettingsUpdate200> = {},
): HostingEmailSpamSettingsUpdate200 => ({ ...overrideResponse });

export const getEmailSsoResponseMock = (
  overrideResponse: Partial<EmailSso200> = {},
): EmailSso200 => ({ url: faker.word.sample(), ...overrideResponse });

export const getHostingEmailTestSendResponseMock = (
  overrideResponse: Partial<HostingEmailTestSend200> = {},
): HostingEmailTestSend200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailFolderListResponseMock = (
  overrideResponse: Partial<HostingEmailFolderList200> = {},
): HostingEmailFolderList200 => ({
  count: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  folders: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      disk_usage: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      guid: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      messages: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subfolders: faker.helpers.arrayElement([Array.from([]), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingEmailSetupInfoResponseMock = (
  overrideResponse: Partial<HostingEmailSetupInfo200> = {},
): HostingEmailSetupInfo200 => ({
  host: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  imap: faker.helpers.arrayElement([
    {
      port: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      port_ssl: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  pop3: faker.helpers.arrayElement([
    {
      port: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      port_ssl: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  smtp: faker.helpers.arrayElement([
    {
      port: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      port_ssl: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingSendEmailSetupInfoResponseMock = (
  overrideResponse: Partial<HostingSendEmailSetupInfo200> = {},
): HostingSendEmailSetupInfo200 => ({ ...overrideResponse });

export const getHostingFixownershipResponseMock = (
  overrideResponse: Partial<HostingFixownership200> = {},
): HostingFixownership200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingFtpListResponseMock = (
  overrideResponse: Partial<HostingFtpList200> = {},
): HostingFtpList200 => ({
  ftp_accounts: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      homedir: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  server_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  special_ftp_accounts: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      homedir: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingFtpAddResponseMock = (
  overrideResponse: Partial<HostingFtpAdd200> = {},
): HostingFtpAdd200 => ({
  user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingFtpUpdateResponseMock = (
  overrideResponse: Partial<HostingFtpUpdate200> = {},
): HostingFtpUpdate200 => ({
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingFtpResponseMock = (
  overrideResponse: Partial<HostingFtp200> = {},
): HostingFtp200 => ({
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingRepoListResponseMock = (): HostingRepoList200Item[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    branch: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    repo_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  }));

export const getHostingRepoSyncResponseMock = (
  overrideResponse: Partial<HostingRepoSync200> = {},
): HostingRepoSync200 => ({
  action: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  branch: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  log: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  repo_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingRepoResponseMock = (
  overrideResponse: Partial<HostingRepo200> = {},
): HostingRepo200 => ({
  path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  repo_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingRepoLogResponseMock = (
  overrideResponse: Partial<HostingRepoLog200> = {},
): HostingRepoLog200 => ({
  log: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHotlinkconfigDetailsResponseMock = (
  overrideResponse: Partial<HotlinkconfigDetails200> = {},
): HotlinkconfigDetails200 => ({
  direct_request: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  file_types: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  protocol_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  redirect_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHotlinkconfigAddResponseMock = (
  overrideResponse: Partial<HotlinkconfigAdd200> = {},
): HotlinkconfigAdd200 => ({ ...overrideResponse });

export const getHotlinkconfigDeleteResponseMock = (
  overrideResponse: Partial<HotlinkconfigDelete200> = {},
): HotlinkconfigDelete200 => ({ ...overrideResponse });

export const getListIndexResponseMock = (
  overrideResponse: Partial<ListIndex200> = {},
): ListIndex200 => ({
  indexes: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      index_options: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddIndexResponseMock = (
  overrideResponse: Partial<AddIndex200> = {},
): AddIndex200 => ({
  file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getIndexResponseMock = (
  overrideResponse: Partial<Index200> = {},
): Index200 => ({
  file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingInfoResponseMock = (
  overrideResponse: Partial<HostingInfo200> = {},
): HostingInfo200 => ({
  ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingInfoDiskUsageResponseMock = (
  overrideResponse: Partial<HostingInfoDiskUsage200> = {},
): HostingInfoDiskUsage200 => ({
  disklastupdated: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  disklimit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  diskused: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  diskused_raw: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  fileslimit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  filesused: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingLeadResponseMock = (
  overrideResponse: Partial<HostingLead200> = {},
): HostingLead200 => ({
  response: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      clientRequestId: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      data: faker.helpers.arrayElement([
        {
          leadId: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
      errors: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      messageId: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      providerApplicationName: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingLicenseInfoResponseMock = (
  overrideResponse: Partial<HostingLicenseInfo200> = {},
): HostingLicenseInfo200 => ({
  licenses: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      details: faker.helpers.arrayElement([
        {
          seats: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      is_upgradeable: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingMigrationStatusResponseMock = (
  overrideResponse: Partial<HostingMigrationStatus200> = {},
): HostingMigrationStatus200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingMigrationsResponseMock = (
  overrideResponse: Partial<HostingMigrations200> = {},
): HostingMigrations200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingMigrationsEventResponseMock = (
  overrideResponse: Partial<HostingMigrationsEvent200> = {},
): HostingMigrationsEvent200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingMigrationInfoResponseMock = (
  overrideResponse: Partial<HostingMigrationInfo200> = {},
): HostingMigrationInfo200 => ({
  domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  feasible: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  hostname: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  incoming_domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  is_valid_migration_id: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  migration_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  site_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingMigrationSiteScanStatusResponseMock = (
  overrideResponse: Partial<HostingMigrationSiteScanStatus200> = {},
): HostingMigrationSiteScanStatus200 => ({
  callback_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  transferable: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingMonarxAddonsListResponseMock = (
  overrideResponse: Partial<HostingMonarxAddonsList200> = {},
): HostingMonarxAddonsList200 => ({
  rows: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    addon_id: faker.number.int({ min: undefined, max: undefined }),
    back_reference: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    domain_name: faker.word.sample(),
    health_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hosting_id: faker.word.sample(),
    plan: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getHostingNameserversResponseMock = (
  overrideResponse: Partial<HostingNameservers200> = {},
): HostingNameservers200 => ({
  nameservers: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  ...overrideResponse,
});

export const getHostingOnboardingDataResponseMock = (
  overrideResponse: Partial<HostingOnboardingData200> = {},
): HostingOnboardingData200 => ({
  completed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingOnboardingDataUpdateResponseMock = (
  overrideResponse: Partial<HostingOnboardingDataUpdate200> = {},
): HostingOnboardingDataUpdate200 => ({
  completed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingPasswordUpdateResponseMock = (
  overrideResponse: Partial<HostingPasswordUpdate200> = {},
): HostingPasswordUpdate200 => ({
  updated: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPasswordGenerateResponseMock = (
  overrideResponse: Partial<PasswordGenerate200> = {},
): PasswordGenerate200 => ({
  password: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getPasswordScoreResponseMock = (
  overrideResponse: Partial<PasswordScore200> = {},
): PasswordScore200 => ({
  score: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPhpErrorsResponseMock = (
  overrideResponse: Partial<PhpErrors200> = {},
): PhpErrors200 => ({
  content: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  date: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getProductLicenseDetailsResponseMock = (
  overrideResponse: Partial<ProductLicenseDetails200> = {},
): ProductLicenseDetails200 => ({
  wpsolution: faker.helpers.arrayElement([
    {
      commerce: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          expirationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          prodInstId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
        })),
        undefined,
      ]),
      creator: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          expirationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          prodInstId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
        })),
        undefined,
      ]),
      total: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingRedirectsResponseMock = (): HostingRedirects200Item[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    docroot: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    http_status_code: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    redirect_www: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    src: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    wildcard: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  }));

export const getHostingRedirectResponseMock = (
  overrideResponse: Partial<HostingRedirect200> = {},
): HostingRedirect200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddHostingRedirectsResponseMock = (
  overrideResponse: Partial<AddHostingRedirects200> = {},
): AddHostingRedirects200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingResellerSsoWhmResponseMock = (
  overrideResponse: Partial<HostingResellerSsoWhm200> = {},
): HostingResellerSsoWhm200 => ({
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingServerHitsResponseMock = (
  overrideResponse: Partial<HostingServerHits200> = {},
): HostingServerHits200 => ({
  server_hits: {
    last_n_days: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      hits: faker.number.int({ min: undefined, max: undefined }),
      name: faker.word.sample(),
    })),
    total_hits: faker.number.int({ min: undefined, max: undefined }),
  },
  ...overrideResponse,
});

export const getHostingShellToggleResponseMock = (
  overrideResponse: Partial<HostingShellToggle200> = {},
): HostingShellToggle200 => ({
  enabled: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingShellInfoResponseMock = (
  overrideResponse: Partial<HostingShellInfo200> = {},
): HostingShellInfo200 => ({
  enabled: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingSiteAddResponseMock = (
  overrideResponse: Partial<HostingSiteAdd200> = {},
): HostingSiteAdd200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSitesBatchResponseMock = (
  overrideResponse: Partial<SitesBatch200> = {},
): SitesBatch200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getHostingSpamexpertsEligibleDomainsResponseMock = (
  overrideResponse: Partial<HostingSpamexpertsEligibleDomains200> = {},
): HostingSpamexpertsEligibleDomains200 => ({
  n_rows: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      is_autogen: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingSshInfoResponseMock = (
  overrideResponse: Partial<HostingSshInfo200> = {},
): HostingSshInfo200 => ({
  credential: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  username: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyFetchResponseMock = (
  overrideResponse: Partial<SshKeyFetch200> = {},
): SshKeyFetch200 => ({
  key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyImportResponseMock = (
  overrideResponse: Partial<SshKeyImport200> = {},
): SshKeyImport200 => ({
  key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyListResponseMock = (
  overrideResponse: Partial<SshKeyList200> = {},
): SshKeyList200 => ({
  keys: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      haspub: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSshKeyResponseMock = (
  overrideResponse: Partial<SshKey200> = {},
): SshKey200 => ({
  deleted: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyGenerateResponseMock = (
  overrideResponse: Partial<SshKeyGenerate200> = {},
): SshKeyGenerate200 => ({
  key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  private_key_path: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  public_key_path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingVpsSshKeySyncResponseMock = (
  overrideResponse: Partial<HostingVpsSshKeySync200> = {},
): HostingVpsSshKeySync200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  username: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSsoResponseMock = (
  overrideResponse: Partial<Sso200> = {},
): Sso200 => ({ url: faker.word.sample(), ...overrideResponse });

export const getHostingVisitorsResponseMock = (
  overrideResponse: Partial<HostingVisitors200> = {},
): HostingVisitors200 => ({
  daily: faker.helpers.arrayElement([
    {
      data: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          bandwidth: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          date: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          hits: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          interval_end: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          interval_start: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          pages: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          visits: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      total: faker.helpers.arrayElement([
        {
          total_bandwidth: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          total_hits: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          total_pages: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          total_visitors: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        },
        undefined,
      ]),
    },
    undefined,
  ]),
  is_linked_domain: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  linked_domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  total_bandwidth: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total_hits: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total_pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total_unique_visitors: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total_visitors: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  visitors: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      bandwidth: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      hits: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      interval_end: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      interval_start: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      unique_visitors: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      visitors: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPublicImagesResponseMock = (
  overrideResponse: Partial<PublicImages200> = {},
): PublicImages200 => ({
  limit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  n_rows: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      ai_key_enabled: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      app: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      arch_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      cpanel_default: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      current: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      docker_default: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      links: faker.helpers.arrayElement([
        {
          community: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          doc: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          forums: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      lts: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      manage_link: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_cpus: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_disk: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_ram: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      os_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      os_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      readme: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      software: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      title: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      user_image: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPublicRegionsResponseMock = (
  overrideResponse: Partial<PublicRegions200> = {},
): PublicRegions200 => ({
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  n_rows: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      city: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      country: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      dedi: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      dedi_msg: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      description: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      display_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      id: faker.number.int({ min: undefined, max: undefined }),
      ident: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.word.sample(),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      vps: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      vps_msg: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPurchaseProductsResponseMock = (
  overrideResponse: Partial<AccountPurchaseProducts200> = {},
): AccountPurchaseProducts200 => ({
  products: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      currency_code: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      currency_symbol: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      quantity: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      sku: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      specs: faker.helpers.arrayElement([
        {
          bandwidth: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          nvme_storage_gb: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          ram_gb: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          ram_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          vcpu_cores: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        },
        undefined,
      ]),
      terms: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          base_price: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          final_price: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          tax_amount: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          term_quantity: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          term_unit: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          term_unit_description: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          total_price: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPurchaseHostingResponseMock = (
  overrideResponse: Partial<AccountPurchaseHosting200> = {},
): AccountPurchaseHosting200 => ({
  order_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  product_instance_id: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountPurchaseOrderResponseMock = (
  overrideResponse: Partial<AccountPurchaseOrder200> = {},
): AccountPurchaseOrder200 => ({
  hosting_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  hosting_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.helpers.arrayElement(['pending', 'active', 'failed'] as const),
      null,
    ]),
    undefined,
  ]),
  ip_address: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  order_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  order_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      'processing',
      'pending',
      'partially_complete',
      'completed',
      'failed',
      'deferred',
    ] as const),
    undefined,
  ]),
  product_instance_id: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  ssh_command: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesInfoResponseMock = (
  overrideResponse: Partial<SitesInfo200> = {},
): SitesInfo200 => ({
  account_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  account_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  base_domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  confirmed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  datacenter: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  detected_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  docpath: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  docroot: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  edge_cache: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  handler_404: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  install_blu_ai: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  install_blu_ai_store: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  installed_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  is_primary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  jobs: faker.helpers.arrayElement([{}, undefined]),
  last_error: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  migration_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  onboarding: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  pagespeed: faker.helpers.arrayElement([
    {
      lastrun: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      performance: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      strategy: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  pending_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_url_data: faker.helpers.arrayElement([
    {
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_temp: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      job_failed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      stage: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      wp_session: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  php_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  resources: faker.helpers.arrayElement([
    {
      storage: faker.helpers.arrayElement([
        {
          available: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          total: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          unit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          used: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      workers: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  staging: faker.helpers.arrayElement([
    {
      parent_site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoted_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoting_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promotion_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
    },
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  tenweb_upgrade_date: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  url_is_provisional: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  version_ptr: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  wp_multi_site: faker.helpers.arrayElement([
    {
      canonicalize_aliases: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      enable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getSiteUpdateResponseMock = (
  overrideResponse: Partial<SiteUpdate200> = {},
): SiteUpdate200 => ({
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSiteResponseMock = (
  overrideResponse: Partial<Site200> = {},
): Site200 => ({ success: faker.datatype.boolean(), ...overrideResponse });

export const getSitesAtomicMetricsResponseMock = (
  overrideResponse: Partial<SitesAtomicMetrics200> = {},
): SitesAtomicMetrics200 => ({
  raw: faker.helpers.arrayElement([
    {
      date_end: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_start: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      dimension: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1,
          ).map(() => faker.word.sample()),
        ]),
        undefined,
      ]),
      metric: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1,
          ).map(() => faker.word.sample()),
        ]),
        undefined,
      ]),
      periods: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: {
            [faker.string.alphanumeric(5)]: faker.helpers.arrayElement([
              faker.word.sample(),
              faker.number.int({ min: undefined, max: undefined }),
              faker.number.int({ min: undefined, max: undefined }),
            ]),
          },
          timestamp: faker.number.int({ min: undefined, max: undefined }),
        })),
        undefined,
      ]),
      resolution: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  views: faker.helpers.arrayElement([
    {
      last_n_days: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          hits: faker.number.int({ min: undefined, max: undefined }),
          name: faker.word.sample(),
        })),
        undefined,
      ]),
      total_hits: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesAutoupdatesInfoResponseMock = (
  overrideResponse: Partial<SitesAutoupdatesResponse> = {},
): SitesAutoupdatesResponse => ({
  core: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  plugins: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  themes: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesAutoupdatesUpdateResponseMock = (
  overrideResponse: Partial<SitesAutoupdatesResponse> = {},
): SitesAutoupdatesResponse => ({
  core: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  plugins: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  themes: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesBackupsResponseMock = (
  overrideResponse: Partial<SitesBackups200> = {},
): SitesBackups200 => ({
  has_backups: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesHasBackupsResponseMock = (
  overrideResponse: Partial<SitesHasBackups200> = {},
): SitesHasBackups200 => ({
  has_backups: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesBackupsCodeguardResponseMock = (
  overrideResponse: Partial<SitesBackupsCodeguard200> = {},
): SitesBackupsCodeguard200 => ({
  database_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  website_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesBackupsDetailsResponseMock = (
  overrideResponse: Partial<SitesBackupsDetails200> = {},
): SitesBackupsDetails200 => ({
  codeguard: faker.helpers.arrayElement([
    {
      activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      database_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      disabled: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      over_quota: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      seats_available: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      seats_count: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      website_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  jetpack: faker.helpers.arrayElement([
    {
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_exists: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      can_purchase: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      has_active_addon: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      has_active_plugin: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      last_backup_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      last_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      next_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      plugin_exists: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  xcitium: faker.helpers.arrayElement([
    {
      activated: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      addon_back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      addon_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      can_upgrade: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      database_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      disabled: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      over_quota: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      plan_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      seats_available: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      seats_count: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      website_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getJetpackBackupStatusResponseMock = (
  overrideResponse: Partial<JetpackBackupStatus200> = {},
): JetpackBackupStatus200 => ({
  addon_back_reference: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  addon_exists: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  addon_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  can_upgrade: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  has_active_addon: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  has_active_plugin: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  next_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_upgrade: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  plan_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  plugin_exists: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupsJetpackBackupResponseMock =
  (): BackupsJetpackBackup200 => ({});

export const getSitesBackupsXcitiumResponseMock = (
  overrideResponse: Partial<SitesBackupsXcitium200> = {},
): SitesBackupsXcitium200 => ({
  workflow_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSiteAddonCloudflareResponseMock = (
  overrideResponse: Partial<SiteAddonCloudflare200> = {},
): SiteAddonCloudflare200 => ({
  addon_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesDatabaseInfoResponseMock = (
  overrideResponse: Partial<SitesDatabaseInfo200> = {},
): SitesDatabaseInfo200 => ({
  charset: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  collation: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesDatabasePasswordsyncResponseMock = (
  overrideResponse: Partial<SitesDatabasePasswordsync200> = {},
): SitesDatabasePasswordsync200 => ({ ...overrideResponse });

export const getSitesDnsResponseMock = (
  overrideResponse: Partial<SitesDns200> = {},
): SitesDns200 => ({
  records: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      value: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  source: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesDomainResponseMock = (
  overrideResponse: Partial<SitesDomain200> = {},
): SitesDomain200 => ({
  a_match: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  connected: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  detected: faker.helpers.arrayElement([
    {
      a: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      ns: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
    },
    undefined,
  ]),
  is_internal: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  nameserver_match: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  wanted: faker.helpers.arrayElement([
    {
      a: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      ns: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesDomainUrlResponseMock = (
  overrideResponse: Partial<SitesDomainUrl200> = {},
): SitesDomainUrl200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesDomainsCreateResponseMock = (
  overrideResponse: Partial<SitesDomainsCreate200> = {},
): SitesDomainsCreate200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getErrorPagesFetchResponseMock = (
  overrideResponse: Partial<ErrorPagesFetch200> = {},
): ErrorPagesFetch200 => ({
  error_page: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  html_content: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getErrorPagesAddResponseMock = (
  overrideResponse: Partial<ErrorPagesAdd200> = {},
): ErrorPagesAdd200 => ({ ...overrideResponse });

export const getErrorPagesDeleteResponseMock = (
  overrideResponse: Partial<ErrorPagesDelete200> = {},
): ErrorPagesDelete200 => ({ ...overrideResponse });

export const getSiteIpaddressListResponseMock =
  (): SiteIpaddressList200Item[] =>
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      beginning_ip: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      ending_ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      server_setting: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
    }));

export const getSiteIpaddressResponseMock = (
  overrideResponse: Partial<SiteIpaddress200> = {},
): SiteIpaddress200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddSiteIpaddressResponseMock = (
  overrideResponse: Partial<AddSiteIpaddress200> = {},
): AddSiteIpaddress200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesJetpackPurchaseResponseMock = (
  overrideResponse: Partial<SitesJetpackPurchase200> = {},
): SitesJetpackPurchase200 => ({
  can_purchase: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesAccessLogsResponseMock = (
  overrideResponse: Partial<SitesAccessLogs200> = {},
): SitesAccessLogs200 => ({
  datetime_end: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  datetime_start: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  logs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      body_bytes_sent: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      cached: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      datetime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      epoch: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      http_host: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      http_referrer: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      http_user_agent: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      http_x_forwarded_for: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      renderer: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      request_completion: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      request_time: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      request_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      request_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      scheme: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      status: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      user_ip: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  page_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesErrorLogsResponseMock = (
  overrideResponse: Partial<SitesErrorLogs200> = {},
): SitesErrorLogs200 => ({
  datetime_end: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  datetime_start: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  logs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      datetime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      epoch: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      kind: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      line: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      severity: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  page_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSiteMalwareStatusResponseMock = (
  overrideResponse: Partial<SiteMalwareStatus200> = {},
): SiteMalwareStatus200 => ({
  malware_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  scanner_state: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesMetricsDimensionAveragedResponseMock = (
  overrideResponse: Partial<SitesMetricsDimensionAveraged200> = {},
): SitesMetricsDimensionAveraged200 => ({
  date_end: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  date_start: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  dimension: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  elapsed: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  metrics: faker.helpers.arrayElement([
    {
      requests_persec: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
      response_bytes_average: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
      response_bytes_persec: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
      response_time_average: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
    },
    undefined,
  ]),
  unit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSitesMetricDimensionsResponseMock = (
  overrideResponse: Partial<SitesMetricDimensions200> = {},
): SitesMetricDimensions200 => ({
  date_end: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  date_start: faker.helpers.arrayElement([
    `${faker.date.past().toISOString().split('.')[0]}Z`,
    undefined,
  ]),
  dimensions: faker.helpers.arrayElement([
    {
      http_host: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      http_status: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      http_verb: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      http_version: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      page_is_cached: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      page_renderer: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      visitor_asn: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      visitor_country_code: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      visitor_is_crawler: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      wp_admin_ajax_action: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          dimension: faker.helpers.arrayElement([
            {
              [faker.string.alphanumeric(5)]: faker.number.int({
                min: undefined,
                max: undefined,
              }),
            },
            undefined,
          ]),
          timestamp: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
    },
    undefined,
  ]),
  elapsed: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  metric: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSitesOnboardingStepsResponseMock = (
  overrideResponse: Partial<SitesOnboardingSteps200> = {},
): SitesOnboardingSteps200 => ({
  steps: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      action: faker.helpers.arrayElement([
        {
          ctb: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          redirect: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          set_meta: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sso_app: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          text: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
      order: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      text: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitePendingDomainDeleteResponseMock = (
  overrideResponse: Partial<SitePendingDomainDelete200> = {},
): SitePendingDomainDelete200 => ({ ...overrideResponse });

export const getSitesPerformanceCachepurgeResponseMock = (
  overrideResponse: Partial<SitesPerformanceCachepurge200> = {},
): SitesPerformanceCachepurge200 => ({
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesPerformanceEdgecacheResponseMock = (
  overrideResponse: Partial<SitesPerformanceEdgecache200> = {},
): SitesPerformanceEdgecache200 => ({ ...overrideResponse });

export const getSitesPerformanceEnduranceCacheLevelStatusResponseMock = (
  overrideResponse: Partial<SitesPerformanceEnduranceCacheLevelStatus200> = {},
): SitesPerformanceEnduranceCacheLevelStatus200 => ({
  endurance_cache_level: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesPerformanceEnduranceCacheLevelResponseMock = (
  overrideResponse: Partial<SitesPerformanceEnduranceCacheLevel200> = {},
): SitesPerformanceEnduranceCacheLevel200 => ({
  options: faker.helpers.arrayElement([{}, undefined]),
  ...overrideResponse,
});

export const getSitesPerformanceEndurancePageCacheResponseMock = (
  overrideResponse: Partial<SitesPerformanceEndurancePageCache200> = {},
): SitesPerformanceEndurancePageCache200 => ({
  result: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSitesPerformanceRedisToggleResponseMock = (
  overrideResponse: Partial<SitesPerformanceRedisToggle200> = {},
): SitesPerformanceRedisToggle200 => ({ ...overrideResponse });

export const getSitesPerformanceRedisStatusResponseMock = (
  overrideResponse: Partial<SitesPerformanceRedisStatus200> = {},
): SitesPerformanceRedisStatus200 => ({
  obj_cache_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  obj_cache_installed: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  redis_service_active: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesPerformanceRedisUninstallResponseMock = (
  overrideResponse: Partial<SitesPerformanceRedisUninstall200> = {},
): SitesPerformanceRedisUninstall200 => ({ ...overrideResponse });

export const getSitesPerformanceRedisPurgeResponseMock = (
  overrideResponse: Partial<SitesPerformanceRedisPurge200> = {},
): SitesPerformanceRedisPurge200 => ({ ...overrideResponse });

export const getSitesPerformanceScansListResponseMock = (
  overrideResponse: Partial<SitesPerformanceScansList200> = {},
): SitesPerformanceScansList200 => ({
  data: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      accessibility_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      best_practices_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      created_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        undefined,
      ]),
      cumulative_layout_shift: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      first_contentful_paint: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      is_active: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      job_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      largest_contentful_paint: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      last_scan_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        undefined,
      ]),
      overall_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      performance_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      result_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      seo_score: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      speed_index: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      time_taken: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      time_to_first_byte: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      total_blocking_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      updated_at: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  meta: faker.helpers.arrayElement([
    {
      page: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      per_page: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      total: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesPerformanceScansResponseMock = (
  overrideResponse: Partial<SitesPerformanceScans200> = {},
): SitesPerformanceScans200 => ({ ...overrideResponse });

export const getSitesPerformanceScansAddResponseMock = (
  overrideResponse: Partial<SitesPerformanceScansAdd200> = {},
): SitesPerformanceScansAdd200 => ({ ...overrideResponse });

export const getCreatePhpInfoResponseMock = (
  overrideResponse: Partial<CreatePhpInfo200> = {},
): CreatePhpInfo200 => ({
  html: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSitePluginsResponseMock = (
  overrideResponse: Partial<SitePlugins200> = {},
): SitePlugins200 => ({
  auto_update: faker.datatype.boolean(),
  plugins: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    id: faker.word.sample(),
    status: faker.word.sample(),
    title: faker.word.sample(),
    update: faker.datatype.boolean(),
    version: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  })),
  subtype: faker.word.sample(),
  ...overrideResponse,
});

export const getSitePluginUpdateResponseMock = (
  overrideResponse: Partial<SitePluginUpdate200> = {},
): SitePluginUpdate200 => ({
  id: faker.word.sample(),
  status: faker.word.sample(),
  ...overrideResponse,
});

export const getSitePluginInstallResponseMock = (
  overrideResponse: Partial<SitePluginInstall200> = {},
): SitePluginInstall200 => ({
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitePluginsAutoupdateResponseMock = (
  overrideResponse: Partial<SitePluginsAutoupdate200> = {},
): SitePluginsAutoupdate200 => ({
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSitePluginInstallerResponseMock = (
  overrideResponse: Partial<SitePluginInstaller200> = {},
): SitePluginInstaller200 => ({
  id: faker.word.sample(),
  status: faker.word.sample(),
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSitePluginsToggleResponseMock = (
  overrideResponse: Partial<SitePluginsToggle200> = {},
): SitePluginsToggle200 => ({
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSitePluginsUpdateResponseMock = (
  overrideResponse: Partial<SitePluginsUpdate200> = {},
): SitePluginsUpdate200 => ({
  success: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getSiteQualityMetricsResponseMock = (
  overrideResponse: Partial<SiteQualityMetrics200> = {},
): SiteQualityMetrics200 => ({
  aspect_details: {
    performance: faker.helpers.arrayElement([
      {
        'cumulative-layout-shift': faker.helpers.arrayElement([{}, undefined]),
        'first-contentful-paint': faker.helpers.arrayElement([{}, undefined]),
        'largest-contentful-paint': faker.helpers.arrayElement([{}, undefined]),
        'speed-index': faker.helpers.arrayElement([{}, undefined]),
        'total-blocking-time': faker.helpers.arrayElement([{}, undefined]),
      },
      undefined,
    ]),
  },
  aspect_scores: {
    performance: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
  },
  audits: faker.helpers.arrayElement([{}, undefined]),
  loading_experience: faker.helpers.arrayElement([{}, undefined]),
  origin_loading_experience: faker.helpers.arrayElement([{}, undefined]),
  strategy: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getResetSiteResponseMock = (
  overrideResponse: Partial<ResetSite200> = {},
): ResetSite200 => ({
  previous_status: faker.word.sample(),
  status: faker.word.sample(),
  ...overrideResponse,
});

export const getSitesSecurityBundleResponseMock = (
  overrideResponse: Partial<SitesSecurityBundle200> = {},
): SitesSecurityBundle200 => ({
  eligible: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesSecurityCheckCoreResponseMock = (
  overrideResponse: Partial<SitesSecurityCheckCore200> = {},
): SitesSecurityCheckCore200 => ({
  results: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecurityResetCoreFilesResponseMock = (
  overrideResponse: Partial<SitesSecurityResetCoreFiles200> = {},
): SitesSecurityResetCoreFiles200 => ({
  results: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecurityHttpsRedirectionStatusResponseMock = (
  overrideResponse: Partial<SitesSecurityHttpsRedirectionStatus200> = {},
): SitesSecurityHttpsRedirectionStatus200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  redirection_status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecurityHttpsEnableDisableSslResponseMock = (
  overrideResponse: Partial<SitesSecurityHttpsEnableDisableSsl200> = {},
): SitesSecurityHttpsEnableDisableSsl200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  redirection_status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecuritySitelockResponseMock = (
  overrideResponse: Partial<SitesSecuritySitelock200> = {},
): SitesSecuritySitelock200 => ({
  addon_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  billing_code: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domains: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  has_cdn: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  is_migrated: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  plan: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  platform_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  scope: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  source: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  upgrade_levels: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecuritySslAcmeResponseMock = (
  overrideResponse: Partial<SitesSecuritySslAcme200> = {},
): SitesSecuritySslAcme200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecuritySslStatusResponseMock = (
  overrideResponse: Partial<SitesSecuritySslStatus200> = {},
): SitesSecuritySslStatus200 => ({
  domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  product: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  provider: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ssl_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  upgradeable: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSettingsComingSoonResponseMock = (
  overrideResponse: Partial<SitesSettingsComingSoon200> = {},
): SitesSettingsComingSoon200 => ({
  enable: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSitesSettingsComingSoonToggleResponseMock = (
  overrideResponse: Partial<SitesSettingsComingSoonToggle200> = {},
): SitesSettingsComingSoonToggle200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSettingsDebugResponseMock = (
  overrideResponse: Partial<SitesSettingsDebug200> = {},
): SitesSettingsDebug200 => ({
  status: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSettingsDebugToggleResponseMock = (
  overrideResponse: Partial<SitesSettingsDebugToggle200> = {},
): SitesSettingsDebugToggle200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSettingsPhpVersionUpdateResponseMock = (
  overrideResponse: Partial<SitesSettingsPhpVersionUpdate200> = {},
): SitesSettingsPhpVersionUpdate200 => ({
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSettingsPhpVersionInheritanceResponseMock = (
  overrideResponse: Partial<SitesSettingsPhpVersionInheritance200> = {},
): SitesSettingsPhpVersionInheritance200 => ({
  inherited: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    docpath: faker.word.sample(),
    docroot: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    homedir: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    ok: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    php_inherited: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    php_version: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    url: faker.word.sample(),
    user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  })),
  success: faker.number.int({ min: undefined, max: undefined }),
  ...overrideResponse,
});

export const getSitesSettingsPhpVersionsResponseMock = (
  overrideResponse: Partial<SitesSettingsPhpVersions200> = {},
): SitesSettingsPhpVersions200 => ({
  default: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  deprecated: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  latest: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  versions: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSshUserListResponseMock = (
  overrideResponse: Partial<SitesSshUserList200> = {},
): SitesSshUserList200 => ({
  users: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSshUserCreateResponseMock = (
  overrideResponse: Partial<SitesSshUserCreate200> = {},
): SitesSshUserCreate200 => ({
  private_key: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  public_key: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  public_key_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSshUserDeleteResponseMock = (
  overrideResponse: Partial<SitesSshUserDelete200> = {},
): SitesSshUserDelete200 => ({ ...overrideResponse });

export const getSitesSshUserUpdateResponseMock = (
  overrideResponse: Partial<SitesSshUserUpdate200> = {},
): SitesSshUserUpdate200 => ({ ...overrideResponse });

export const getSitesSslResponseMock = (
  overrideResponse: Partial<SitesSsl200> = {},
): SitesSsl200 => ({
  domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  domain_dns_status: faker.helpers.arrayElement([
    faker.word.sample(),
    undefined,
  ]),
  expiration: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  issuer: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  product: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  provider: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  type: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  upgradeable: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSsoResponseMock = (
  overrideResponse: Partial<SitesSso200> = {},
): SitesSso200 => ({
  other: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      addon_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  sso: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  type: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getStagingSitePromoteResponseMock = (
  overrideResponse: Partial<StagingSitePromote200> = {},
): StagingSitePromote200 => ({
  job_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSiteStatusResponseMock = (
  overrideResponse: Partial<SiteStatus200> = {},
): SiteStatus200 => ({
  cloudflare_ready: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  pending_url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSiteUsersResponseMock = (
  overrideResponse: Partial<SiteUsers200> = {},
): SiteUsers200 => ({
  users: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    display_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    id: faker.number.int({ min: undefined, max: undefined }),
    meta: faker.helpers.arrayElement([
      {
        maestro_web_pro: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        maestro_wpp_identifier: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
      },
      undefined,
    ]),
    post_count: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    role: faker.word.sample(),
    user_email: faker.word.sample(),
    user_id: faker.number.int({ min: undefined, max: undefined }),
    user_login: faker.word.sample(),
    user_nicename: faker.word.sample(),
  })),
  ...overrideResponse,
});

export const getSitesVersionResponseMock = (
  overrideResponse: Partial<SitesVersion200> = {},
): SitesVersion200 => ({
  current: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  latest: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  update: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSiteWpGenerateResponseMock = (
  overrideResponse: Partial<SiteWpGenerate200> = {},
): SiteWpGenerate200 => ({
  results: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: faker.word.sample(),
    },
    undefined,
  ]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSiteThemeInstallResponseMock = (
  overrideResponse: Partial<SiteThemeInstall200> = {},
): SiteThemeInstall200 => ({
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  success: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  ...overrideResponse,
});

export const getSiteAddonWpsolutionResponseMock = (
  overrideResponse: Partial<SiteAddonWpsolution200> = {},
): SiteAddonWpsolution200 => ({ ...overrideResponse });

export const getUserBillingAccountsResponseMock = (
  overrideResponse: Partial<UserBillingAccounts200> = {},
): UserBillingAccounts200 => ({
  accounts: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    billing_account_id: faker.number.int({ min: undefined, max: undefined }),
  })),
  ...overrideResponse,
});

export const getUserDomainsResponseMock = (
  overrideResponse: Partial<UserDomains200> = {},
): UserDomains200 => ({
  domains: {
    [faker.string.alphanumeric(5)]: {
      billing: faker.helpers.arrayElement([
        {
          account_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          domain_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          is_internal_domain: faker.datatype.boolean(),
          name_servers: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          number_of_services: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          prod_cd: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_inst_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
    },
  },
  ...overrideResponse,
});

export const getUserHostingResponseMock = (
  overrideResponse: Partial<UserHosting200> = {},
): UserHosting200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_info: faker.helpers.arrayElement([
        {
          addon_back_ref: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          addon_date_added: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          addon_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          addon_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          application: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          billing_account_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          brand: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          brand_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          date_added: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          date_modified: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          homedir: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          image: faker.helpers.arrayElement([
            {
              app: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              os_name: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              os_version: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              software: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
            },
            undefined,
          ]),
          ip: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          meta: faker.helpers.arrayElement([
            {
              main_domain: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              prev_tenant: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
            },
            undefined,
          ]),
          ns: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.word.sample()),
            undefined,
          ]),
          os_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          os_version: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          platform: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          region: faker.helpers.arrayElement([
            {
              desc: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
              name: faker.helpers.arrayElement([
                faker.helpers.arrayElement([faker.word.sample(), null]),
                undefined,
              ]),
            },
            undefined,
          ]),
          server_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          server_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          server_subtype: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          server_type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          software: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          ssh_hostname: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          tenant_back_ref: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          tenant_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          username: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      back_reference: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      billing: faker.helpers.arrayElement([
        {
          auto_renew_flag: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          expiration_date: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_inst_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      capability_sites: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      feature_set: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      has_panel_mail: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_upgradeable: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      limit: faker.helpers.arrayElement([
        {
          disk_limit_gib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          max_disk_limit_gib_per_site: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      limit_remote: faker.helpers.arrayElement([
        {
          inodes: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          quota_kib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      package: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      panel: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      panel_mail_addon: faker.helpers.arrayElement([
        {
          back_reference: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          subtype: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      used: faker.helpers.arrayElement([
        {
          disk_limit_gib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          disk_usage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          inodes: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          sites_active: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          staging_sites: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      used_stage: faker.helpers.arrayElement([
        {
          disk_limit_gib: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          disk_usage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUserHostingOverviewResponseMock = (
  overrideResponse: Partial<UserHostingOverview200> = {},
): UserHostingOverview200 => ({
  has_unlimited_sites: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  hosting_accounts: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  max_sites: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAllUserMonarxDetailsResponseMock = (
  overrideResponse: Partial<AllUserMonarxDetails200> = {},
): AllUserMonarxDetails200 => ({
  rows: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    account_back_ref: faker.helpers.arrayElement([
      faker.word.sample(),
      undefined,
    ]),
    addon_id: faker.number.int({ min: undefined, max: undefined }),
    domain_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    domain_name: faker.word.sample(),
    health_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    last_scan_completed_at: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    plan: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    prod_inst_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    prod_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getUserOnboardingResponseMock = (
  overrideResponse: Partial<UserOnboarding200> = {},
): UserOnboarding200 => ({
  eligible: faker.datatype.boolean(),
  message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  survey_completed: faker.datatype.boolean(),
  survey_unavailable: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserOnboardingStepsResponseMock = (
  overrideResponse: Partial<OnboardingGetStepsResponse> = {},
): OnboardingGetStepsResponse => ({
  eligible: faker.datatype.boolean(),
  message: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  products: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    completed: faker.datatype.boolean(),
    prod_code: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    prod_inst_id: faker.word.sample(),
    prod_inst_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    prod_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    site_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    site_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    steps: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      completed: faker.datatype.boolean(),
      dismissible: faker.datatype.boolean(),
      name: faker.word.sample(),
      step_id: faker.word.sample(),
    })),
    type: faker.word.sample(),
    url_is_provisional: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
  })),
  user: {
    complete_profile: {
      completed: faker.datatype.boolean(),
      dismissible: faker.datatype.boolean(),
      name: faker.word.sample(),
      step_id: faker.word.sample(),
    },
    meet_welcome_team: {
      completed: faker.datatype.boolean(),
      dismissible: faker.datatype.boolean(),
      name: faker.word.sample(),
      step_id: faker.word.sample(),
    },
  },
  ...overrideResponse,
});

export const getUserOnboardingSurveyGetResponseMock = (
  overrideResponse: Partial<OnboardingSurveyResponse> = {},
): OnboardingSurveyResponse => ({
  describes: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  focus_on: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  industry: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  number_of_people: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  survey_unavailable: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserOnboardingSurveyPostResponseMock = (
  overrideResponse: Partial<OnboardingSurveyResponse> = {},
): OnboardingSurveyResponse => ({
  describes: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  focus_on: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  industry: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  number_of_people: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => faker.word.sample()),
  survey_unavailable: faker.datatype.boolean(),
  ...overrideResponse,
});

export const getUserPhoneSmsConsentResponseMock = (
  overrideResponse: Partial<UserPhoneSmsConsent200> = {},
): UserPhoneSmsConsent200 => ({
  data: faker.helpers.arrayElement([{}, undefined]),
  status: faker.word.sample(),
  ...overrideResponse,
});

export const getUserPhoneSmsConsentUpdateResponseMock = (
  overrideResponse: Partial<UserPhoneSmsConsentUpdate200> = {},
): UserPhoneSmsConsentUpdate200 => ({
  data: faker.helpers.arrayElement([
    { optInId: faker.helpers.arrayElement([faker.word.sample(), undefined]) },
    undefined,
  ]),
  status: faker.word.sample(),
  ...overrideResponse,
});

export const getUserProductsResponseMock = (
  overrideResponse: Partial<UserProducts200> = {},
): UserProducts200 => ({
  products: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      auto_renew: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      auto_renew_flag: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      created_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          `${faker.date.past().toISOString().split('.')[0]}Z`,
          null,
        ]),
        undefined,
      ]),
      expiration_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      generic_prod_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_cloud_product: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_free_foundation_hosting: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_gw_product_configured: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      parent_prod_inst_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      prod_inst_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_inst_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      subscription_term: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      subscription_unit: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUserProservicesResponseMock = (
  overrideResponse: Partial<UserProservices200> = {},
): UserProservices200 => ({
  products: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      auto_renew_flag: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      billing_account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      created_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      expiration_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      generic_prod_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      identifier: faker.helpers.arrayElement([
        {
          key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          value: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        },
        undefined,
      ]),
      life_cycle_state: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      parent_prod_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      parent_prod_inst_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_code: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_inst_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_inst_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      prod_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      product_profile_options: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          profile_option: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          profile_value: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        })),
        undefined,
      ]),
      revision_window_days: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUserServersResponseMock = (
  overrideResponse: Partial<UserServers200> = {},
): UserServers200 => ({
  servers: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    account_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    domains: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      autogen_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    flavor_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hostname: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    image_name: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    primary_ip: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    prod_inst_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    server_id: faker.number.int({ min: undefined, max: undefined }),
    server_ips: Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    server_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    target_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    tenant_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
  })),
  ...overrideResponse,
});

export const getUserSitesAiResponseMock = (
  overrideResponse: Partial<UserSitesAi200> = {},
): UserSitesAi200 => ({
  items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_back_ref: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      account_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      billing: faker.helpers.arrayElement([
        {
          auto_renew_flag: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          expiration_date: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_code: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_inst_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          prod_name: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      confirmed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      datacenter: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_modified: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      detected_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      docpath: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      docroot: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      edge_cache: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      handler_404: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      has_woocommerce: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      install_blu_ai: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      install_blu_ai_store: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      installed_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_primary: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_upgradeable: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      jobs: faker.helpers.arrayElement([{}, undefined]),
      last_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      migration_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      onboarding: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      pending_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_url_data: faker.helpers.arrayElement([
        {
          base_domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          error: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          is_temp: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          job_failed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          stage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          wp_session: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      php_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      resources: faker.helpers.arrayElement([
        {
          storage: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              unit: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      staging: faker.helpers.arrayElement([
        {
          parent_site_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoted_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoting_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promotion_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.number.int({ min: undefined, max: undefined })),
            undefined,
          ]),
        },
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      tenweb_upgrade_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      url_is_provisional: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      version_ptr: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      wp_multi_site: faker.helpers.arrayElement([
        {
          canonicalize_aliases: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          enable: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getUserSpamexpertsResponseMock = (
  overrideResponse: Partial<UserSpamexperts200> = {},
): UserSpamexperts200 => ({
  rows: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    addon_id: faker.number.int({ min: undefined, max: undefined }),
    back_reference: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hosting_back_reference: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    meta: {
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      email: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    status: faker.word.sample(),
  })),
  ...overrideResponse,
});

export const getWaldaiSsoResponseMock = (
  overrideResponse: Partial<WaldaiSso200> = {},
): WaldaiSso200 => ({ redirect_url: faker.word.sample(), ...overrideResponse });

export const getAccountHostingListV2ResponseMock = (
  overrideResponse: Partial<AccountHostingListV2200> = {},
): AccountHostingListV2200 => ({
  accounts: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      billing_account_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      current_sites: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      feature_set: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      hosting_addon_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      hosting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      max_sites: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      parent_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      platform: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      platform_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      prod_inst_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      region_desc: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      region_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      server_ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      server_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAddonsSitelockSsoV2ResponseMock = (
  overrideResponse: Partial<AddonsSitelockSsoV2200> = {},
): AddonsSitelockSsoV2200 => ({
  site_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  sitelock_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getBackupCreateV2ResponseMock = (
  overrideResponse: Partial<BackupCreateV2200> = {},
): BackupCreateV2200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  tracking_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupDownloadV2ResponseMock = (
  overrideResponse: Partial<BackupDownloadV2200> = {},
): BackupDownloadV2200 => ({
  client_tracking_id: faker.word.sample(),
  ...overrideResponse,
});

export const getBackupListV2ResponseMock = (
  overrideResponse: Partial<BackupListV2200> = {},
): BackupListV2200 => ({
  backups: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      backup_creation_time: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      backup_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      databases: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      dc_location: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      schedule_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      timezone: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupRestoreV2ResponseMock = (
  overrideResponse: Partial<BackupRestoreV2200> = {},
): BackupRestoreV2200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  tracking_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupStatusV2ResponseMock = (
  overrideResponse: Partial<BackupStatusV2200> = {},
): BackupStatusV2200 => ({
  backup_download_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  backups_deletion_status: faker.helpers.arrayElement([{}, undefined]),
  cbs_action: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  cbs_event_processing: faker.helpers.arrayElement([
    {
      action: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      backup_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      snapshot_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  cbs_execution_phase: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  cbs_internal_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  client_tracking_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  current_state_backup_download_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  current_state_backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  execution_progress: faker.helpers.arrayElement([
    {
      stages_completed: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      total_stages: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  freed_up_bytes: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  progress_percentage: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  restored_from_backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  tracking_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingAdvancedServerV2ResponseMock = (
  overrideResponse: Partial<HostingAdvancedServerV2200> = {},
): HostingAdvancedServerV2200 => ({
  actions: faker.helpers.arrayElement([{}, undefined]),
  hostname: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ips: faker.helpers.arrayElement([
    {
      other_ips: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.helpers.arrayElement([faker.word.sample(), null])),
        undefined,
      ]),
      primary_ip: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  os_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  os_version: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  uptime_seconds: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDbListV2ResponseMock = (
  overrideResponse: Partial<DbListV2200> = {},
): DbListV2200 => ({
  databases: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      db: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      sitename: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      sizemib: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      usercount: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      userlist: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({
          db: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDomainsV2ResponseMock = (
  overrideResponse: Partial<HostingDomainsV2200> = {},
): HostingDomainsV2200 => ({
  domains: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    account_back_ref: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    authoritative: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    autogen_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    back_reference: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    base_domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    billing_account_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    billing_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    date_ssl_exp: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    dns_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    docroot: faker.helpers.arrayElement([faker.word.sample(), null]),
    domain: faker.word.sample(),
    entri_last_success: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    homedir: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hosting_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    id: faker.number.int({ min: undefined, max: undefined }),
    is_internal: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    jobs: faker.helpers.arrayElement([{}, undefined]),
    nameservers: faker.helpers.arrayElement([
      Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1,
      ).map(() => faker.word.sample()),
      undefined,
    ]),
    platform: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    platform_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    product_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    setup_progress: faker.helpers.arrayElement([
      {
        validate_cdn: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_cdn_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_dns: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_dns_auto_repair: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_dns_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_ssl: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_ssl_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_ssl_error_table: faker.helpers.arrayElement([{}, undefined]),
      },
      undefined,
    ]),
    ssl_issuer: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_prod_inst_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_tier: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_upgradeable: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    third_party_dns: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    type: faker.word.sample(),
    used_entri: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
  })),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingDomainsUnassignV2ResponseMock = (
  overrideResponse: Partial<HostingDomainsUnassignV2200> = {},
): HostingDomainsUnassignV2200 => ({ ...overrideResponse });

export const getListFilesV2ResponseMock = (
  overrideResponse: Partial<ListFilesV2200> = {},
): ListFilesV2200 => ({
  files: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      file: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      size: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingNameserversV2ResponseMock = (
  overrideResponse: Partial<HostingNameserversV2200> = {},
): HostingNameserversV2200 => ({
  brand: faker.word.sample(),
  hosts: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    host: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    ips: faker.helpers.arrayElement([
      Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1,
      ).map(() => faker.word.sample()),
      undefined,
    ]),
  })),
  id: faker.number.int({ min: undefined, max: undefined }),
  is_default: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getHostingRedirectsV2ResponseMock =
  (): HostingRedirectsV2200Item[] =>
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      docroot: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      http_status_code: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      redirect_www: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      src: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      wildcard: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    }));

export const getHostingSitesV2ResponseMock = (
  overrideResponse: Partial<HostingSitesV2200> = {},
): HostingSitesV2200 => ({
  available_sites: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_back_ref: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      account_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      confirmed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      datacenter: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_modified: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      detected_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      docpath: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      docroot: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      edge_cache: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      handler_404: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      install_blu_ai: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      install_blu_ai_store: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      installed_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_primary: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      jobs: faker.helpers.arrayElement([{}, undefined]),
      last_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      migration_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      onboarding: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      pending_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_url_data: faker.helpers.arrayElement([
        {
          base_domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          error: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          is_temp: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          job_failed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          stage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          wp_session: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      php_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      resources: faker.helpers.arrayElement([
        {
          storage: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              unit: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      staging: faker.helpers.arrayElement([
        {
          parent_site_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoted_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoting_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promotion_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.number.int({ min: undefined, max: undefined })),
            undefined,
          ]),
        },
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      tenweb_upgrade_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      url_is_provisional: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      version_ptr: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      wp_multi_site: faker.helpers.arrayElement([
        {
          canonicalize_aliases: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          enable: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
        },
        undefined,
      ]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  max_sites: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  used_sites: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  used_sites_details: faker.helpers.arrayElement([
    {
      sites_active: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      sites_misconfigured: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      sites_other: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      sites_pending: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      staging_sites: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    },
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingSiteAddV2ResponseMock = (
  overrideResponse: Partial<HostingSiteAddV2200> = {},
): HostingSiteAddV2200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyImportV2ResponseMock = (
  overrideResponse: Partial<SshKeyImportV2200> = {},
): SshKeyImportV2200 => ({
  private_key_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  public_key_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSshKeyListV2ResponseMock = (
  overrideResponse: Partial<SshKeyListV2200> = {},
): SshKeyListV2200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      key: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      mtime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSshKeyV2ResponseMock = (
  overrideResponse: Partial<SshKeyV2200> = {},
): SshKeyV2200 => ({
  deleted: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  key_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getPublicImagesV2ResponseMock = (
  overrideResponse: Partial<PublicImagesV2200> = {},
): PublicImagesV2200 => ({
  limit: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  n_rows: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.word.sample(),
      faker.number.int({ min: undefined, max: undefined }),
    ]),
    undefined,
  ]),
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      app: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      arch_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      cpanel_default: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      current: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      docker_default: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      links: faker.helpers.arrayElement([
        {
          community: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          doc: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          forums: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      lts: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      manage_link: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_cpus: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_disk: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      min_ram: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      os_name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      os_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      readme: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      software: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      title: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      user_image: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesListV2ResponseMock = (
  overrideResponse: Partial<SitesListV2200> = {},
): SitesListV2200 => ({
  items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_back_ref: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      account_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      confirmed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      datacenter: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_modified: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      detected_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      docpath: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      docroot: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      edge_cache: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      handler_404: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      installed_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_primary: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      jobs: faker.helpers.arrayElement([{}, undefined]),
      last_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      migration_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      onboarding: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      path: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      pending_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_url_data: faker.helpers.arrayElement([
        {
          base_domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          error: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          is_temp: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          job_failed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          stage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          wp_session: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      php_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      resources: faker.helpers.arrayElement([
        {
          storage: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              unit: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      staging: faker.helpers.arrayElement([
        {
          parent_site_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoted_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoting_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promotion_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.number.int({ min: undefined, max: undefined })),
            undefined,
          ]),
        },
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      url_is_provisional: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      version_ptr: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesInfoV2ResponseMock = (
  overrideResponse: Partial<SiteInfoResponseModelV2> = {},
): SiteInfoResponseModelV2 => ({
  account_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  account_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  base_domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  brand_protection_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  confirmed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  datacenter: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  detected_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  docpath: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  docroot: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain_ptrs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({})),
    undefined,
  ]),
  edge_cache: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  handler_404: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  has_woocommerce: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  install_blu_ai: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  install_blu_ai_store: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  installed_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  is_primary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  jobs: faker.helpers.arrayElement([{}, undefined]),
  last_error: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  migration_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  onboarding: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  onboarding_call_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  options: faker.helpers.arrayElement([
    {
      nfd_origin_prompt: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_description: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_title: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  pagespeed: faker.helpers.arrayElement([
    {
      lastrun: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      performance: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      strategy: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  parent_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  path: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_url_data: faker.helpers.arrayElement([
    {
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_temp: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      job_failed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      stage: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      wp_session: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  php_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pro_services_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  resources: faker.helpers.arrayElement([
    {
      storage: faker.helpers.arrayElement([
        {
          available: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          total: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          unit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          used: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      workers: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  staging: faker.helpers.arrayElement([
    {
      parent_site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoted_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoting_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promotion_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
    },
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  subtype: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  tenweb_upgrade_date: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  url_is_provisional: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  version_ptr: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesDomainsV2ResponseMock = (
  overrideResponse: Partial<SitesDomainsV2200> = {},
): SitesDomainsV2200 => ({
  domains: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    account_back_ref: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    authoritative: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    autogen_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    back_reference: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    base_domain: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    billing_account_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    billing_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    date_ssl_exp: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    dns_status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    docroot: faker.helpers.arrayElement([faker.word.sample(), null]),
    domain: faker.word.sample(),
    homedir: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    hosting_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
    id: faker.number.int({ min: undefined, max: undefined }),
    is_internal: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    jobs: faker.helpers.arrayElement([{}, undefined]),
    nameservers: faker.helpers.arrayElement([
      Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1,
      ).map(() => faker.word.sample()),
      undefined,
    ]),
    platform: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    platform_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    product_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    setup_progress: faker.helpers.arrayElement([
      {
        validate_cdn: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_cdn_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_dns: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_dns_auto_repair: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_dns_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_ssl: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        validate_ssl_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        validate_ssl_error_table: faker.helpers.arrayElement([{}, undefined]),
      },
      undefined,
    ]),
    ssl_issuer: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_prod_inst_id: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_status: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_tier: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_type: faker.helpers.arrayElement([
      faker.helpers.arrayElement([faker.word.sample(), null]),
      undefined,
    ]),
    ssl_upgradeable: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    third_party_dns: faker.helpers.arrayElement([
      faker.datatype.boolean(),
      undefined,
    ]),
    type: faker.word.sample(),
    used_entri: faker.helpers.arrayElement([
      faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        null,
      ]),
      undefined,
    ]),
  })),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSiteMalwareStatusV2ResponseMock = (
  overrideResponse: Partial<SiteMalwareStatusV2200> = {},
): SiteMalwareStatusV2200 => ({
  addon_state: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  malware_state: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  plugin_state: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  scanner_state: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSecuritySitelockV2ResponseMock = (
  overrideResponse: Partial<SitesSecuritySitelockV2200> = {},
): SitesSecuritySitelockV2200 => ({
  addon_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  billing_code: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domains: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  has_cdn: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  is_migrated: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  plan: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  platform_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  scope: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  source: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  success: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  upgrade_levels: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => faker.word.sample()),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesSshUserListV2ResponseMock = (
  overrideResponse: Partial<SitesSshUserListV2200> = {},
): SitesSshUserListV2200 => ({
  users: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      installed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_active: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      job_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      public_key_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      ssh_hostname: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      user: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSiteUsersV2ResponseMock = (
  overrideResponse: Partial<SiteUsersV2200> = {},
): SiteUsersV2200 => ({
  total_users: faker.number.int({ min: undefined, max: undefined }),
  users: Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1,
  ).map(() => ({
    display_name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    id: faker.number.int({ min: undefined, max: undefined }),
    meta: faker.helpers.arrayElement([
      {
        maestro_web_pro: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        maestro_wpp_identifier: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
      },
      undefined,
    ]),
    post_count: faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      undefined,
    ]),
    role: faker.word.sample(),
    user_email: faker.word.sample(),
    user_id: faker.number.int({ min: undefined, max: undefined }),
    user_login: faker.word.sample(),
    user_nicename: faker.word.sample(),
  })),
  ...overrideResponse,
});

export const getBackupCreateV3ResponseMock = (
  overrideResponse: Partial<BackupCreateV3200> = {},
): BackupCreateV3200 => ({
  message: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  tracking_id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupRestoreV3ResponseMock = (
  overrideResponse: Partial<BackupRestoreV3200> = {},
): BackupRestoreV3200 => ({
  client_tracking_id: faker.word.sample(),
  ...overrideResponse,
});

export const getBackupListV3ResponseMock = (
  overrideResponse: Partial<BackupListV3200> = {},
): BackupListV3200 => ({
  has_more: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      backup_creation_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      backup_expiration_time: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.word.sample(),
          faker.number.int({ min: undefined, max: undefined }),
        ]),
        undefined,
      ]),
      backup_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      backup_reason: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      backup_size_bytes: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      backup_status: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      backup_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      databases: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      dc_location: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      exclude_paths: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      paths: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.word.sample()),
        undefined,
      ]),
      schedule_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      timezone: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  offset: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getBackupStatusV3ResponseMock = (
  overrideResponse: Partial<BackupStatusV3200> = {},
): BackupStatusV3200 => ({
  backup_download_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  backups_deletion_status: faker.helpers.arrayElement([{}, undefined]),
  cbs_action: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  cbs_event_processing: faker.helpers.arrayElement([
    {
      action: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      backup_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      plan_type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.helpers.arrayElement(['free', 'premium'] as const),
          null,
        ]),
        undefined,
      ]),
      site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      snapshot_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  cbs_execution_phase: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  cbs_internal_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  client_tracking_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  current_state_backup_download_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  current_state_backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  execution_progress: faker.helpers.arrayElement([
    {
      stages_completed: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      total_stages: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  freed_up_bytes: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  progress_percentage: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  restored_from_backup_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  tracking_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getHostingSiteAddV3ResponseMock = (
  overrideResponse: Partial<HostingSiteAddV3200> = {},
): HostingSiteAddV3200 => ({
  id: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  ...overrideResponse,
});

export const getSshKeyImportV3ResponseMock = (
  overrideResponse: Partial<SshKeyImportV3200> = {},
): SshKeyImportV3200 => ({
  public_key_name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSshKeyListV3ResponseMock = (
  overrideResponse: Partial<SshKeyListV3200> = {},
): SshKeyListV3200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      authorize: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      mtime: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesListV3ResponseMock = (
  overrideResponse: Partial<SitesListV3200> = {},
): SitesListV3200 => ({
  grouped_items: faker.helpers.arrayElement([
    {
      [faker.string.alphanumeric(5)]: Array.from(
        { length: faker.number.int({ min: 1, max: 10 }) },
        (_, i) => i + 1,
      ).map(() => ({
        account_back_ref: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        account_id: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        account_status: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        base_domain: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        brand_protection_clicked: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        confirmed: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        datacenter: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        date_added: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        date_modified: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        detected_type: faker.helpers.arrayElement([
          faker.word.sample(),
          undefined,
        ]),
        docpath: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        docroot: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        domain: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        domain_ptrs: faker.helpers.arrayElement([
          Array.from(
            { length: faker.number.int({ min: 1, max: 10 }) },
            (_, i) => i + 1,
          ).map(() => ({})),
          undefined,
        ]),
        edge_cache: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        handler_404: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        has_woocommerce: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        install_blu_ai: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        install_blu_ai_store: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        installed_id: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        is_primary: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        jobs: faker.helpers.arrayElement([{}, undefined]),
        last_error: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        migration_id: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        name: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        onboarding: faker.helpers.arrayElement([
          faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            null,
          ]),
          undefined,
        ]),
        onboarding_call_clicked: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        options: faker.helpers.arrayElement([
          {
            nfd_origin_prompt: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            site_description: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            site_title: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
          },
          undefined,
        ]),
        pagespeed: faker.helpers.arrayElement([
          {
            lastrun: faker.helpers.arrayElement([
              faker.word.sample(),
              undefined,
            ]),
            performance: faker.helpers.arrayElement([
              faker.word.sample(),
              undefined,
            ]),
            strategy: faker.helpers.arrayElement([
              faker.word.sample(),
              undefined,
            ]),
          },
          undefined,
        ]),
        parent_back_ref: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        path: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        pending_url: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        pending_url_data: faker.helpers.arrayElement([
          {
            base_domain: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            domain: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            domain_id: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            error: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            is_temp: faker.helpers.arrayElement([
              faker.datatype.boolean(),
              undefined,
            ]),
            job_failed: faker.helpers.arrayElement([
              faker.datatype.boolean(),
              undefined,
            ]),
            stage: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            wp_session: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
          },
          undefined,
        ]),
        php_version: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        pro_services_clicked: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        resources: faker.helpers.arrayElement([
          {
            storage: faker.helpers.arrayElement([
              {
                available: faker.helpers.arrayElement([
                  faker.helpers.arrayElement([
                    faker.number.int({ min: undefined, max: undefined }),
                    null,
                  ]),
                  undefined,
                ]),
                total: faker.helpers.arrayElement([
                  faker.helpers.arrayElement([
                    faker.number.int({ min: undefined, max: undefined }),
                    null,
                  ]),
                  undefined,
                ]),
                unit: faker.helpers.arrayElement([
                  faker.word.sample(),
                  undefined,
                ]),
                used: faker.helpers.arrayElement([
                  faker.helpers.arrayElement([
                    faker.number.int({ min: undefined, max: undefined }),
                    null,
                  ]),
                  undefined,
                ]),
              },
              undefined,
            ]),
            workers: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
          },
          undefined,
        ]),
        staging: faker.helpers.arrayElement([
          {
            parent_site_id: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            promoted_from: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            promoting_from: faker.helpers.arrayElement([
              faker.helpers.arrayElement([
                faker.number.int({ min: undefined, max: undefined }),
                null,
              ]),
              undefined,
            ]),
            promotion_status: faker.helpers.arrayElement([
              faker.helpers.arrayElement([faker.word.sample(), null]),
              undefined,
            ]),
            sites: faker.helpers.arrayElement([
              Array.from(
                { length: faker.number.int({ min: 1, max: 10 }) },
                (_, i) => i + 1,
              ).map(() => faker.number.int({ min: undefined, max: undefined })),
              undefined,
            ]),
          },
          undefined,
        ]),
        status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        subtype: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        tenweb_upgrade_date: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
        url: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        url_is_provisional: faker.helpers.arrayElement([
          faker.datatype.boolean(),
          undefined,
        ]),
        version: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
        version_ptr: faker.helpers.arrayElement([
          faker.helpers.arrayElement([faker.word.sample(), null]),
          undefined,
        ]),
      })),
    },
    undefined,
  ]),
  items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      account_back_ref: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      account_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      brand_protection_clicked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      confirmed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      datacenter: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      date_modified: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      detected_type: faker.helpers.arrayElement([
        faker.word.sample(),
        undefined,
      ]),
      docpath: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      docroot: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain_ptrs: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => ({})),
        undefined,
      ]),
      edge_cache: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      handler_404: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      has_woocommerce: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      install_blu_ai: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      install_blu_ai_store: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      installed_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_primary: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      jobs: faker.helpers.arrayElement([{}, undefined]),
      last_error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      migration_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      onboarding: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      onboarding_call_clicked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      options: faker.helpers.arrayElement([
        {
          nfd_origin_prompt: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          site_description: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          site_title: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      pagespeed: faker.helpers.arrayElement([
        {
          lastrun: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          performance: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
          strategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined,
          ]),
        },
        undefined,
      ]),
      parent_back_ref: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      path: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pending_url_data: faker.helpers.arrayElement([
        {
          base_domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          domain_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          error: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          is_temp: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          job_failed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          stage: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          wp_session: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
        },
        undefined,
      ]),
      php_version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      pro_services_clicked: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      resources: faker.helpers.arrayElement([
        {
          storage: faker.helpers.arrayElement([
            {
              available: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              total: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
              unit: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined,
              ]),
              used: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                  faker.number.int({ min: undefined, max: undefined }),
                  null,
                ]),
                undefined,
              ]),
            },
            undefined,
          ]),
          workers: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      staging: faker.helpers.arrayElement([
        {
          parent_site_id: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoted_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promoting_from: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          promotion_status: faker.helpers.arrayElement([
            faker.helpers.arrayElement([faker.word.sample(), null]),
            undefined,
          ]),
          sites: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1,
            ).map(() => faker.number.int({ min: undefined, max: undefined })),
            undefined,
          ]),
        },
        undefined,
      ]),
      status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      subtype: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      tenweb_upgrade_date: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      url: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      url_is_provisional: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      version: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      version_ptr: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    })),
    undefined,
  ]),
  limit: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  page: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  pages: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  rows: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  total: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSitesInfoV3ResponseMock = (
  overrideResponse: Partial<SiteInfoResponseModelV2> = {},
): SiteInfoResponseModelV2 => ({
  account_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  account_id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  account_status: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  base_domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  brand_protection_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  confirmed: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  datacenter: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  date_added: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  date_modified: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  detected_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  docpath: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  docroot: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  domain_ptrs: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({})),
    undefined,
  ]),
  edge_cache: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  handler_404: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  has_woocommerce: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  id: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  install_blu_ai: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  install_blu_ai_store: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  installed_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  is_primary: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  jobs: faker.helpers.arrayElement([{}, undefined]),
  last_error: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  migration_id: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  name: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  onboarding: faker.helpers.arrayElement([
    faker.helpers.arrayElement([
      faker.number.int({ min: undefined, max: undefined }),
      null,
    ]),
    undefined,
  ]),
  onboarding_call_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  options: faker.helpers.arrayElement([
    {
      nfd_origin_prompt: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_description: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      site_title: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  pagespeed: faker.helpers.arrayElement([
    {
      lastrun: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      performance: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      strategy: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    },
    undefined,
  ]),
  parent_back_ref: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  path: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pending_url_data: faker.helpers.arrayElement([
    {
      base_domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      domain_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      error: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      is_temp: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      job_failed: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      stage: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      wp_session: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
    },
    undefined,
  ]),
  php_version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  pro_services_clicked: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  resources: faker.helpers.arrayElement([
    {
      storage: faker.helpers.arrayElement([
        {
          available: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          total: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
          unit: faker.helpers.arrayElement([faker.word.sample(), undefined]),
          used: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
              faker.number.int({ min: undefined, max: undefined }),
              null,
            ]),
            undefined,
          ]),
        },
        undefined,
      ]),
      workers: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
    },
    undefined,
  ]),
  staging: faker.helpers.arrayElement([
    {
      parent_site_id: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoted_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promoting_from: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
        undefined,
      ]),
      promotion_status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([faker.word.sample(), null]),
        undefined,
      ]),
      sites: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1,
        ).map(() => faker.number.int({ min: undefined, max: undefined })),
        undefined,
      ]),
    },
    undefined,
  ]),
  status: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  subtype: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  tenweb_upgrade_date: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  url: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  url_is_provisional: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  version: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  version_ptr: faker.helpers.arrayElement([
    faker.helpers.arrayElement([faker.word.sample(), null]),
    undefined,
  ]),
  ...overrideResponse,
});

export const getSshKeyListV4ResponseMock = (
  overrideResponse: Partial<SshKeyListV4200> = {},
): SshKeyListV4200 => ({
  rows: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1,
    ).map(() => ({
      alg_type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      authorize: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      created_at: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      name: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      pubkey: faker.helpers.arrayElement([faker.word.sample(), undefined]),
      remote: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
      type: faker.helpers.arrayElement([faker.word.sample(), undefined]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getAccountEventListMockHandler = (
  overrideResponse?:
    | AccountEventList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountEventList200> | AccountEventList200),
) => {
  return http.get('*/v1/account/events', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountEventListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountFeaturesMockHandler = (
  overrideResponse?:
    | AccountFeatures200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountFeatures200> | AccountFeatures200),
) => {
  return http.get('*/v1/account/features', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountFeaturesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountHostingListMockHandler = (
  overrideResponse?:
    | AccountHostingList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountHostingList200> | AccountHostingList200),
) => {
  return http.get('*/v1/account/hosting', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountHostingListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPublicKeysMockHandler = (
  overrideResponse?:
    | AccountPublicKeys200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountPublicKeys200> | AccountPublicKeys200),
) => {
  return http.get('*/v1/account/public-keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountPublicKeysResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPublicKeyCreateMockHandler = (
  overrideResponse?:
    | AccountPublicKeyCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AccountPublicKeyCreate200> | AccountPublicKeyCreate200),
) => {
  return http.post('*/v1/account/public-keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountPublicKeyCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPublicKeyMockHandler = (
  overrideResponse?:
    | AccountPublicKey200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountPublicKey200> | AccountPublicKey200),
) => {
  return http.get('*/v1/account/public-keys/:publicKeyId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountPublicKeyResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPublicKeyToggleMockHandler = (
  overrideResponse?:
    | AccountPublicKeyToggle200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AccountPublicKeyToggle200> | AccountPublicKeyToggle200),
) => {
  return http.post('*/v1/account/public-keys/:publicKeyId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountPublicKeyToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPublicKeyDeleteMockHandler = (
  overrideResponse?:
    | AccountPublicKeyDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<AccountPublicKeyDelete200> | AccountPublicKeyDelete200),
) => {
  return http.delete('*/v1/account/public-keys/:publicKeyId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountPublicKeyDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountAddonListMockHandler = (
  overrideResponse?:
    | AccountAddonList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountAddonList200> | AccountAddonList200),
) => {
  return http.get('*/v1/account/:accountId/addons', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountAddonListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardBackupListMockHandler = (
  overrideResponse?:
    | CodeguardBackupList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CodeguardBackupList200> | CodeguardBackupList200),
) => {
  return http.get('*/v1/addons/codeguard/:addonId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardBackupListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardBackupCreateMockHandler = (
  overrideResponse?:
    | CodeguardBackupCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<CodeguardBackupCreate200> | CodeguardBackupCreate200),
) => {
  return http.post('*/v1/addons/codeguard/:addonId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardBackupCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardBackupDownloadMockHandler = (
  overrideResponse?:
    | CodeguardBackupDownload200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<CodeguardBackupDownload200> | CodeguardBackupDownload200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/backups/download',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardBackupDownloadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardBackupRestoreMockHandler = (
  overrideResponse?:
    | CodeguardBackupRestore200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<CodeguardBackupRestore200> | CodeguardBackupRestore200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/backups/restore',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardBackupRestoreResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardDatabaseListMockHandler = (
  overrideResponse?:
    | CodeguardDatabaseList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CodeguardDatabaseList200> | CodeguardDatabaseList200),
) => {
  return http.get('*/v1/addons/codeguard/:addonId/databases', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardDatabaseListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardDatabaseBackupListMockHandler = (
  overrideResponse?:
    | CodeguardDatabaseBackupList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<CodeguardDatabaseBackupList200>
        | CodeguardDatabaseBackupList200),
) => {
  return http.get(
    '*/v1/addons/codeguard/:addonId/databases/backups',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardDatabaseBackupListResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardDatabaseBackupCreateMockHandler = (
  overrideResponse?:
    | CodeguardDatabaseBackupCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<CodeguardDatabaseBackupCreate200>
        | CodeguardDatabaseBackupCreate200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/databases/backups',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardDatabaseBackupCreateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardDatabaseBackupRestoreMockHandler = (
  overrideResponse?:
    | CodeguardDatabaseBackupRestore200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<CodeguardDatabaseBackupRestore200>
        | CodeguardDatabaseBackupRestore200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/databases/backups/restore',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardDatabaseBackupRestoreResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardLoginLinkMockHandler = (
  overrideResponse?:
    | CodeguardLoginLink200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CodeguardLoginLink200> | CodeguardLoginLink200),
) => {
  return http.get('*/v1/addons/codeguard/:addonId/login', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardLoginLinkResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardPlanInfoMockHandler = (
  overrideResponse?:
    | CodeguardPlanInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CodeguardPlanInfo200> | CodeguardPlanInfo200),
) => {
  return http.get('*/v1/addons/codeguard/:addonId/plan', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardPlanInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardWebsiteListMockHandler = (
  overrideResponse?:
    | CodeguardWebsiteList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CodeguardWebsiteList200> | CodeguardWebsiteList200),
) => {
  return http.get('*/v1/addons/codeguard/:addonId/websites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCodeguardWebsiteListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCodeguardWebsiteBackupListMockHandler = (
  overrideResponse?:
    | CodeguardWebsiteBackupList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<CodeguardWebsiteBackupList200>
        | CodeguardWebsiteBackupList200),
) => {
  return http.get(
    '*/v1/addons/codeguard/:addonId/websites/backups',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardWebsiteBackupListResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardWebsiteBackupCreateMockHandler = (
  overrideResponse?:
    | CodeguardWebsiteBackupCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<CodeguardWebsiteBackupCreate200>
        | CodeguardWebsiteBackupCreate200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/websites/backups',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardWebsiteBackupCreateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getCodeguardWebsiteBackupRestoreMockHandler = (
  overrideResponse?:
    | CodeguardWebsiteBackupRestore200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<CodeguardWebsiteBackupRestore200>
        | CodeguardWebsiteBackupRestore200),
) => {
  return http.post(
    '*/v1/addons/codeguard/:addonId/websites/backups/restore',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCodeguardWebsiteBackupRestoreResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getAddonsSitelockSsoMockHandler = (
  overrideResponse?:
    | AddonsSitelockSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsSitelockSso200> | AddonsSitelockSso200),
) => {
  return http.get('*/v1/addons/sitelock/:addonId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsSitelockSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getXcitiumBackupListMockHandler = (
  overrideResponse?:
    | XcitiumBackupList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<XcitiumBackupList200> | XcitiumBackupList200),
) => {
  return http.get('*/v1/addons/xcitium/:addonId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getXcitiumBackupListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getXcitiumBackupCreateMockHandler = (
  overrideResponse?:
    | XcitiumBackupCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<XcitiumBackupCreate200> | XcitiumBackupCreate200),
) => {
  return http.post('*/v1/addons/xcitium/:addonId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getXcitiumBackupCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getXcitiumBackupDownloadMockHandler = (
  overrideResponse?:
    | XcitiumBackupDownload200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<XcitiumBackupDownload200> | XcitiumBackupDownload200),
) => {
  return http.post(
    '*/v1/addons/xcitium/:addonId/backups/download',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getXcitiumBackupDownloadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getXcitiumBackupRestoreMockHandler = (
  overrideResponse?:
    | XcitiumBackupRestore200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<XcitiumBackupRestore200> | XcitiumBackupRestore200),
) => {
  return http.post(
    '*/v1/addons/xcitium/:addonId/backups/restore',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getXcitiumBackupRestoreResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getXcitiumPlanInfoMockHandler = (
  overrideResponse?:
    | XcitiumPlanInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<XcitiumPlanInfo200> | XcitiumPlanInfo200),
) => {
  return http.get('*/v1/addons/xcitium/:addonId/plan', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getXcitiumPlanInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getXcitiumSsoMockHandler = (
  overrideResponse?:
    | XcitiumSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<XcitiumSso200> | XcitiumSso200),
) => {
  return http.get('*/v1/addons/xcitium/:addonId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getXcitiumSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupInitiateMockHandler = (
  overrideResponse?:
    | BackupInitiate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupInitiate200> | BackupInitiate200),
) => {
  return http.post('*/v1/addons/:addonId/backup', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupInitiateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupStatusMockHandler = (
  overrideResponse?:
    | BackupStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupStatus200> | BackupStatus200),
) => {
  return http.get('*/v1/addons/:addonId/backup', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupListMockHandler = (
  overrideResponse?:
    | BackupList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupList200> | BackupList200),
) => {
  return http.get('*/v1/addons/:addonId/backup/list', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupMetaMockHandler = (
  overrideResponse?:
    | BackupMeta200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupMeta200> | BackupMeta200),
) => {
  return http.get('*/v1/addons/:addonId/backup/meta', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupMetaResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupCreateOndemandV1MockHandler = (
  overrideResponse?:
    | BackupCreateOndemandV1200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupCreateOndemandV1200> | BackupCreateOndemandV1200),
) => {
  return http.post(
    '*/v1/addons/:addonId/backup/sites/:siteId/create',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupCreateOndemandV1ResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupCustomDeleteV1MockHandler = (
  overrideResponse?:
    | BackupCustomDeleteV1200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupCustomDeleteV1200> | BackupCustomDeleteV1200),
) => {
  return http.post(
    '*/v1/addons/:addonId/backup/sites/:siteId/delete',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupCustomDeleteV1ResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupSettingsMockHandler = (
  overrideResponse?:
    | BackupSettings200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupSettings200> | BackupSettings200),
) => {
  return http.get(
    '*/v1/addons/:addonId/backup/sites/:siteId/settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupSettingsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupSettingsCreateMockHandler = (
  overrideResponse?:
    | BackupSettingsCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupSettingsCreate200> | BackupSettingsCreate200),
) => {
  return http.post(
    '*/v1/addons/:addonId/backup/sites/:siteId/settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupSettingsCreateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupSettingsUpdateMockHandler = (
  overrideResponse?:
    | BackupSettingsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<BackupSettingsUpdate200> | BackupSettingsUpdate200),
) => {
  return http.put(
    '*/v1/addons/:addonId/backup/sites/:siteId/settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupSettingsUpdateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupPrefSetStatusMockHandler = (
  overrideResponse?:
    | BackupPrefSetStatus200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<BackupPrefSetStatus200> | BackupPrefSetStatus200),
) => {
  return http.put(
    '*/v1/addons/:addonId/backup/sites/:siteId/settings/status',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupPrefSetStatusResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupUsageMockHandler = (
  overrideResponse?:
    | BackupUsage200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupUsage200> | BackupUsage200),
) => {
  return http.get('*/v1/addons/:addonId/backup/usage', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupUsageResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsCloudflareMockHandler = (
  overrideResponse?:
    | AddonsCloudflare200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<AddonsCloudflare200> | AddonsCloudflare200),
) => {
  return http.delete('*/v1/addons/:addonId/cloudflare', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsCloudflareResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsCloudflareExternalNsCheckMockHandler = (
  overrideResponse?:
    | AddonsCloudflareExternalNsCheck200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<AddonsCloudflareExternalNsCheck200>
        | AddonsCloudflareExternalNsCheck200),
) => {
  return http.get(
    '*/v1/addons/:addonId/cloudflare/external-ns-check',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAddonsCloudflareExternalNsCheckResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getAddonsInfoMockHandler = (
  overrideResponse?:
    | AddonsInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsInfo200> | AddonsInfo200),
) => {
  return http.get('*/v1/addons/:addonId/info', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsJetpackValidateMockHandler = (
  overrideResponse?:
    | AddonsJetpackValidate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddonsJetpackValidate200> | AddonsJetpackValidate200),
) => {
  return http.post('*/v1/addons/:addonId/jetpack/validate', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsJetpackValidateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsLlmBalanceMockHandler = (
  overrideResponse?:
    | AddonsLlmBalance200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsLlmBalance200> | AddonsLlmBalance200),
) => {
  return http.get('*/v1/addons/:addonId/llm/balance', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsLlmBalanceResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsLlmKeysMockHandler = (
  overrideResponse?:
    | AddonsLlmKeys200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsLlmKeys200> | AddonsLlmKeys200),
) => {
  return http.get('*/v1/addons/:addonId/llm/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsLlmKeysResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsLlmKeysCreateMockHandler = (
  overrideResponse?:
    | AddonsLlmKeysCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddonsLlmKeysCreate200> | AddonsLlmKeysCreate200),
) => {
  return http.post('*/v1/addons/:addonId/llm/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsLlmKeysCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsLlmKeysDeleteMockHandler = (
  overrideResponse?:
    | AddonsLlmKeysDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<AddonsLlmKeysDelete200> | AddonsLlmKeysDelete200),
) => {
  return http.delete('*/v1/addons/:addonId/llm/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsLlmKeysDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getMonarxAddonSealGenerationMockHandler = (
  overrideResponse?:
    | MonarxAddonSealGeneration200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<MonarxAddonSealGeneration200>
        | MonarxAddonSealGeneration200),
) => {
  return http.get('*/v1/addons/:addonId/monarx/generate_seal', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getMonarxAddonSealGenerationResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getMonarxAddonReportUrlMockHandler = (
  overrideResponse?:
    | MonarxAddonReportUrl200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<MonarxAddonReportUrl200> | MonarxAddonReportUrl200),
) => {
  return http.get('*/v1/addons/:addonId/monarx/report_url', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getMonarxAddonReportUrlResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsSpamexpertsDomainAssignMockHandler = (
  overrideResponse?:
    | AddonsSpamexpertsDomainAssign200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<AddonsSpamexpertsDomainAssign200>
        | AddonsSpamexpertsDomainAssign200),
) => {
  return http.post(
    '*/v1/addons/:addonId/spamexperts/domain/assign',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAddonsSpamexpertsDomainAssignResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getAddonsSpamexpertsSsoMockHandler = (
  overrideResponse?:
    | AddonsSpamexpertsSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsSpamexpertsSso200> | AddonsSpamexpertsSso200),
) => {
  return http.get('*/v1/addons/:addonId/spamexperts/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsSpamexpertsSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsSyncMockHandler = (
  overrideResponse?:
    | AddonsSync200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsSync200> | AddonsSync200),
) => {
  return http.get('*/v1/addons/:addonId/sync', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsSyncResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getWebzaiSsoMockHandler = (
  overrideResponse?:
    | WebzaiSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<WebzaiSso200> | WebzaiSso200),
) => {
  return http.get('*/v1/addons/:addonId/webzai/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getWebzaiSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getWeeblySsoMockHandler = (
  overrideResponse?:
    | WeeblySso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<WeeblySso200> | WeeblySso200),
) => {
  return http.get('*/v1/addons/:addonId/weebly/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getWeeblySsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsWorkflowsMockHandler = (
  overrideResponse?:
    | AddonsWorkflows200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsWorkflows200> | AddonsWorkflows200),
) => {
  return http.get('*/v1/addons/:addonId/workflows', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsWorkflowsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAnnouncementsMockHandler = (
  overrideResponse?:
    | Announcements200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<Announcements200> | Announcements200),
) => {
  return http.get('*/v1/announcements', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAnnouncementsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBullhornAnnouncementsMockHandler = (
  overrideResponse?:
    | BullhornAnnouncements200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BullhornAnnouncements200> | BullhornAnnouncements200),
) => {
  return http.get('*/v1/announcements/bullhorn', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBullhornAnnouncementsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainInfoMockHandler = (
  overrideResponse?:
    | DomainInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainInfo200> | DomainInfo200),
) => {
  return http.get('*/v1/domains/:domainId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainCertsMockHandler = (
  overrideResponse?:
    | DomainCerts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainCerts200> | DomainCerts200),
) => {
  return http.get('*/v1/domains/:domainId/certs', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainCertsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainCertInstallMockHandler = (
  overrideResponse?:
    | DomainCertInstall200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainCertInstall200> | DomainCertInstall200),
) => {
  return http.post('*/v1/domains/:domainId/certs', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainCertInstallResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainCertUpdateMockHandler = (
  overrideResponse?:
    | DomainCertUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<DomainCertUpdate200> | DomainCertUpdate200),
) => {
  return http.put('*/v1/domains/:domainId/certs', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainCertUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainCertUninstallMockHandler = (
  overrideResponse?:
    | DomainCertUninstall200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DomainCertUninstall200> | DomainCertUninstall200),
) => {
  return http.delete('*/v1/domains/:domainId/certs', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainCertUninstallResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnseditorMockHandler = (
  overrideResponse?:
    | DomainDnseditor200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DomainDnseditor200> | DomainDnseditor200),
) => {
  return http.delete('*/v1/domains/:domainId/dns-editor', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainDnseditorResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnseditorListMockHandler = (
  overrideResponse?:
    | DomainDnseditorList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainDnseditorList200> | DomainDnseditorList200),
) => {
  return http.get('*/v1/domains/:domainId/dns-editor', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainDnseditorListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnseditorAddMockHandler = (
  overrideResponse?:
    | DomainDnseditorAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainDnseditorAdd200> | DomainDnseditorAdd200),
) => {
  return http.post('*/v1/domains/:domainId/dns-editor', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainDnseditorAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnseditorEditMockHandler = (
  overrideResponse?:
    | DomainDnseditorEdit200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<DomainDnseditorEdit200> | DomainDnseditorEdit200),
) => {
  return http.put('*/v1/domains/:domainId/dns-editor', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainDnseditorEditResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnszoneResetMockHandler = (
  overrideResponse?:
    | DomainDnszoneReset200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainDnszoneReset200> | DomainDnszoneReset200),
) => {
  return http.get('*/v1/domains/:domainId/dns-zone-reset', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainDnszoneResetResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainEmailDeliverabilityMockHandler = (
  overrideResponse?:
    | DomainEmailDeliverability200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<DomainEmailDeliverability200>
        | DomainEmailDeliverability200),
) => {
  return http.get(
    '*/v1/domains/:domainId/email-deliverability',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDomainEmailDeliverabilityResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDomainsEntriLastSuccessMockHandler = (
  overrideResponse?:
    | DomainsEntriLastSuccess200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainsEntriLastSuccess200> | DomainsEntriLastSuccess200),
) => {
  return http.post(
    '*/v1/domains/:domainId/entri/last-success',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDomainsEntriLastSuccessResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDomainsSetEntriUsedMockHandler = (
  overrideResponse?:
    | DomainsSetEntriUsed200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainsSetEntriUsed200> | DomainsSetEntriUsed200),
) => {
  return http.post('*/v1/domains/:domainId/entri/used', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainsSetEntriUsedResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainsUnsetEntriUsedMockHandler = (
  overrideResponse?:
    | DomainsUnsetEntriUsed200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DomainsUnsetEntriUsed200> | DomainsUnsetEntriUsed200),
) => {
  return http.delete('*/v1/domains/:domainId/entri/used', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainsUnsetEntriUsedResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainHealthMockHandler = (
  overrideResponse?:
    | DomainHealth200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainHealth200> | DomainHealth200),
) => {
  return http.get('*/v1/domains/:domainId/health', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainHealthResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccessLogsMockHandler = (
  overrideResponse?:
    | AccessLogs200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccessLogs200> | AccessLogs200),
) => {
  return http.get('*/v1/domains/:domainId/logs/access', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccessLogsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainResourceRecordsMockHandler = (
  overrideResponse?:
    | DomainResourceRecords200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainResourceRecords200> | DomainResourceRecords200),
) => {
  return http.get('*/v1/domains/:domainId/resource-records', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainResourceRecordsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUpdateDomainResourceRecordsMockHandler = (
  overrideResponse?:
    | UpdateDomainResourceRecords200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<UpdateDomainResourceRecords200>
        | UpdateDomainResourceRecords200),
) => {
  return http.put('*/v1/domains/:domainId/resource-records', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUpdateDomainResourceRecordsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainUnassignMockHandler = (
  overrideResponse?:
    | DomainUnassign200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainUnassign200> | DomainUnassign200),
) => {
  return http.post('*/v1/domains/:domainId/unassign', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainUnassignResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainZoneeditorUrlMockHandler = (
  overrideResponse?:
    | DomainZoneeditorUrl200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainZoneeditorUrl200> | DomainZoneeditorUrl200),
) => {
  return http.get('*/v1/domains/:domainId/zoneeditor-url', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainZoneeditorUrlResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getEntriJwtMockHandler = (
  overrideResponse?:
    | EntriJwt200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<EntriJwt200> | EntriJwt200),
) => {
  return http.get('*/v1/entri/jwt', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getEntriJwtResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAccountMockHandler = (
  overrideResponse?:
    | HostingAccount200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAccount200> | HostingAccount200),
) => {
  return http.get('*/v1/hosting/:hostingId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAccountResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getActivityLogMockHandler = (
  overrideResponse?:
    | ActivityLog200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ActivityLog200> | ActivityLog200),
) => {
  return http.get('*/v1/hosting/:hostingId/activity-log', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getActivityLogResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAddonsMockHandler = (
  overrideResponse?:
    | HostingAddons200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAddons200> | HostingAddons200),
) => {
  return http.get('*/v1/hosting/:hostingId/addons', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAddonsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedConsoleMockHandler = (
  overrideResponse?:
    | HostingAdvancedConsole200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedConsole200> | HostingAdvancedConsole200),
) => {
  return http.get('*/v1/hosting/:hostingId/advanced/console', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedConsoleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedDnsMockHandler = (
  overrideResponse?:
    | HostingAdvancedDns200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedDns200> | HostingAdvancedDns200),
) => {
  return http.get('*/v1/hosting/:hostingId/advanced/dns', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedDnsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedDnsUpdateMockHandler = (
  overrideResponse?:
    | HostingAdvancedDnsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingAdvancedDnsUpdate200> | HostingAdvancedDnsUpdate200),
) => {
  return http.post('*/v1/hosting/:hostingId/advanced/dns', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedDnsUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedDomainServicesCheckMockHandler = (
  overrideResponse?:
    | HostingAdvancedDomainServicesCheck200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingAdvancedDomainServicesCheck200>
        | HostingAdvancedDomainServicesCheck200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/advanced/domain/services',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingAdvancedDomainServicesCheckResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingAdvancedDomainServicesMockHandler = (
  overrideResponse?:
    | HostingAdvancedDomainServices200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<HostingAdvancedDomainServices200>
        | HostingAdvancedDomainServices200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/advanced/domain/services',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingAdvancedDomainServicesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingAdvancedImagesMockHandler = (
  overrideResponse?:
    | HostingAdvancedImages200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedImages200> | HostingAdvancedImages200),
) => {
  return http.get('*/v1/hosting/:hostingId/advanced/images', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedImagesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedServerMockHandler = (
  overrideResponse?:
    | HostingAdvancedServer200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedServer200> | HostingAdvancedServer200),
) => {
  return http.get('*/v1/hosting/:hostingId/advanced/server', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedServerResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedServerStatusMockHandler = (
  overrideResponse?:
    | HostingAdvancedServerStatus200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingAdvancedServerStatus200>
        | HostingAdvancedServerStatus200),
) => {
  return http.put('*/v1/hosting/:hostingId/advanced/server', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedServerStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedServerHealthcheckMockHandler = (
  overrideResponse?:
    | HostingAdvancedServerHealthcheck200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingAdvancedServerHealthcheck200>
        | HostingAdvancedServerHealthcheck200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/advanced/server/healthcheck',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingAdvancedServerHealthcheckResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingAdvancedPasswordMockHandler = (
  overrideResponse?:
    | HostingAdvancedPassword200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<HostingAdvancedPassword200> | HostingAdvancedPassword200),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/advanced/server/password',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingAdvancedPasswordResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingAdvancedSsoWhmMockHandler = (
  overrideResponse?:
    | HostingAdvancedSsoWhm200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedSsoWhm200> | HostingAdvancedSsoWhm200),
) => {
  return http.get('*/v1/hosting/:hostingId/advanced/sso_whm', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedSsoWhmResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedSystemConsoleMockHandler = (
  overrideResponse?:
    | HostingAdvancedSystemConsole200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingAdvancedSystemConsole200>
        | HostingAdvancedSystemConsole200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/advanced/system-console',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingAdvancedSystemConsoleResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationsListMockHandler = (
  overrideResponse?:
    | HostingApplicationListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationListResponse>
        | HostingApplicationListResponse),
) => {
  return http.get('*/v1/hosting/:hostingId/applications/', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingApplicationsListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingApplicationGetMockHandler = (
  overrideResponse?:
    | HostingApplicationOverviewResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationOverviewResponse>
        | HostingApplicationOverviewResponse),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/applications/:applicationId/',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationGetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationDeleteMockHandler = (
  overrideResponse?:
    | HostingApplicationDeleteResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingApplicationDeleteResponse>
        | HostingApplicationDeleteResponse),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/applications/:applicationId/',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationDeleteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationConfigGetMockHandler = (
  overrideResponse?:
    | HostingApplicationConfigResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationConfigResponse>
        | HostingApplicationConfigResponse),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/applications/:applicationId/config',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationConfigGetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationConfigSetMockHandler = (
  overrideResponse?:
    | HostingConfigMutationResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingConfigMutationResponse>
        | HostingConfigMutationResponse),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/applications/:applicationId/config/:name',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationConfigSetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationConfigDeleteMockHandler = (
  overrideResponse?:
    | HostingConfigMutationResponse
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingConfigMutationResponse>
        | HostingConfigMutationResponse),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/applications/:applicationId/config/:name',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationConfigDeleteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationDeploymentsListMockHandler = (
  overrideResponse?:
    | HostingApplicationDeploymentHistoryResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationDeploymentHistoryResponse>
        | HostingApplicationDeploymentHistoryResponse),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/applications/:applicationId/deployments',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationDeploymentsListResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationRedeployMockHandler = (
  overrideResponse?:
    | HostingRedeployResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingRedeployResponse> | HostingRedeployResponse),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/applications/:applicationId/deployments',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationRedeployResponseMock(),
        ),
        { status: 202, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationDeploymentGetMockHandler = (
  overrideResponse?:
    | HostingApplicationDeploymentDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationDeploymentDetailResponse>
        | HostingApplicationDeploymentDetailResponse),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/applications/:applicationId/deployments/:deploymentId',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationDeploymentGetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationDeploymentLogsGetMockHandler = (
  overrideResponse?:
    | HostingApplicationDeploymentLogsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingApplicationDeploymentLogsResponse>
        | HostingApplicationDeploymentLogsResponse),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/applications/:applicationId/deployments/:deploymentId/logs',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationDeploymentLogsGetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationDeploymentRollbackMockHandler = (
  overrideResponse?:
    | HostingRollbackResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingRollbackResponse> | HostingRollbackResponse),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/applications/:applicationId/deployments/:deploymentId/rollback',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationDeploymentRollbackResponseMock(),
        ),
        { status: 202, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingApplicationHostnamesPutMockHandler = (
  overrideResponse?:
    | HostingApplicationHostnamesResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingApplicationHostnamesResponse>
        | HostingApplicationHostnamesResponse),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/applications/:applicationId/hostnames',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingApplicationHostnamesPutResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingBackupsMockHandler = (
  overrideResponse?:
    | HostingBackups200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingBackups200> | HostingBackups200),
) => {
  return http.get('*/v1/hosting/:hostingId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingBackupsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingCapabilitiesMockHandler = (
  overrideResponse?:
    | HostingCapabilities200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingCapabilities200> | HostingCapabilities200),
) => {
  return http.get('*/v1/hosting/:hostingId/capabilities', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingCapabilitiesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getListCronsMockHandler = (
  overrideResponse?:
    | ListCrons200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ListCrons200> | ListCrons200),
) => {
  return http.get('*/v1/hosting/:hostingId/crontab', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getListCronsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddCronMockHandler = (
  overrideResponse?:
    | AddCron200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddCron200> | AddCron200),
) => {
  return http.post('*/v1/hosting/:hostingId/crontab', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddCronResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUpdateCronMockHandler = (
  overrideResponse?:
    | UpdateCron200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<UpdateCron200> | UpdateCron200),
) => {
  return http.put('*/v1/hosting/:hostingId/crontab', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUpdateCronResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCronMockHandler = (
  overrideResponse?:
    | Cron200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<Cron200> | Cron200),
) => {
  return http.delete('*/v1/hosting/:hostingId/crontab', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCronResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCronLastRunMockHandler = (
  overrideResponse?:
    | CronLastRun200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<CronLastRun200> | CronLastRun200),
) => {
  return http.get('*/v1/hosting/:hostingId/crontab/last-run', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCronLastRunResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbAddMockHandler = (
  overrideResponse?:
    | DbAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DbAdd200> | DbAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/db', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbMockHandler = (
  overrideResponse?:
    | Db200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<Db200> | Db200),
) => {
  return http.delete('*/v1/hosting/:hostingId/db', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingDbAuthorizedHostsMockHandler = (
  overrideResponse?:
    | HostingDbAuthorizedHosts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingDbAuthorizedHosts200> | HostingDbAuthorizedHosts200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/db/authorized-hosts',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingDbAuthorizedHostsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingDbAuthorizedHostsAddMockHandler = (
  overrideResponse?:
    | HostingDbAuthorizedHostsAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<HostingDbAuthorizedHostsAdd200>
        | HostingDbAuthorizedHostsAdd200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/db/authorized-hosts',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingDbAuthorizedHostsAddResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingDbAuthorizedHostsUpdateMockHandler = (
  overrideResponse?:
    | HostingDbAuthorizedHostsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingDbAuthorizedHostsUpdate200>
        | HostingDbAuthorizedHostsUpdate200),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/db/authorized-hosts',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingDbAuthorizedHostsUpdateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingDbAuthorizedHostsDeleteMockHandler = (
  overrideResponse?:
    | HostingDbAuthorizedHostsDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingDbAuthorizedHostsDelete200>
        | HostingDbAuthorizedHostsDelete200),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/db/authorized-hosts',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingDbAuthorizedHostsDeleteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDbCheckDatabaseMockHandler = (
  overrideResponse?:
    | DbCheckDatabase200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DbCheckDatabase200> | DbCheckDatabase200),
) => {
  return http.post('*/v1/hosting/:hostingId/db/check', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbCheckDatabaseResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getRepairDatabaseMockHandler = (
  overrideResponse?:
    | RepairDatabase200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<RepairDatabase200> | RepairDatabase200),
) => {
  return http.post('*/v1/hosting/:hostingId/db/repair', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getRepairDatabaseResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUsageMockHandler = (
  overrideResponse?:
    | DbUsage200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DbUsage200> | DbUsage200),
) => {
  return http.get('*/v1/hosting/:hostingId/db/usage', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUsageResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUserPasswordSetMockHandler = (
  overrideResponse?:
    | DbUserPasswordSet200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DbUserPasswordSet200> | DbUserPasswordSet200),
) => {
  return http.post('*/v1/hosting/:hostingId/db/user/password', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUserPasswordSetResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUserPrivsGetMockHandler = (
  overrideResponse?:
    | DbUserPrivsGet200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DbUserPrivsGet200> | DbUserPrivsGet200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/db/user/privileges',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDbUserPrivsGetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDbUserPrivsSetMockHandler = (
  overrideResponse?:
    | DbUserPrivsSet200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DbUserPrivsSet200> | DbUserPrivsSet200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/db/user/privileges',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDbUserPrivsSetResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDbUserAddMockHandler = (
  overrideResponse?:
    | DbUserAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DbUserAdd200> | DbUserAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/db/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUserAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUserDeleteMockHandler = (
  overrideResponse?:
    | DbUserDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DbUserDelete200> | DbUserDelete200),
) => {
  return http.delete('*/v1/hosting/:hostingId/db/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUserDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUserListMockHandler = (
  overrideResponse?:
    | DbUserList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DbUserList200> | DbUserList200),
) => {
  return http.get('*/v1/hosting/:hostingId/db/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUserListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbUserRenameMockHandler = (
  overrideResponse?:
    | DbUserRename200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<DbUserRename200> | DbUserRename200),
) => {
  return http.put('*/v1/hosting/:hostingId/db/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbUserRenameResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbMultipleUserDatabaseMockHandler = (
  overrideResponse?:
    | DbMultipleUserDatabase200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<DbMultipleUserDatabase200> | DbMultipleUserDatabase200),
) => {
  return http.delete('*/v1/hosting/:hostingId/db/users/bulk', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbMultipleUserDatabaseResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDirectoryPrivacyMockHandler = (
  overrideResponse?:
    | DirectoryPrivacy200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DirectoryPrivacy200> | DirectoryPrivacy200),
) => {
  return http.get('*/v1/hosting/:hostingId/directoryprivacy', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDirectoryPrivacyResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddPrivacyMockHandler = (
  overrideResponse?:
    | AddPrivacy200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddPrivacy200> | AddPrivacy200),
) => {
  return http.post('*/v1/hosting/:hostingId/directoryprivacy', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddPrivacyResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPrivacyMockHandler = (
  overrideResponse?:
    | Privacy200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<Privacy200> | Privacy200),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/directoryprivacy',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPrivacyResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getEditPrivacyMockHandler = (
  overrideResponse?:
    | EditPrivacy200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<EditPrivacy200> | EditPrivacy200),
) => {
  return http.put('*/v1/hosting/:hostingId/directoryprivacy', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getEditPrivacyResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPrivacyUserMockHandler = (
  overrideResponse?:
    | PrivacyUser200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<PrivacyUser200> | PrivacyUser200),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/directoryprivacy/user',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPrivacyUserResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingDomainAssignMockHandler = (
  overrideResponse?:
    | HostingDomainAssign200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingDomainAssign200> | HostingDomainAssign200),
) => {
  return http.post('*/v1/hosting/:hostingId/domain/assign', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingDomainAssignResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingDomainAvailabilityMockHandler = (
  overrideResponse?:
    | HostingDomainAvailability200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingDomainAvailability200>
        | HostingDomainAvailability200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/domain/availability',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingDomainAvailabilityResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDomainsMockHandler = (
  overrideResponse?:
    | Domains200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<Domains200> | Domains200),
) => {
  return http.get('*/v1/hosting/:hostingId/domains', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDomainsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDomainDnsExportMockHandler = (
  overrideResponse?:
    | DomainDnsExport200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DomainDnsExport200> | DomainDnsExport200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/domains/dns/export',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDomainDnsExportResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getDomainDnsImportMockHandler = (
  overrideResponse?:
    | DomainDnsImport200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<DomainDnsImport200> | DomainDnsImport200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/domains/dns/import',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDomainDnsImportResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingDomainsLinkMockHandler = (
  overrideResponse?:
    | HostingDomainsLink200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingDomainsLink200> | HostingDomainsLink200),
) => {
  return http.post('*/v1/hosting/:hostingId/domains/link', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingDomainsLinkResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingDomainsUnassignMockHandler = (
  overrideResponse?:
    | HostingDomainsUnassign200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingDomainsUnassign200> | HostingDomainsUnassign200),
) => {
  return http.post('*/v1/hosting/:hostingId/domains/unassign', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingDomainsUnassignResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEcommerceInfoMockHandler = (
  overrideResponse?:
    | HostingEcommerceInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEcommerceInfo200> | HostingEcommerceInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/ecommerce', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEcommerceInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailAddMockHandler = (
  overrideResponse?:
    | HostingEmailAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailAdd200> | HostingEmailAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/emails', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailDeleteMockHandler = (
  overrideResponse?:
    | HostingEmailDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<HostingEmailDelete200> | HostingEmailDelete200),
) => {
  return http.delete('*/v1/hosting/:hostingId/emails', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailListMockHandler = (
  overrideResponse?:
    | HostingEmailList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailList200> | HostingEmailList200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailUpdateMockHandler = (
  overrideResponse?:
    | HostingEmailUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<HostingEmailUpdate200> | HostingEmailUpdate200),
) => {
  return http.put('*/v1/hosting/:hostingId/emails', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailAutoresponderInfoMockHandler = (
  overrideResponse?:
    | HostingEmailAutoresponderInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingEmailAutoresponderInfo200>
        | HostingEmailAutoresponderInfo200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/autoresponder',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailAutoresponderInfoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailAutoresponderUpdateMockHandler = (
  overrideResponse?:
    | HostingEmailAutoresponderUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingEmailAutoresponderUpdate200>
        | HostingEmailAutoresponderUpdate200),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/emails/autoresponder',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailAutoresponderUpdateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailAutoresponderCreateMockHandler = (
  overrideResponse?:
    | HostingEmailAutoresponderCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<HostingEmailAutoresponderCreate200>
        | HostingEmailAutoresponderCreate200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/emails/autoresponder',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailAutoresponderCreateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailAutoresponderDeleteMockHandler = (
  overrideResponse?:
    | HostingEmailAutoresponderDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingEmailAutoresponderDelete200>
        | HostingEmailAutoresponderDelete200),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/emails/autoresponder',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailAutoresponderDeleteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailAutoresponderListMockHandler = (
  overrideResponse?:
    | HostingEmailAutoresponderList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingEmailAutoresponderList200>
        | HostingEmailAutoresponderList200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/autoresponders',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailAutoresponderListResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailFiltersListMockHandler = (
  overrideResponse?:
    | HostingEmailFiltersList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailFiltersList200> | HostingEmailFiltersList200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails/filters', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailFiltersListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailFiltersAddMockHandler = (
  overrideResponse?:
    | HostingEmailFiltersAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailFiltersAdd200> | HostingEmailFiltersAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/emails/filters', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailFiltersAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailFiltersUpdateMockHandler = (
  overrideResponse?:
    | HostingEmailFiltersUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingEmailFiltersUpdate200>
        | HostingEmailFiltersUpdate200),
) => {
  return http.put('*/v1/hosting/:hostingId/emails/filters', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailFiltersUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailFiltersDeleteMockHandler = (
  overrideResponse?:
    | HostingEmailFiltersDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingEmailFiltersDelete200>
        | HostingEmailFiltersDelete200),
) => {
  return http.delete('*/v1/hosting/:hostingId/emails/filters', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailFiltersDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailForwardersListMockHandler = (
  overrideResponse?:
    | HostingEmailForwardersList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingEmailForwardersList200>
        | HostingEmailForwardersList200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails/forwarders', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailForwardersListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailForwarderAddMockHandler = (
  overrideResponse?:
    | HostingEmailForwarderAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailForwarderAdd200> | HostingEmailForwarderAdd200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/emails/forwarders',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailForwarderAddResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailForwardDeleteMockHandler = (
  overrideResponse?:
    | HostingEmailForwardDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<HostingEmailForwardDelete200>
        | HostingEmailForwardDelete200),
) => {
  return http.delete(
    '*/v1/hosting/:hostingId/emails/forwarders',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailForwardDeleteResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailKeysAddMockHandler = (
  overrideResponse?:
    | HostingEmailKeysAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailKeysAdd200> | HostingEmailKeysAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/emails/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailKeysAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailKeysListMockHandler = (
  overrideResponse?:
    | HostingEmailKeysList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailKeysList200> | HostingEmailKeysList200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailKeysListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailDomainRoutingMockHandler = (
  overrideResponse?:
    | HostingEmailDomainRouting200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingEmailDomainRouting200>
        | HostingEmailDomainRouting200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails/routing', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailDomainRoutingResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailDomainRoutingSetMockHandler = (
  overrideResponse?:
    | HostingEmailDomainRoutingSet200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingEmailDomainRoutingSet200>
        | HostingEmailDomainRoutingSet200),
) => {
  return http.put('*/v1/hosting/:hostingId/emails/routing', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailDomainRoutingSetResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailSettingsMockHandler = (
  overrideResponse?:
    | HostingEmailSettings200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailSettings200> | HostingEmailSettings200),
) => {
  return http.post('*/v1/hosting/:hostingId/emails/settings', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailSettingsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailSpamCustomSettingsMockHandler = (
  overrideResponse?:
    | HostingEmailSpamCustomSettings200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingEmailSpamCustomSettings200>
        | HostingEmailSpamCustomSettings200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/spam/custom-settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSpamCustomSettingsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailSpamCustomSettingsUpdateMockHandler = (
  overrideResponse?:
    | HostingEmailSpamCustomSettingsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingEmailSpamCustomSettingsUpdate200>
        | HostingEmailSpamCustomSettingsUpdate200),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/emails/spam/custom-settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSpamCustomSettingsUpdateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailSpamEmptyMockHandler = (
  overrideResponse?:
    | HostingEmailSpamEmpty200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailSpamEmpty200> | HostingEmailSpamEmpty200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/emails/spam/empty',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSpamEmptyResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailSpamSettingsMockHandler = (
  overrideResponse?:
    | HostingEmailSpamSettings200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailSpamSettings200> | HostingEmailSpamSettings200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/spam/settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSpamSettingsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailSpamSettingsUpdateMockHandler = (
  overrideResponse?:
    | HostingEmailSpamSettingsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingEmailSpamSettingsUpdate200>
        | HostingEmailSpamSettingsUpdate200),
) => {
  return http.put(
    '*/v1/hosting/:hostingId/emails/spam/settings',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSpamSettingsUpdateResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getEmailSsoMockHandler = (
  overrideResponse?:
    | EmailSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<EmailSso200> | EmailSso200),
) => {
  return http.get('*/v1/hosting/:hostingId/emails/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getEmailSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailTestSendMockHandler = (
  overrideResponse?:
    | HostingEmailTestSend200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingEmailTestSend200> | HostingEmailTestSend200),
) => {
  return http.post('*/v1/hosting/:hostingId/emails/test/send', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingEmailTestSendResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingEmailFolderListMockHandler = (
  overrideResponse?:
    | HostingEmailFolderList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailFolderList200> | HostingEmailFolderList200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/:address/folders',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailFolderListResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingEmailSetupInfoMockHandler = (
  overrideResponse?:
    | HostingEmailSetupInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingEmailSetupInfo200> | HostingEmailSetupInfo200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/emails/:email/setup-info',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingEmailSetupInfoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingSendEmailSetupInfoMockHandler = (
  overrideResponse?:
    | HostingSendEmailSetupInfo200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<HostingSendEmailSetupInfo200>
        | HostingSendEmailSetupInfo200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/emails/:email/setup-info/send',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingSendEmailSetupInfoResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingFixownershipMockHandler = (
  overrideResponse?:
    | HostingFixownership200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingFixownership200> | HostingFixownership200),
) => {
  return http.post('*/v1/hosting/:hostingId/fixownership', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingFixownershipResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingFtpListMockHandler = (
  overrideResponse?:
    | HostingFtpList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingFtpList200> | HostingFtpList200),
) => {
  return http.get('*/v1/hosting/:hostingId/ftp', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingFtpListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingFtpAddMockHandler = (
  overrideResponse?:
    | HostingFtpAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingFtpAdd200> | HostingFtpAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/ftp', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingFtpAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingFtpUpdateMockHandler = (
  overrideResponse?:
    | HostingFtpUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<HostingFtpUpdate200> | HostingFtpUpdate200),
) => {
  return http.put('*/v1/hosting/:hostingId/ftp', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingFtpUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingFtpMockHandler = (
  overrideResponse?:
    | HostingFtp200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<HostingFtp200> | HostingFtp200),
) => {
  return http.delete('*/v1/hosting/:hostingId/ftp', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingFtpResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRepoListMockHandler = (
  overrideResponse?:
    | HostingRepoList200Item[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingRepoList200Item[]> | HostingRepoList200Item[]),
) => {
  return http.get('*/v1/hosting/:hostingId/git-repos', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRepoListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRepoSyncMockHandler = (
  overrideResponse?:
    | HostingRepoSync200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingRepoSync200> | HostingRepoSync200),
) => {
  return http.post('*/v1/hosting/:hostingId/git-repos', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRepoSyncResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRepoMockHandler = (
  overrideResponse?:
    | HostingRepo200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<HostingRepo200> | HostingRepo200),
) => {
  return http.delete('*/v1/hosting/:hostingId/git-repos', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRepoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRepoLogMockHandler = (
  overrideResponse?:
    | HostingRepoLog200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingRepoLog200> | HostingRepoLog200),
) => {
  return http.get('*/v1/hosting/:hostingId/git-repos/log', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRepoLogResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHotlinkconfigDetailsMockHandler = (
  overrideResponse?:
    | HotlinkconfigDetails200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HotlinkconfigDetails200> | HotlinkconfigDetails200),
) => {
  return http.get('*/v1/hosting/:hostingId/hotlinkconfig', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHotlinkconfigDetailsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHotlinkconfigAddMockHandler = (
  overrideResponse?:
    | HotlinkconfigAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HotlinkconfigAdd200> | HotlinkconfigAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/hotlinkconfig', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHotlinkconfigAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHotlinkconfigDeleteMockHandler = (
  overrideResponse?:
    | HotlinkconfigDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<HotlinkconfigDelete200> | HotlinkconfigDelete200),
) => {
  return http.delete('*/v1/hosting/:hostingId/hotlinkconfig', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHotlinkconfigDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getListIndexMockHandler = (
  overrideResponse?:
    | ListIndex200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ListIndex200> | ListIndex200),
) => {
  return http.get('*/v1/hosting/:hostingId/index', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getListIndexResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddIndexMockHandler = (
  overrideResponse?:
    | AddIndex200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddIndex200> | AddIndex200),
) => {
  return http.post('*/v1/hosting/:hostingId/index', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddIndexResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getIndexMockHandler = (
  overrideResponse?:
    | Index200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<Index200> | Index200),
) => {
  return http.delete('*/v1/hosting/:hostingId/index', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getIndexResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingInfoMockHandler = (
  overrideResponse?:
    | HostingInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingInfo200> | HostingInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/info', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingInfoDiskUsageMockHandler = (
  overrideResponse?:
    | HostingInfoDiskUsage200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingInfoDiskUsage200> | HostingInfoDiskUsage200),
) => {
  return http.get('*/v1/hosting/:hostingId/info/diskusage', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingInfoDiskUsageResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingLeadMockHandler = (
  overrideResponse?:
    | HostingLead200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingLead200> | HostingLead200),
) => {
  return http.post('*/v1/hosting/:hostingId/lead', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingLeadResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingLicenseInfoMockHandler = (
  overrideResponse?:
    | HostingLicenseInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingLicenseInfo200> | HostingLicenseInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/license', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingLicenseInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingMigrationStatusMockHandler = (
  overrideResponse?:
    | HostingMigrationStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingMigrationStatus200> | HostingMigrationStatus200),
) => {
  return http.get('*/v1/hosting/:hostingId/migrations', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingMigrationStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingMigrationsMockHandler = (
  overrideResponse?:
    | HostingMigrations200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingMigrations200> | HostingMigrations200),
) => {
  return http.post('*/v1/hosting/:hostingId/migrations', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingMigrationsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingMigrationsEventMockHandler = (
  overrideResponse?:
    | HostingMigrationsEvent200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingMigrationsEvent200> | HostingMigrationsEvent200),
) => {
  return http.post('*/v1/hosting/:hostingId/migrations/event', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingMigrationsEventResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingMigrationInfoMockHandler = (
  overrideResponse?:
    | HostingMigrationInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingMigrationInfo200> | HostingMigrationInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/migrations/info', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingMigrationInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingMigrationSiteScanStatusMockHandler = (
  overrideResponse?:
    | HostingMigrationSiteScanStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingMigrationSiteScanStatus200>
        | HostingMigrationSiteScanStatus200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/migrations/site-scan',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingMigrationSiteScanStatusResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingMonarxAddonsListMockHandler = (
  overrideResponse?:
    | HostingMonarxAddonsList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingMonarxAddonsList200> | HostingMonarxAddonsList200),
) => {
  return http.get('*/v1/hosting/:hostingId/monarx/addons', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingMonarxAddonsListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingNameserversMockHandler = (
  overrideResponse?:
    | HostingNameservers200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingNameservers200> | HostingNameservers200),
) => {
  return http.get('*/v1/hosting/:hostingId/nameservers', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingNameserversResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingOnboardingDataMockHandler = (
  overrideResponse?:
    | HostingOnboardingData200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingOnboardingData200> | HostingOnboardingData200),
) => {
  return http.get('*/v1/hosting/:hostingId/onboarding', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingOnboardingDataResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingOnboardingDataUpdateMockHandler = (
  overrideResponse?:
    | HostingOnboardingDataUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<HostingOnboardingDataUpdate200>
        | HostingOnboardingDataUpdate200),
) => {
  return http.put('*/v1/hosting/:hostingId/onboarding', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingOnboardingDataUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingPasswordUpdateMockHandler = (
  overrideResponse?:
    | HostingPasswordUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<HostingPasswordUpdate200> | HostingPasswordUpdate200),
) => {
  return http.put('*/v1/hosting/:hostingId/password', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingPasswordUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPasswordGenerateMockHandler = (
  overrideResponse?:
    | PasswordGenerate200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PasswordGenerate200> | PasswordGenerate200),
) => {
  return http.get('*/v1/hosting/:hostingId/password/generate', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPasswordGenerateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPasswordScoreMockHandler = (
  overrideResponse?:
    | PasswordScore200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PasswordScore200> | PasswordScore200),
) => {
  return http.get('*/v1/hosting/:hostingId/password/score', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPasswordScoreResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPhpErrorsMockHandler = (
  overrideResponse?:
    | PhpErrors200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PhpErrors200> | PhpErrors200),
) => {
  return http.get('*/v1/hosting/:hostingId/php-errors', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPhpErrorsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getProductLicenseDetailsMockHandler = (
  overrideResponse?:
    | ProductLicenseDetails200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ProductLicenseDetails200> | ProductLicenseDetails200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/product/license-details',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getProductLicenseDetailsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingRedirectsMockHandler = (
  overrideResponse?:
    | HostingRedirects200Item[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingRedirects200Item[]> | HostingRedirects200Item[]),
) => {
  return http.get('*/v1/hosting/:hostingId/redirects', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRedirectsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRedirectMockHandler = (
  overrideResponse?:
    | HostingRedirect200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<HostingRedirect200> | HostingRedirect200),
) => {
  return http.delete('*/v1/hosting/:hostingId/redirects', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRedirectResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddHostingRedirectsMockHandler = (
  overrideResponse?:
    | AddHostingRedirects200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddHostingRedirects200> | AddHostingRedirects200),
) => {
  return http.post('*/v1/hosting/:hostingId/redirects', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddHostingRedirectsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingResellerSsoWhmMockHandler = (
  overrideResponse?:
    | HostingResellerSsoWhm200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingResellerSsoWhm200> | HostingResellerSsoWhm200),
) => {
  return http.get('*/v1/hosting/:hostingId/reseller/sso/whm', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingResellerSsoWhmResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingServerHitsMockHandler = (
  overrideResponse?:
    | HostingServerHits200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingServerHits200> | HostingServerHits200),
) => {
  return http.get('*/v1/hosting/:hostingId/server-hits', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingServerHitsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingShellToggleMockHandler = (
  overrideResponse?:
    | HostingShellToggle200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<HostingShellToggle200> | HostingShellToggle200),
) => {
  return http.put('*/v1/hosting/:hostingId/shell', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingShellToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingShellInfoMockHandler = (
  overrideResponse?:
    | HostingShellInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingShellInfo200> | HostingShellInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/shell', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingShellInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingSiteAddMockHandler = (
  overrideResponse?:
    | HostingSiteAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingSiteAdd200> | HostingSiteAdd200),
) => {
  return http.post('*/v1/hosting/:hostingId/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingSiteAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesBatchMockHandler = (
  overrideResponse?:
    | SitesBatch200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SitesBatch200> | SitesBatch200),
) => {
  return http.put('*/v1/hosting/:hostingId/sites/batch', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesBatchResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingSpamexpertsEligibleDomainsMockHandler = (
  overrideResponse?:
    | HostingSpamexpertsEligibleDomains200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<HostingSpamexpertsEligibleDomains200>
        | HostingSpamexpertsEligibleDomains200),
) => {
  return http.get(
    '*/v1/hosting/:hostingId/spamexperts/eligible-domains',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingSpamexpertsEligibleDomainsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getHostingSshInfoMockHandler = (
  overrideResponse?:
    | HostingSshInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingSshInfo200> | HostingSshInfo200),
) => {
  return http.get('*/v1/hosting/:hostingId/ssh', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingSshInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyFetchMockHandler = (
  overrideResponse?:
    | SshKeyFetch200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SshKeyFetch200> | SshKeyFetch200),
) => {
  return http.get('*/v1/hosting/:hostingId/ssh/fetch', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyFetchResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyImportMockHandler = (
  overrideResponse?:
    | SshKeyImport200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SshKeyImport200> | SshKeyImport200),
) => {
  return http.post('*/v1/hosting/:hostingId/ssh/import', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyImportResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyListMockHandler = (
  overrideResponse?:
    | SshKeyList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SshKeyList200> | SshKeyList200),
) => {
  return http.get('*/v1/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyMockHandler = (
  overrideResponse?:
    | SshKey200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SshKey200> | SshKey200),
) => {
  return http.delete('*/v1/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyGenerateMockHandler = (
  overrideResponse?:
    | SshKeyGenerate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SshKeyGenerate200> | SshKeyGenerate200),
) => {
  return http.post('*/v1/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyGenerateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingVpsSshKeySyncMockHandler = (
  overrideResponse?:
    | HostingVpsSshKeySync200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingVpsSshKeySync200> | HostingVpsSshKeySync200),
) => {
  return http.post(
    '*/v1/hosting/:hostingId/ssh/keys/:id/sync',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getHostingVpsSshKeySyncResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSsoMockHandler = (
  overrideResponse?:
    | Sso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<Sso200> | Sso200),
) => {
  return http.get('*/v1/hosting/:hostingId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingVisitorsMockHandler = (
  overrideResponse?:
    | HostingVisitors200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingVisitors200> | HostingVisitors200),
) => {
  return http.get('*/v1/hosting/:hostingId/visitors', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingVisitorsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPublicImagesMockHandler = (
  overrideResponse?:
    | PublicImages200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PublicImages200> | PublicImages200),
) => {
  return http.get('*/v1/public/images', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPublicImagesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPublicRegionsMockHandler = (
  overrideResponse?:
    | PublicRegions200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PublicRegions200> | PublicRegions200),
) => {
  return http.get('*/v1/public/regions', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPublicRegionsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountPurchaseProductsMockHandler = (
  overrideResponse?:
    | AccountPurchaseProducts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountPurchaseProducts200> | AccountPurchaseProducts200),
) => {
  return http.get(
    '*/v1/purchase/accounts/:billingAccountId/hosting',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAccountPurchaseProductsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getAccountPurchaseHostingMockHandler = (
  overrideResponse?:
    | AccountPurchaseHosting200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AccountPurchaseHosting200> | AccountPurchaseHosting200),
) => {
  return http.post(
    '*/v1/purchase/accounts/:billingAccountId/hosting',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAccountPurchaseHostingResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getAccountPurchaseOrderMockHandler = (
  overrideResponse?:
    | AccountPurchaseOrder200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountPurchaseOrder200> | AccountPurchaseOrder200),
) => {
  return http.get(
    '*/v1/purchase/accounts/:billingAccountId/orders/:orderId',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getAccountPurchaseOrderResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesInfoMockHandler = (
  overrideResponse?:
    | SitesInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesInfo200> | SitesInfo200),
) => {
  return http.get('*/v1/sites/:siteId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteUpdateMockHandler = (
  overrideResponse?:
    | SiteUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SiteUpdate200> | SiteUpdate200),
) => {
  return http.put('*/v1/sites/:siteId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteMockHandler = (
  overrideResponse?:
    | Site200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<Site200> | Site200),
) => {
  return http.delete('*/v1/sites/:siteId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesAtomicMetricsMockHandler = (
  overrideResponse?:
    | SitesAtomicMetrics200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesAtomicMetrics200> | SitesAtomicMetrics200),
) => {
  return http.get('*/v1/sites/:siteId/atomic/metrics', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesAtomicMetricsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesAutoupdatesInfoMockHandler = (
  overrideResponse?:
    | SitesAutoupdatesResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesAutoupdatesResponse> | SitesAutoupdatesResponse),
) => {
  return http.get('*/v1/sites/:siteId/autoupdates', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesAutoupdatesInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesAutoupdatesUpdateMockHandler = (
  overrideResponse?:
    | SitesAutoupdatesResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SitesAutoupdatesResponse> | SitesAutoupdatesResponse),
) => {
  return http.put('*/v1/sites/:siteId/autoupdates', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesAutoupdatesUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesBackupsMockHandler = (
  overrideResponse?:
    | SitesBackups200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesBackups200> | SitesBackups200),
) => {
  return http.get('*/v1/sites/:siteId/backups', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesBackupsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesHasBackupsMockHandler = (
  overrideResponse?:
    | SitesHasBackups200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesHasBackups200> | SitesHasBackups200),
) => {
  return http.get('*/v1/sites/:siteId/backups/check', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesHasBackupsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesBackupsCodeguardMockHandler = (
  overrideResponse?:
    | SitesBackupsCodeguard200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesBackupsCodeguard200> | SitesBackupsCodeguard200),
) => {
  return http.post('*/v1/sites/:siteId/backups/codeguard', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesBackupsCodeguardResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesBackupsDetailsMockHandler = (
  overrideResponse?:
    | SitesBackupsDetails200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesBackupsDetails200> | SitesBackupsDetails200),
) => {
  return http.get('*/v1/sites/:siteId/backups/details', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesBackupsDetailsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getJetpackBackupStatusMockHandler = (
  overrideResponse?:
    | JetpackBackupStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<JetpackBackupStatus200> | JetpackBackupStatus200),
) => {
  return http.get('*/v1/sites/:siteId/backups/jetpack', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getJetpackBackupStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupsJetpackBackupMockHandler = (
  overrideResponse?:
    | BackupsJetpackBackup200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<BackupsJetpackBackup200> | BackupsJetpackBackup200),
) => {
  return http.put('*/v1/sites/:siteId/backups/jetpack', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupsJetpackBackupResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesBackupsXcitiumMockHandler = (
  overrideResponse?:
    | SitesBackupsXcitium200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesBackupsXcitium200> | SitesBackupsXcitium200),
) => {
  return http.post('*/v1/sites/:siteId/backups/xcitium', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesBackupsXcitiumResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteAddonCloudflareMockHandler = (
  overrideResponse?:
    | SiteAddonCloudflare200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SiteAddonCloudflare200> | SiteAddonCloudflare200),
) => {
  return http.post('*/v1/sites/:siteId/cloudflare', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteAddonCloudflareResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDatabaseInfoMockHandler = (
  overrideResponse?:
    | SitesDatabaseInfo200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesDatabaseInfo200> | SitesDatabaseInfo200),
) => {
  return http.get('*/v1/sites/:siteId/database', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDatabaseInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDatabasePasswordsyncMockHandler = (
  overrideResponse?:
    | SitesDatabasePasswordsync200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesDatabasePasswordsync200>
        | SitesDatabasePasswordsync200),
) => {
  return http.post(
    '*/v1/sites/:siteId/database/password-sync',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesDatabasePasswordsyncResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesDnsMockHandler = (
  overrideResponse?:
    | SitesDns200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesDns200> | SitesDns200),
) => {
  return http.get('*/v1/sites/:siteId/dns', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDnsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDomainMockHandler = (
  overrideResponse?:
    | SitesDomain200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesDomain200> | SitesDomain200),
) => {
  return http.get('*/v1/sites/:siteId/domain', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDomainResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDomainUrlMockHandler = (
  overrideResponse?:
    | SitesDomainUrl200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesDomainUrl200> | SitesDomainUrl200),
) => {
  return http.post('*/v1/sites/:siteId/domain', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDomainUrlResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDomainsCreateMockHandler = (
  overrideResponse?:
    | SitesDomainsCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesDomainsCreate200> | SitesDomainsCreate200),
) => {
  return http.post('*/v1/sites/:siteId/domains', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDomainsCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getErrorPagesFetchMockHandler = (
  overrideResponse?:
    | ErrorPagesFetch200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ErrorPagesFetch200> | ErrorPagesFetch200),
) => {
  return http.get('*/v1/sites/:siteId/error-pages', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getErrorPagesFetchResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getErrorPagesAddMockHandler = (
  overrideResponse?:
    | ErrorPagesAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<ErrorPagesAdd200> | ErrorPagesAdd200),
) => {
  return http.post('*/v1/sites/:siteId/error-pages', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getErrorPagesAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getErrorPagesDeleteMockHandler = (
  overrideResponse?:
    | ErrorPagesDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<ErrorPagesDelete200> | ErrorPagesDelete200),
) => {
  return http.delete('*/v1/sites/:siteId/error-pages', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getErrorPagesDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteIpaddressListMockHandler = (
  overrideResponse?:
    | SiteIpaddressList200Item[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteIpaddressList200Item[]> | SiteIpaddressList200Item[]),
) => {
  return http.get('*/v1/sites/:siteId/ipblocker', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteIpaddressListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteIpaddressMockHandler = (
  overrideResponse?:
    | SiteIpaddress200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SiteIpaddress200> | SiteIpaddress200),
) => {
  return http.delete('*/v1/sites/:siteId/ipblocker', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteIpaddressResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddSiteIpaddressMockHandler = (
  overrideResponse?:
    | AddSiteIpaddress200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<AddSiteIpaddress200> | AddSiteIpaddress200),
) => {
  return http.post('*/v1/sites/:siteId/ipblocker', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddSiteIpaddressResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesJetpackPurchaseMockHandler = (
  overrideResponse?:
    | SitesJetpackPurchase200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesJetpackPurchase200> | SitesJetpackPurchase200),
) => {
  return http.get('*/v1/sites/:siteId/jetpack/purchase', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesJetpackPurchaseResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesAccessLogsMockHandler = (
  overrideResponse?:
    | SitesAccessLogs200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesAccessLogs200> | SitesAccessLogs200),
) => {
  return http.get('*/v1/sites/:siteId/logs/access', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesAccessLogsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesAccessLogsDownloadMockHandler = (
  overrideResponse?:
    | unknown
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<unknown> | unknown),
) => {
  return http.get('*/v1/sites/:siteId/logs/access/download', async (info) => {
    await delay(0);
    if (typeof overrideResponse === 'function') {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getSitesErrorLogsMockHandler = (
  overrideResponse?:
    | SitesErrorLogs200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesErrorLogs200> | SitesErrorLogs200),
) => {
  return http.get('*/v1/sites/:siteId/logs/error', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesErrorLogsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesErrorLogsDownloadMockHandler = (
  overrideResponse?:
    | unknown
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<unknown> | unknown),
) => {
  return http.get('*/v1/sites/:siteId/logs/error/download', async (info) => {
    await delay(0);
    if (typeof overrideResponse === 'function') {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 200 });
  });
};

export const getSiteMalwareStatusMockHandler = (
  overrideResponse?:
    | SiteMalwareStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteMalwareStatus200> | SiteMalwareStatus200),
) => {
  return http.get('*/v1/sites/:siteId/malware-status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteMalwareStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesMetricsDimensionAveragedMockHandler = (
  overrideResponse?:
    | SitesMetricsDimensionAveraged200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesMetricsDimensionAveraged200>
        | SitesMetricsDimensionAveraged200),
) => {
  return http.get(
    '*/v1/sites/:siteId/metrics/dimension/:dimension/averaged',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesMetricsDimensionAveragedResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesMetricDimensionsMockHandler = (
  overrideResponse?:
    | SitesMetricDimensions200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesMetricDimensions200> | SitesMetricDimensions200),
) => {
  return http.get(
    '*/v1/sites/:siteId/metrics/:metric/dimensions',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesMetricDimensionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesOnboardingStepsMockHandler = (
  overrideResponse?:
    | SitesOnboardingSteps200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesOnboardingSteps200> | SitesOnboardingSteps200),
) => {
  return http.get('*/v1/sites/:siteId/onboarding/steps', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesOnboardingStepsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePendingDomainDeleteMockHandler = (
  overrideResponse?:
    | SitePendingDomainDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SitePendingDomainDelete200> | SitePendingDomainDelete200),
) => {
  return http.delete('*/v1/sites/:siteId/pending-domain', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePendingDomainDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceCachepurgeMockHandler = (
  overrideResponse?:
    | SitesPerformanceCachepurge200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesPerformanceCachepurge200>
        | SitesPerformanceCachepurge200),
) => {
  return http.post(
    '*/v1/sites/:siteId/performance/cachepurge',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesPerformanceCachepurgeResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesPerformanceEdgecacheMockHandler = (
  overrideResponse?:
    | SitesPerformanceEdgecache200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<SitesPerformanceEdgecache200>
        | SitesPerformanceEdgecache200),
) => {
  return http.put('*/v1/sites/:siteId/performance/edge_cache', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceEdgecacheResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceEnduranceCacheLevelStatusMockHandler = (
  overrideResponse?:
    | SitesPerformanceEnduranceCacheLevelStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesPerformanceEnduranceCacheLevelStatus200>
        | SitesPerformanceEnduranceCacheLevelStatus200),
) => {
  return http.get(
    '*/v1/sites/:siteId/performance/endurance_cache_level',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesPerformanceEnduranceCacheLevelStatusResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesPerformanceEnduranceCacheLevelMockHandler = (
  overrideResponse?:
    | SitesPerformanceEnduranceCacheLevel200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesPerformanceEnduranceCacheLevel200>
        | SitesPerformanceEnduranceCacheLevel200),
) => {
  return http.post(
    '*/v1/sites/:siteId/performance/endurance_cache_level',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesPerformanceEnduranceCacheLevelResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesPerformanceEndurancePageCacheMockHandler = (
  overrideResponse?:
    | SitesPerformanceEndurancePageCache200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<SitesPerformanceEndurancePageCache200>
        | SitesPerformanceEndurancePageCache200),
) => {
  return http.put(
    '*/v1/sites/:siteId/performance/endurance_page_cache',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesPerformanceEndurancePageCacheResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesPerformanceRedisToggleMockHandler = (
  overrideResponse?:
    | SitesPerformanceRedisToggle200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<SitesPerformanceRedisToggle200>
        | SitesPerformanceRedisToggle200),
) => {
  return http.put('*/v1/sites/:siteId/performance/redis', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceRedisToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceRedisStatusMockHandler = (
  overrideResponse?:
    | SitesPerformanceRedisStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesPerformanceRedisStatus200>
        | SitesPerformanceRedisStatus200),
) => {
  return http.get('*/v1/sites/:siteId/performance/redis', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceRedisStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceRedisUninstallMockHandler = (
  overrideResponse?:
    | SitesPerformanceRedisUninstall200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) =>
        | Promise<SitesPerformanceRedisUninstall200>
        | SitesPerformanceRedisUninstall200),
) => {
  return http.delete('*/v1/sites/:siteId/performance/redis', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceRedisUninstallResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceRedisPurgeMockHandler = (
  overrideResponse?:
    | SitesPerformanceRedisPurge200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesPerformanceRedisPurge200>
        | SitesPerformanceRedisPurge200),
) => {
  return http.post('*/v1/sites/:siteId/performance/redis', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceRedisPurgeResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceScansListMockHandler = (
  overrideResponse?:
    | SitesPerformanceScansList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesPerformanceScansList200>
        | SitesPerformanceScansList200),
) => {
  return http.get('*/v1/sites/:siteId/performance/scans', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceScansListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceScansMockHandler = (
  overrideResponse?:
    | SitesPerformanceScans200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SitesPerformanceScans200> | SitesPerformanceScans200),
) => {
  return http.delete('*/v1/sites/:siteId/performance/scans', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceScansResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesPerformanceScansAddMockHandler = (
  overrideResponse?:
    | SitesPerformanceScansAdd200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesPerformanceScansAdd200> | SitesPerformanceScansAdd200),
) => {
  return http.post('*/v1/sites/:siteId/performance/scans', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesPerformanceScansAddResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getCreatePhpInfoMockHandler = (
  overrideResponse?:
    | CreatePhpInfo200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<CreatePhpInfo200> | CreatePhpInfo200),
) => {
  return http.post('*/v1/sites/:siteId/php-info', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCreatePhpInfoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginsMockHandler = (
  overrideResponse?:
    | SitePlugins200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitePlugins200> | SitePlugins200),
) => {
  return http.get('*/v1/sites/:siteId/plugins', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginUpdateMockHandler = (
  overrideResponse?:
    | SitePluginUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SitePluginUpdate200> | SitePluginUpdate200),
) => {
  return http.put('*/v1/sites/:siteId/plugins', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginInstallMockHandler = (
  overrideResponse?:
    | SitePluginInstall200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitePluginInstall200> | SitePluginInstall200),
) => {
  return http.post('*/v1/sites/:siteId/plugins', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginInstallResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginsAutoupdateMockHandler = (
  overrideResponse?:
    | SitePluginsAutoupdate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitePluginsAutoupdate200> | SitePluginsAutoupdate200),
) => {
  return http.post('*/v1/sites/:siteId/plugins/autoupdate', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginsAutoupdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginInstallerMockHandler = (
  overrideResponse?:
    | SitePluginInstaller200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitePluginInstaller200> | SitePluginInstaller200),
) => {
  return http.post('*/v1/sites/:siteId/plugins/installer', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginInstallerResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginsToggleMockHandler = (
  overrideResponse?:
    | SitePluginsToggle200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitePluginsToggle200> | SitePluginsToggle200),
) => {
  return http.post('*/v1/sites/:siteId/plugins/toggle', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginsToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitePluginsUpdateMockHandler = (
  overrideResponse?:
    | SitePluginsUpdate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitePluginsUpdate200> | SitePluginsUpdate200),
) => {
  return http.post('*/v1/sites/:siteId/plugins/update', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitePluginsUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteQualityMetricsMockHandler = (
  overrideResponse?:
    | SiteQualityMetrics200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteQualityMetrics200> | SiteQualityMetrics200),
) => {
  return http.get('*/v1/sites/:siteId/quality-metrics', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteQualityMetricsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getResetSiteMockHandler = (
  overrideResponse?:
    | ResetSite200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<ResetSite200> | ResetSite200),
) => {
  return http.post('*/v1/sites/:siteId/reset', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getResetSiteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecurityBundleMockHandler = (
  overrideResponse?:
    | SitesSecurityBundle200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSecurityBundle200> | SitesSecurityBundle200),
) => {
  return http.get('*/v1/sites/:siteId/security/bundle', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecurityBundleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecurityCheckCoreMockHandler = (
  overrideResponse?:
    | SitesSecurityCheckCore200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSecurityCheckCore200> | SitesSecurityCheckCore200),
) => {
  return http.get('*/v1/sites/:siteId/security/core/check', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecurityCheckCoreResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecurityResetCoreFilesMockHandler = (
  overrideResponse?:
    | SitesSecurityResetCoreFiles200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesSecurityResetCoreFiles200>
        | SitesSecurityResetCoreFiles200),
) => {
  return http.post('*/v1/sites/:siteId/security/core/reset', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecurityResetCoreFilesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecurityHttpsRedirectionStatusMockHandler = (
  overrideResponse?:
    | SitesSecurityHttpsRedirectionStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesSecurityHttpsRedirectionStatus200>
        | SitesSecurityHttpsRedirectionStatus200),
) => {
  return http.get('*/v1/sites/:siteId/security/https', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecurityHttpsRedirectionStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecurityHttpsEnableDisableSslMockHandler = (
  overrideResponse?:
    | SitesSecurityHttpsEnableDisableSsl200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesSecurityHttpsEnableDisableSsl200>
        | SitesSecurityHttpsEnableDisableSsl200),
) => {
  return http.post('*/v1/sites/:siteId/security/https', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecurityHttpsEnableDisableSslResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecuritySitelockMockHandler = (
  overrideResponse?:
    | SitesSecuritySitelock200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSecuritySitelock200> | SitesSecuritySitelock200),
) => {
  return http.get('*/v1/sites/:siteId/security/sitelock', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecuritySitelockResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecuritySslAcmeMockHandler = (
  overrideResponse?:
    | SitesSecuritySslAcme200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesSecuritySslAcme200> | SitesSecuritySslAcme200),
) => {
  return http.post('*/v1/sites/:siteId/security/ssl/acme', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecuritySslAcmeResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecuritySslStatusMockHandler = (
  overrideResponse?:
    | SitesSecuritySslStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSecuritySslStatus200> | SitesSecuritySslStatus200),
) => {
  return http.get('*/v1/sites/:siteId/security/ssl/status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecuritySslStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsComingSoonMockHandler = (
  overrideResponse?:
    | SitesSettingsComingSoon200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSettingsComingSoon200> | SitesSettingsComingSoon200),
) => {
  return http.get('*/v1/sites/:siteId/settings/coming-soon', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsComingSoonResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsComingSoonToggleMockHandler = (
  overrideResponse?:
    | SitesSettingsComingSoonToggle200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesSettingsComingSoonToggle200>
        | SitesSettingsComingSoonToggle200),
) => {
  return http.post('*/v1/sites/:siteId/settings/coming-soon', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsComingSoonToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsDebugMockHandler = (
  overrideResponse?:
    | SitesSettingsDebug200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSettingsDebug200> | SitesSettingsDebug200),
) => {
  return http.get('*/v1/sites/:siteId/settings/debug', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsDebugResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsDebugToggleMockHandler = (
  overrideResponse?:
    | SitesSettingsDebugToggle200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesSettingsDebugToggle200> | SitesSettingsDebugToggle200),
) => {
  return http.post('*/v1/sites/:siteId/settings/debug', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsDebugToggleResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsPhpVersionUpdateMockHandler = (
  overrideResponse?:
    | SitesSettingsPhpVersionUpdate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) =>
        | Promise<SitesSettingsPhpVersionUpdate200>
        | SitesSettingsPhpVersionUpdate200),
) => {
  return http.post('*/v1/sites/:siteId/settings/php-version', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsPhpVersionUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSettingsPhpVersionInheritanceMockHandler = (
  overrideResponse?:
    | SitesSettingsPhpVersionInheritance200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SitesSettingsPhpVersionInheritance200>
        | SitesSettingsPhpVersionInheritance200),
) => {
  return http.get(
    '*/v1/sites/:siteId/settings/php-version/inheritance',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getSitesSettingsPhpVersionInheritanceResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getSitesSettingsPhpVersionsMockHandler = (
  overrideResponse?:
    | SitesSettingsPhpVersions200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSettingsPhpVersions200> | SitesSettingsPhpVersions200),
) => {
  return http.get('*/v1/sites/:siteId/settings/php-versions', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSettingsPhpVersionsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSshUserListMockHandler = (
  overrideResponse?:
    | SitesSshUserList200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSshUserList200> | SitesSshUserList200),
) => {
  return http.get('*/v1/sites/:siteId/ssh-users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSshUserListResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSshUserCreateMockHandler = (
  overrideResponse?:
    | SitesSshUserCreate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SitesSshUserCreate200> | SitesSshUserCreate200),
) => {
  return http.post('*/v1/sites/:siteId/ssh-users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSshUserCreateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSshUserDeleteMockHandler = (
  overrideResponse?:
    | SitesSshUserDelete200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SitesSshUserDelete200> | SitesSshUserDelete200),
) => {
  return http.delete('*/v1/sites/:siteId/ssh-users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSshUserDeleteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSshUserUpdateMockHandler = (
  overrideResponse?:
    | SitesSshUserUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) => Promise<SitesSshUserUpdate200> | SitesSshUserUpdate200),
) => {
  return http.put('*/v1/sites/:siteId/ssh-users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSshUserUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSslMockHandler = (
  overrideResponse?:
    | SitesSsl200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSsl200> | SitesSsl200),
) => {
  return http.get('*/v1/sites/:siteId/ssl', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSslResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSsoMockHandler = (
  overrideResponse?:
    | SitesSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSso200> | SitesSso200),
) => {
  return http.get('*/v1/sites/:siteId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getStagingSitePromoteMockHandler = (
  overrideResponse?:
    | StagingSitePromote200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<StagingSitePromote200> | StagingSitePromote200),
) => {
  return http.post('*/v1/sites/:siteId/staging', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getStagingSitePromoteResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteStatusMockHandler = (
  overrideResponse?:
    | SiteStatus200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteStatus200> | SiteStatus200),
) => {
  return http.get('*/v1/sites/:siteId/status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteStatusResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteUsersMockHandler = (
  overrideResponse?:
    | SiteUsers200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteUsers200> | SiteUsers200),
) => {
  return http.get('*/v1/sites/:siteId/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteUsersResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesVersionMockHandler = (
  overrideResponse?:
    | SitesVersion200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesVersion200> | SitesVersion200),
) => {
  return http.get('*/v1/sites/:siteId/version', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesVersionResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteWpGenerateMockHandler = (
  overrideResponse?:
    | SiteWpGenerate200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SiteWpGenerate200> | SiteWpGenerate200),
) => {
  return http.post('*/v1/sites/:siteId/wp/generate', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteWpGenerateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteThemeInstallMockHandler = (
  overrideResponse?:
    | SiteThemeInstall200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SiteThemeInstall200> | SiteThemeInstall200),
) => {
  return http.post('*/v1/sites/:siteId/wp/themes', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteThemeInstallResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteAddonWpsolutionMockHandler = (
  overrideResponse?:
    | SiteAddonWpsolution200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SiteAddonWpsolution200> | SiteAddonWpsolution200),
) => {
  return http.post('*/v1/sites/:siteId/wpsolution', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteAddonWpsolutionResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserBillingAccountsMockHandler = (
  overrideResponse?:
    | UserBillingAccounts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserBillingAccounts200> | UserBillingAccounts200),
) => {
  return http.get('*/v1/user/billing-accounts', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserBillingAccountsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserDomainsMockHandler = (
  overrideResponse?:
    | UserDomains200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserDomains200> | UserDomains200),
) => {
  return http.get('*/v1/user/domains', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserDomainsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserHostingMockHandler = (
  overrideResponse?:
    | UserHosting200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserHosting200> | UserHosting200),
) => {
  return http.get('*/v1/user/hosting', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserHostingResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserHostingOverviewMockHandler = (
  overrideResponse?:
    | UserHostingOverview200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserHostingOverview200> | UserHostingOverview200),
) => {
  return http.get('*/v1/user/hosting/overview', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserHostingOverviewResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAllUserMonarxDetailsMockHandler = (
  overrideResponse?:
    | AllUserMonarxDetails200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AllUserMonarxDetails200> | AllUserMonarxDetails200),
) => {
  return http.get('*/v1/user/monarx/details', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAllUserMonarxDetailsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserOnboardingMockHandler = (
  overrideResponse?:
    | UserOnboarding200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserOnboarding200> | UserOnboarding200),
) => {
  return http.get('*/v1/user/onboarding', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserOnboardingResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserOnboardingStepsMockHandler = (
  overrideResponse?:
    | OnboardingGetStepsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<OnboardingGetStepsResponse> | OnboardingGetStepsResponse),
) => {
  return http.get('*/v1/user/onboarding/steps', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserOnboardingStepsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserOnboardingExploreAiAllAccessClickMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<void> | void),
) => {
  return http.post(
    '*/v1/user/onboarding/steps/explore-ai-all-access/click',
    async (info) => {
      await delay(0);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
  );
};

export const getUserOnboardingMeetWelcomeTeamClickMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<void> | void),
) => {
  return http.post(
    '*/v1/user/onboarding/steps/meet-welcome-team/click',
    async (info) => {
      await delay(0);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
  );
};

export const getUserOnboardingSignInAiDashboardClickMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<void> | void),
) => {
  return http.post(
    '*/v1/user/onboarding/steps/sign-in-ai-dashboard/click',
    async (info) => {
      await delay(0);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    },
  );
};

export const getUserOnboardingSurveyGetMockHandler = (
  overrideResponse?:
    | OnboardingSurveyResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<OnboardingSurveyResponse> | OnboardingSurveyResponse),
) => {
  return http.get('*/v1/user/onboarding/survey', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserOnboardingSurveyGetResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserOnboardingSurveyPostMockHandler = (
  overrideResponse?:
    | OnboardingSurveyResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<OnboardingSurveyResponse> | OnboardingSurveyResponse),
) => {
  return http.post('*/v1/user/onboarding/survey', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserOnboardingSurveyPostResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserPhoneSmsConsentMockHandler = (
  overrideResponse?:
    | UserPhoneSmsConsent200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserPhoneSmsConsent200> | UserPhoneSmsConsent200),
) => {
  return http.get('*/v1/user/phone-sms-consent', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserPhoneSmsConsentResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserPhoneSmsConsentUpdateMockHandler = (
  overrideResponse?:
    | UserPhoneSmsConsentUpdate200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<UserPhoneSmsConsentUpdate200>
        | UserPhoneSmsConsentUpdate200),
) => {
  return http.put('*/v1/user/phone-sms-consent', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserPhoneSmsConsentUpdateResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserProductsMockHandler = (
  overrideResponse?:
    | UserProducts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserProducts200> | UserProducts200),
) => {
  return http.get('*/v1/user/products', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserProductsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserProservicesMockHandler = (
  overrideResponse?:
    | UserProservices200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserProservices200> | UserProservices200),
) => {
  return http.get('*/v1/user/proservices', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserProservicesResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserServersMockHandler = (
  overrideResponse?:
    | UserServers200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserServers200> | UserServers200),
) => {
  return http.get('*/v1/user/servers', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserServersResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserSitesAiMockHandler = (
  overrideResponse?:
    | UserSitesAi200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserSitesAi200> | UserSitesAi200),
) => {
  return http.get('*/v1/user/sites/ai', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserSitesAiResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getUserSpamexpertsMockHandler = (
  overrideResponse?:
    | UserSpamexperts200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<UserSpamexperts200> | UserSpamexperts200),
) => {
  return http.get('*/v1/user/spamexperts', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUserSpamexpertsResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getWaldaiSsoMockHandler = (
  overrideResponse?:
    | WaldaiSso200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<WaldaiSso200> | WaldaiSso200),
) => {
  return http.get('*/v1/user/wald-ai/:prodInstId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getWaldaiSsoResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAccountHostingListV2MockHandler = (
  overrideResponse?:
    | AccountHostingListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AccountHostingListV2200> | AccountHostingListV2200),
) => {
  return http.get('*/v2/account/hosting', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAccountHostingListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getAddonsSitelockSsoV2MockHandler = (
  overrideResponse?:
    | AddonsSitelockSsoV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<AddonsSitelockSsoV2200> | AddonsSitelockSsoV2200),
) => {
  return http.get('*/v2/addons/sitelock/:addonId/sso', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getAddonsSitelockSsoV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupCreateV2MockHandler = (
  overrideResponse?:
    | BackupCreateV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupCreateV2200> | BackupCreateV2200),
) => {
  return http.post('*/v2/addons/:addonId/backup/create', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupCreateV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupDownloadV2MockHandler = (
  overrideResponse?:
    | BackupDownloadV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupDownloadV2200> | BackupDownloadV2200),
) => {
  return http.post('*/v2/addons/:addonId/backup/download', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupDownloadV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupListV2MockHandler = (
  overrideResponse?:
    | BackupListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupListV2200> | BackupListV2200),
) => {
  return http.get('*/v2/addons/:addonId/backup/list', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupRestoreV2MockHandler = (
  overrideResponse?:
    | BackupRestoreV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupRestoreV2200> | BackupRestoreV2200),
) => {
  return http.post('*/v2/addons/:addonId/backup/restore', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupRestoreV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupStatusV2MockHandler = (
  overrideResponse?:
    | BackupStatusV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupStatusV2200> | BackupStatusV2200),
) => {
  return http.get('*/v2/addons/:addonId/backup/status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupStatusV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingAdvancedServerV2MockHandler = (
  overrideResponse?:
    | HostingAdvancedServerV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingAdvancedServerV2200> | HostingAdvancedServerV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/advanced/server', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingAdvancedServerV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getDbListV2MockHandler = (
  overrideResponse?:
    | DbListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<DbListV2200> | DbListV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/db', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getDbListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingDomainsV2MockHandler = (
  overrideResponse?:
    | HostingDomainsV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingDomainsV2200> | HostingDomainsV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/domains', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingDomainsV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingDomainsUnassignV2MockHandler = (
  overrideResponse?:
    | HostingDomainsUnassignV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingDomainsUnassignV2200> | HostingDomainsUnassignV2200),
) => {
  return http.post('*/v2/hosting/:hostingId/domains/unassign', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingDomainsUnassignV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getListFilesV2MockHandler = (
  overrideResponse?:
    | ListFilesV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ListFilesV2200> | ListFilesV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/files', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getListFilesV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingNameserversV2MockHandler = (
  overrideResponse?:
    | HostingNameserversV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingNameserversV2200> | HostingNameserversV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/nameservers', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingNameserversV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingRedirectsV2MockHandler = (
  overrideResponse?:
    | HostingRedirectsV2200Item[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingRedirectsV2200Item[]> | HostingRedirectsV2200Item[]),
) => {
  return http.get('*/v2/hosting/:hostingId/redirects', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingRedirectsV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingSitesV2MockHandler = (
  overrideResponse?:
    | HostingSitesV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<HostingSitesV2200> | HostingSitesV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingSitesV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingSiteAddV2MockHandler = (
  overrideResponse?:
    | HostingSiteAddV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingSiteAddV2200> | HostingSiteAddV2200),
) => {
  return http.post('*/v2/hosting/:hostingId/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingSiteAddV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyImportV2MockHandler = (
  overrideResponse?:
    | SshKeyImportV2200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SshKeyImportV2200> | SshKeyImportV2200),
) => {
  return http.post('*/v2/hosting/:hostingId/ssh/import', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyImportV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyListV2MockHandler = (
  overrideResponse?:
    | SshKeyListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SshKeyListV2200> | SshKeyListV2200),
) => {
  return http.get('*/v2/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyV2MockHandler = (
  overrideResponse?:
    | SshKeyV2200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0],
      ) => Promise<SshKeyV2200> | SshKeyV2200),
) => {
  return http.delete('*/v2/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getPublicImagesV2MockHandler = (
  overrideResponse?:
    | PublicImagesV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<PublicImagesV2200> | PublicImagesV2200),
) => {
  return http.get('*/v2/public/images', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getPublicImagesV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesListV2MockHandler = (
  overrideResponse?:
    | SitesListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesListV2200> | SitesListV2200),
) => {
  return http.get('*/v2/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesInfoV2MockHandler = (
  overrideResponse?:
    | SiteInfoResponseModelV2
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteInfoResponseModelV2> | SiteInfoResponseModelV2),
) => {
  return http.get('*/v2/sites/:siteId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesInfoV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesDomainsV2MockHandler = (
  overrideResponse?:
    | SitesDomainsV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesDomainsV2200> | SitesDomainsV2200),
) => {
  return http.get('*/v2/sites/:siteId/domains', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesDomainsV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteMalwareStatusV2MockHandler = (
  overrideResponse?:
    | SiteMalwareStatusV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteMalwareStatusV2200> | SiteMalwareStatusV2200),
) => {
  return http.get('*/v2/sites/:siteId/malware-status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteMalwareStatusV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSecuritySitelockV2MockHandler = (
  overrideResponse?:
    | SitesSecuritySitelockV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSecuritySitelockV2200> | SitesSecuritySitelockV2200),
) => {
  return http.get('*/v2/sites/:siteId/security/sitelock', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSecuritySitelockV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesSshUserListV2MockHandler = (
  overrideResponse?:
    | SitesSshUserListV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesSshUserListV2200> | SitesSshUserListV2200),
) => {
  return http.get('*/v2/sites/:siteId/ssh-users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesSshUserListV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSiteUsersV2MockHandler = (
  overrideResponse?:
    | SiteUsersV2200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteUsersV2200> | SiteUsersV2200),
) => {
  return http.get('*/v2/sites/:siteId/users', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSiteUsersV2ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupCreateV3MockHandler = (
  overrideResponse?:
    | BackupCreateV3200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupCreateV3200> | BackupCreateV3200),
) => {
  return http.post('*/v3/addons/:addonId/backup/create', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupCreateV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupRestoreV3MockHandler = (
  overrideResponse?:
    | BackupRestoreV3200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<BackupRestoreV3200> | BackupRestoreV3200),
) => {
  return http.post('*/v3/addons/:addonId/backup/site_restore', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupRestoreV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getBackupListV3MockHandler = (
  overrideResponse?:
    | BackupListV3200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupListV3200> | BackupListV3200),
) => {
  return http.get(
    '*/v3/addons/:addonId/backup/sites/:siteId/list',
    async (info) => {
      await delay(0);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getBackupListV3ResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
  );
};

export const getBackupStatusV3MockHandler = (
  overrideResponse?:
    | BackupStatusV3200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<BackupStatusV3200> | BackupStatusV3200),
) => {
  return http.get('*/v3/addons/:addonId/backup/status', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getBackupStatusV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getHostingSiteAddV3MockHandler = (
  overrideResponse?:
    | HostingSiteAddV3200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<HostingSiteAddV3200> | HostingSiteAddV3200),
) => {
  return http.post('*/v3/hosting/:hostingId/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getHostingSiteAddV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyImportV3MockHandler = (
  overrideResponse?:
    | SshKeyImportV3200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<SshKeyImportV3200> | SshKeyImportV3200),
) => {
  return http.post('*/v3/hosting/:hostingId/ssh/import', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyImportV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyListV3MockHandler = (
  overrideResponse?:
    | SshKeyListV3200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SshKeyListV3200> | SshKeyListV3200),
) => {
  return http.get('*/v3/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyListV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesListV3MockHandler = (
  overrideResponse?:
    | SitesListV3200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SitesListV3200> | SitesListV3200),
) => {
  return http.get('*/v3/sites', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesListV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSitesInfoV3MockHandler = (
  overrideResponse?:
    | SiteInfoResponseModelV2
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SiteInfoResponseModelV2> | SiteInfoResponseModelV2),
) => {
  return http.get('*/v3/sites/:siteId', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSitesInfoV3ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};

export const getSshKeyListV4MockHandler = (
  overrideResponse?:
    | SshKeyListV4200
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<SshKeyListV4200> | SshKeyListV4200),
) => {
  return http.get('*/v4/hosting/:hostingId/ssh/keys', async (info) => {
    await delay(0);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getSshKeyListV4ResponseMock(),
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } },
    );
  });
};
export const getHostingUAPIMock = () => [
  getAccountEventListMockHandler(),
  getAccountFeaturesMockHandler(),
  getAccountHostingListMockHandler(),
  getAccountPublicKeysMockHandler(),
  getAccountPublicKeyCreateMockHandler(),
  getAccountPublicKeyMockHandler(),
  getAccountPublicKeyToggleMockHandler(),
  getAccountPublicKeyDeleteMockHandler(),
  getAccountAddonListMockHandler(),
  getCodeguardBackupListMockHandler(),
  getCodeguardBackupCreateMockHandler(),
  getCodeguardBackupDownloadMockHandler(),
  getCodeguardBackupRestoreMockHandler(),
  getCodeguardDatabaseListMockHandler(),
  getCodeguardDatabaseBackupListMockHandler(),
  getCodeguardDatabaseBackupCreateMockHandler(),
  getCodeguardDatabaseBackupRestoreMockHandler(),
  getCodeguardLoginLinkMockHandler(),
  getCodeguardPlanInfoMockHandler(),
  getCodeguardWebsiteListMockHandler(),
  getCodeguardWebsiteBackupListMockHandler(),
  getCodeguardWebsiteBackupCreateMockHandler(),
  getCodeguardWebsiteBackupRestoreMockHandler(),
  getAddonsSitelockSsoMockHandler(),
  getXcitiumBackupListMockHandler(),
  getXcitiumBackupCreateMockHandler(),
  getXcitiumBackupDownloadMockHandler(),
  getXcitiumBackupRestoreMockHandler(),
  getXcitiumPlanInfoMockHandler(),
  getXcitiumSsoMockHandler(),
  getBackupInitiateMockHandler(),
  getBackupStatusMockHandler(),
  getBackupListMockHandler(),
  getBackupMetaMockHandler(),
  getBackupCreateOndemandV1MockHandler(),
  getBackupCustomDeleteV1MockHandler(),
  getBackupSettingsMockHandler(),
  getBackupSettingsCreateMockHandler(),
  getBackupSettingsUpdateMockHandler(),
  getBackupPrefSetStatusMockHandler(),
  getBackupUsageMockHandler(),
  getAddonsCloudflareMockHandler(),
  getAddonsCloudflareExternalNsCheckMockHandler(),
  getAddonsInfoMockHandler(),
  getAddonsJetpackValidateMockHandler(),
  getAddonsLlmBalanceMockHandler(),
  getAddonsLlmKeysMockHandler(),
  getAddonsLlmKeysCreateMockHandler(),
  getAddonsLlmKeysDeleteMockHandler(),
  getMonarxAddonSealGenerationMockHandler(),
  getMonarxAddonReportUrlMockHandler(),
  getAddonsSpamexpertsDomainAssignMockHandler(),
  getAddonsSpamexpertsSsoMockHandler(),
  getAddonsSyncMockHandler(),
  getWebzaiSsoMockHandler(),
  getWeeblySsoMockHandler(),
  getAddonsWorkflowsMockHandler(),
  getAnnouncementsMockHandler(),
  getBullhornAnnouncementsMockHandler(),
  getDomainInfoMockHandler(),
  getDomainCertsMockHandler(),
  getDomainCertInstallMockHandler(),
  getDomainCertUpdateMockHandler(),
  getDomainCertUninstallMockHandler(),
  getDomainDnseditorMockHandler(),
  getDomainDnseditorListMockHandler(),
  getDomainDnseditorAddMockHandler(),
  getDomainDnseditorEditMockHandler(),
  getDomainDnszoneResetMockHandler(),
  getDomainEmailDeliverabilityMockHandler(),
  getDomainsEntriLastSuccessMockHandler(),
  getDomainsSetEntriUsedMockHandler(),
  getDomainsUnsetEntriUsedMockHandler(),
  getDomainHealthMockHandler(),
  getAccessLogsMockHandler(),
  getDomainResourceRecordsMockHandler(),
  getUpdateDomainResourceRecordsMockHandler(),
  getDomainUnassignMockHandler(),
  getDomainZoneeditorUrlMockHandler(),
  getEntriJwtMockHandler(),
  getHostingAccountMockHandler(),
  getActivityLogMockHandler(),
  getHostingAddonsMockHandler(),
  getHostingAdvancedConsoleMockHandler(),
  getHostingAdvancedDnsMockHandler(),
  getHostingAdvancedDnsUpdateMockHandler(),
  getHostingAdvancedDomainServicesCheckMockHandler(),
  getHostingAdvancedDomainServicesMockHandler(),
  getHostingAdvancedImagesMockHandler(),
  getHostingAdvancedServerMockHandler(),
  getHostingAdvancedServerStatusMockHandler(),
  getHostingAdvancedServerHealthcheckMockHandler(),
  getHostingAdvancedPasswordMockHandler(),
  getHostingAdvancedSsoWhmMockHandler(),
  getHostingAdvancedSystemConsoleMockHandler(),
  getHostingApplicationsListMockHandler(),
  getHostingApplicationGetMockHandler(),
  getHostingApplicationDeleteMockHandler(),
  getHostingApplicationConfigGetMockHandler(),
  getHostingApplicationConfigSetMockHandler(),
  getHostingApplicationConfigDeleteMockHandler(),
  getHostingApplicationDeploymentsListMockHandler(),
  getHostingApplicationRedeployMockHandler(),
  getHostingApplicationDeploymentGetMockHandler(),
  getHostingApplicationDeploymentLogsGetMockHandler(),
  getHostingApplicationDeploymentRollbackMockHandler(),
  getHostingApplicationHostnamesPutMockHandler(),
  getHostingBackupsMockHandler(),
  getHostingCapabilitiesMockHandler(),
  getListCronsMockHandler(),
  getAddCronMockHandler(),
  getUpdateCronMockHandler(),
  getCronMockHandler(),
  getCronLastRunMockHandler(),
  getDbAddMockHandler(),
  getDbMockHandler(),
  getHostingDbAuthorizedHostsMockHandler(),
  getHostingDbAuthorizedHostsAddMockHandler(),
  getHostingDbAuthorizedHostsUpdateMockHandler(),
  getHostingDbAuthorizedHostsDeleteMockHandler(),
  getDbCheckDatabaseMockHandler(),
  getRepairDatabaseMockHandler(),
  getDbUsageMockHandler(),
  getDbUserPasswordSetMockHandler(),
  getDbUserPrivsGetMockHandler(),
  getDbUserPrivsSetMockHandler(),
  getDbUserAddMockHandler(),
  getDbUserDeleteMockHandler(),
  getDbUserListMockHandler(),
  getDbUserRenameMockHandler(),
  getDbMultipleUserDatabaseMockHandler(),
  getDirectoryPrivacyMockHandler(),
  getAddPrivacyMockHandler(),
  getPrivacyMockHandler(),
  getEditPrivacyMockHandler(),
  getPrivacyUserMockHandler(),
  getHostingDomainAssignMockHandler(),
  getHostingDomainAvailabilityMockHandler(),
  getDomainsMockHandler(),
  getDomainDnsExportMockHandler(),
  getDomainDnsImportMockHandler(),
  getHostingDomainsLinkMockHandler(),
  getHostingDomainsUnassignMockHandler(),
  getHostingEcommerceInfoMockHandler(),
  getHostingEmailAddMockHandler(),
  getHostingEmailDeleteMockHandler(),
  getHostingEmailListMockHandler(),
  getHostingEmailUpdateMockHandler(),
  getHostingEmailAutoresponderInfoMockHandler(),
  getHostingEmailAutoresponderUpdateMockHandler(),
  getHostingEmailAutoresponderCreateMockHandler(),
  getHostingEmailAutoresponderDeleteMockHandler(),
  getHostingEmailAutoresponderListMockHandler(),
  getHostingEmailFiltersListMockHandler(),
  getHostingEmailFiltersAddMockHandler(),
  getHostingEmailFiltersUpdateMockHandler(),
  getHostingEmailFiltersDeleteMockHandler(),
  getHostingEmailForwardersListMockHandler(),
  getHostingEmailForwarderAddMockHandler(),
  getHostingEmailForwardDeleteMockHandler(),
  getHostingEmailKeysAddMockHandler(),
  getHostingEmailKeysListMockHandler(),
  getHostingEmailDomainRoutingMockHandler(),
  getHostingEmailDomainRoutingSetMockHandler(),
  getHostingEmailSettingsMockHandler(),
  getHostingEmailSpamCustomSettingsMockHandler(),
  getHostingEmailSpamCustomSettingsUpdateMockHandler(),
  getHostingEmailSpamEmptyMockHandler(),
  getHostingEmailSpamSettingsMockHandler(),
  getHostingEmailSpamSettingsUpdateMockHandler(),
  getEmailSsoMockHandler(),
  getHostingEmailTestSendMockHandler(),
  getHostingEmailFolderListMockHandler(),
  getHostingEmailSetupInfoMockHandler(),
  getHostingSendEmailSetupInfoMockHandler(),
  getHostingFixownershipMockHandler(),
  getHostingFtpListMockHandler(),
  getHostingFtpAddMockHandler(),
  getHostingFtpUpdateMockHandler(),
  getHostingFtpMockHandler(),
  getHostingRepoListMockHandler(),
  getHostingRepoSyncMockHandler(),
  getHostingRepoMockHandler(),
  getHostingRepoLogMockHandler(),
  getHotlinkconfigDetailsMockHandler(),
  getHotlinkconfigAddMockHandler(),
  getHotlinkconfigDeleteMockHandler(),
  getListIndexMockHandler(),
  getAddIndexMockHandler(),
  getIndexMockHandler(),
  getHostingInfoMockHandler(),
  getHostingInfoDiskUsageMockHandler(),
  getHostingLeadMockHandler(),
  getHostingLicenseInfoMockHandler(),
  getHostingMigrationStatusMockHandler(),
  getHostingMigrationsMockHandler(),
  getHostingMigrationsEventMockHandler(),
  getHostingMigrationInfoMockHandler(),
  getHostingMigrationSiteScanStatusMockHandler(),
  getHostingMonarxAddonsListMockHandler(),
  getHostingNameserversMockHandler(),
  getHostingOnboardingDataMockHandler(),
  getHostingOnboardingDataUpdateMockHandler(),
  getHostingPasswordUpdateMockHandler(),
  getPasswordGenerateMockHandler(),
  getPasswordScoreMockHandler(),
  getPhpErrorsMockHandler(),
  getProductLicenseDetailsMockHandler(),
  getHostingRedirectsMockHandler(),
  getHostingRedirectMockHandler(),
  getAddHostingRedirectsMockHandler(),
  getHostingResellerSsoWhmMockHandler(),
  getHostingServerHitsMockHandler(),
  getHostingShellToggleMockHandler(),
  getHostingShellInfoMockHandler(),
  getHostingSiteAddMockHandler(),
  getSitesBatchMockHandler(),
  getHostingSpamexpertsEligibleDomainsMockHandler(),
  getHostingSshInfoMockHandler(),
  getSshKeyFetchMockHandler(),
  getSshKeyImportMockHandler(),
  getSshKeyListMockHandler(),
  getSshKeyMockHandler(),
  getSshKeyGenerateMockHandler(),
  getHostingVpsSshKeySyncMockHandler(),
  getSsoMockHandler(),
  getHostingVisitorsMockHandler(),
  getPublicImagesMockHandler(),
  getPublicRegionsMockHandler(),
  getAccountPurchaseProductsMockHandler(),
  getAccountPurchaseHostingMockHandler(),
  getAccountPurchaseOrderMockHandler(),
  getSitesInfoMockHandler(),
  getSiteUpdateMockHandler(),
  getSiteMockHandler(),
  getSitesAtomicMetricsMockHandler(),
  getSitesAutoupdatesInfoMockHandler(),
  getSitesAutoupdatesUpdateMockHandler(),
  getSitesBackupsMockHandler(),
  getSitesHasBackupsMockHandler(),
  getSitesBackupsCodeguardMockHandler(),
  getSitesBackupsDetailsMockHandler(),
  getJetpackBackupStatusMockHandler(),
  getBackupsJetpackBackupMockHandler(),
  getSitesBackupsXcitiumMockHandler(),
  getSiteAddonCloudflareMockHandler(),
  getSitesDatabaseInfoMockHandler(),
  getSitesDatabasePasswordsyncMockHandler(),
  getSitesDnsMockHandler(),
  getSitesDomainMockHandler(),
  getSitesDomainUrlMockHandler(),
  getSitesDomainsCreateMockHandler(),
  getErrorPagesFetchMockHandler(),
  getErrorPagesAddMockHandler(),
  getErrorPagesDeleteMockHandler(),
  getSiteIpaddressListMockHandler(),
  getSiteIpaddressMockHandler(),
  getAddSiteIpaddressMockHandler(),
  getSitesJetpackPurchaseMockHandler(),
  getSitesAccessLogsMockHandler(),
  getSitesAccessLogsDownloadMockHandler(),
  getSitesErrorLogsMockHandler(),
  getSitesErrorLogsDownloadMockHandler(),
  getSiteMalwareStatusMockHandler(),
  getSitesMetricsDimensionAveragedMockHandler(),
  getSitesMetricDimensionsMockHandler(),
  getSitesOnboardingStepsMockHandler(),
  getSitePendingDomainDeleteMockHandler(),
  getSitesPerformanceCachepurgeMockHandler(),
  getSitesPerformanceEdgecacheMockHandler(),
  getSitesPerformanceEnduranceCacheLevelStatusMockHandler(),
  getSitesPerformanceEnduranceCacheLevelMockHandler(),
  getSitesPerformanceEndurancePageCacheMockHandler(),
  getSitesPerformanceRedisToggleMockHandler(),
  getSitesPerformanceRedisStatusMockHandler(),
  getSitesPerformanceRedisUninstallMockHandler(),
  getSitesPerformanceRedisPurgeMockHandler(),
  getSitesPerformanceScansListMockHandler(),
  getSitesPerformanceScansMockHandler(),
  getSitesPerformanceScansAddMockHandler(),
  getCreatePhpInfoMockHandler(),
  getSitePluginsMockHandler(),
  getSitePluginUpdateMockHandler(),
  getSitePluginInstallMockHandler(),
  getSitePluginsAutoupdateMockHandler(),
  getSitePluginInstallerMockHandler(),
  getSitePluginsToggleMockHandler(),
  getSitePluginsUpdateMockHandler(),
  getSiteQualityMetricsMockHandler(),
  getResetSiteMockHandler(),
  getSitesSecurityBundleMockHandler(),
  getSitesSecurityCheckCoreMockHandler(),
  getSitesSecurityResetCoreFilesMockHandler(),
  getSitesSecurityHttpsRedirectionStatusMockHandler(),
  getSitesSecurityHttpsEnableDisableSslMockHandler(),
  getSitesSecuritySitelockMockHandler(),
  getSitesSecuritySslAcmeMockHandler(),
  getSitesSecuritySslStatusMockHandler(),
  getSitesSettingsComingSoonMockHandler(),
  getSitesSettingsComingSoonToggleMockHandler(),
  getSitesSettingsDebugMockHandler(),
  getSitesSettingsDebugToggleMockHandler(),
  getSitesSettingsPhpVersionUpdateMockHandler(),
  getSitesSettingsPhpVersionInheritanceMockHandler(),
  getSitesSettingsPhpVersionsMockHandler(),
  getSitesSshUserListMockHandler(),
  getSitesSshUserCreateMockHandler(),
  getSitesSshUserDeleteMockHandler(),
  getSitesSshUserUpdateMockHandler(),
  getSitesSslMockHandler(),
  getSitesSsoMockHandler(),
  getStagingSitePromoteMockHandler(),
  getSiteStatusMockHandler(),
  getSiteUsersMockHandler(),
  getSitesVersionMockHandler(),
  getSiteWpGenerateMockHandler(),
  getSiteThemeInstallMockHandler(),
  getSiteAddonWpsolutionMockHandler(),
  getUserBillingAccountsMockHandler(),
  getUserDomainsMockHandler(),
  getUserHostingMockHandler(),
  getUserHostingOverviewMockHandler(),
  getAllUserMonarxDetailsMockHandler(),
  getUserOnboardingMockHandler(),
  getUserOnboardingStepsMockHandler(),
  getUserOnboardingExploreAiAllAccessClickMockHandler(),
  getUserOnboardingMeetWelcomeTeamClickMockHandler(),
  getUserOnboardingSignInAiDashboardClickMockHandler(),
  getUserOnboardingSurveyGetMockHandler(),
  getUserOnboardingSurveyPostMockHandler(),
  getUserPhoneSmsConsentMockHandler(),
  getUserPhoneSmsConsentUpdateMockHandler(),
  getUserProductsMockHandler(),
  getUserProservicesMockHandler(),
  getUserServersMockHandler(),
  getUserSitesAiMockHandler(),
  getUserSpamexpertsMockHandler(),
  getWaldaiSsoMockHandler(),
  getAccountHostingListV2MockHandler(),
  getAddonsSitelockSsoV2MockHandler(),
  getBackupCreateV2MockHandler(),
  getBackupDownloadV2MockHandler(),
  getBackupListV2MockHandler(),
  getBackupRestoreV2MockHandler(),
  getBackupStatusV2MockHandler(),
  getHostingAdvancedServerV2MockHandler(),
  getDbListV2MockHandler(),
  getHostingDomainsV2MockHandler(),
  getHostingDomainsUnassignV2MockHandler(),
  getListFilesV2MockHandler(),
  getHostingNameserversV2MockHandler(),
  getHostingRedirectsV2MockHandler(),
  getHostingSitesV2MockHandler(),
  getHostingSiteAddV2MockHandler(),
  getSshKeyImportV2MockHandler(),
  getSshKeyListV2MockHandler(),
  getSshKeyV2MockHandler(),
  getPublicImagesV2MockHandler(),
  getSitesListV2MockHandler(),
  getSitesInfoV2MockHandler(),
  getSitesDomainsV2MockHandler(),
  getSiteMalwareStatusV2MockHandler(),
  getSitesSecuritySitelockV2MockHandler(),
  getSitesSshUserListV2MockHandler(),
  getSiteUsersV2MockHandler(),
  getBackupCreateV3MockHandler(),
  getBackupRestoreV3MockHandler(),
  getBackupListV3MockHandler(),
  getBackupStatusV3MockHandler(),
  getHostingSiteAddV3MockHandler(),
  getSshKeyImportV3MockHandler(),
  getSshKeyListV3MockHandler(),
  getSitesListV3MockHandler(),
  getSitesInfoV3MockHandler(),
  getSshKeyListV4MockHandler(),
];
